export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DataInconsistency: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: string; output: string; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  GraphQLBigInt: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  Json: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JsonObject: { input: any; output: any; }
  /** Represents NULL values */
  Void: { input: any; output: any; }
};

export enum AccountType {
  EnterpriseCloud = 'EnterpriseCloud',
  Legacy = 'Legacy',
  SelfServiceFree = 'SelfServiceFree',
  SelfServicePaid = 'SelfServicePaid',
  SelfServiceTrial = 'SelfServiceTrial'
}

export type ArStatistics = {
  __typename: 'ArStatistics';
  configString: Scalars['String']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  sceneRevision?: Maybe<SceneRevision>;
  templateRevision?: Maybe<TemplateRevision>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type ArStatisticsCreateDataInput = {
  configString: Scalars['String']['input'];
  created: Scalars['DateTime']['input'];
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type ArStatisticsFilterInput = {
  configString?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdInFilter>;
  sceneRevisionId?: InputMaybe<IdInFilter>;
  sceneRevisionLegacyId?: InputMaybe<IntInFilter>;
  templateRevisionId?: InputMaybe<IdInFilter>;
  templateRevisionLegacyId?: InputMaybe<IntInFilter>;
};

export enum ArStatisticsOrderByCriteria {
  Id = 'id'
}

export type ArStatisticsOrderByInput = {
  direction: SortOrder;
  key: ArStatisticsOrderByCriteria;
};

export type Asset = {
  __typename: 'Asset';
  articleId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  currentUserAssignment?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  galleryImage?: Maybe<DataObject>;
  id: Scalars['ID']['output'];
  jobAssignments: Array<JobAssignment>;
  jobAssignmentsCount: Scalars['Int']['output'];
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  materialAssignments: Array<MaterialAssignment>;
  materialAssignmentsCount: Scalars['Int']['output'];
  materials: Array<Material>;
  model?: Maybe<Model>;
  name?: Maybe<Scalars['String']['output']>;
  nextActor: NextActor;
  organization: Organization;
  pictureAssignments: Array<PictureAssetAssignment>;
  /** Pictures assigned to this asset via a PictureAssetAssignment. This is a convenience field that is equivalent to `pictureAssignments.picture`. */
  pictures: Array<Picture>;
  picturesCount: Scalars['Int']['output'];
  priorityOrder?: Maybe<Scalars['GraphQLBigInt']['output']>;
  state: AssetState;
  taskInfos: TaskInfos;
  template: Template;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  userAssignments: Array<UserAssignment>;
  userAssignmentsCount: Scalars['Int']['output'];
};


export type AssetDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type AssetJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};


export type AssetMaterialsArgs = {
  where?: InputMaybe<MaterialFilterInput>;
};


export type AssetUserAssignmentsArgs = {
  filter?: InputMaybe<UserAssignmentFilterInput>;
};

export type AssetCreateInput = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  dataObjects?: InputMaybe<Array<DataObjectAssignmentCreateWithoutObjectInput>>;
  modelId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nextActor: NextActor;
  organizationId: Scalars['ID']['input'];
  state: AssetState;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type AssetFilterInput = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<StringFilterInput>;
  hasAssignedUser?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdInFilter>;
  legacyId?: InputMaybe<IntInFilter>;
  materialId?: InputMaybe<IdInFilter>;
  materialLegacyId?: InputMaybe<IntInFilter>;
  modelId?: InputMaybe<IdInFilter>;
  modelLegacyId?: InputMaybe<IntInFilter>;
  name?: InputMaybe<StringFilterInput>;
  nextActor?: InputMaybe<Array<NextActor>>;
  organizationId?: InputMaybe<IdInFilter>;
  organizationLegacyId?: InputMaybe<IntInFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<AssetState>>;
  userId?: InputMaybe<IdInFilter>;
};

export type AssetHistory = {
  __typename: 'AssetHistory';
  articleId?: Maybe<Scalars['String']['output']>;
  asset?: Maybe<Asset>;
  comment?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<User>;
  historyChangeReason?: Maybe<Scalars['String']['output']>;
  historyDate?: Maybe<Scalars['DateTime']['output']>;
  historyType: HistoryType;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nextActor: NextActor;
  state: AssetState;
};

export type AssetHistoryFilterInput = {
  articleId?: InputMaybe<StringFilterInput>;
  assetId?: InputMaybe<IdInFilter>;
  comment?: InputMaybe<StringFilterInput>;
  historyDate?: InputMaybe<DateTimeFilterInput>;
  modelId?: InputMaybe<IdInFilter>;
  name?: InputMaybe<StringFilterInput>;
  organizationId?: InputMaybe<IdInFilter>;
  state?: InputMaybe<Array<AssetState>>;
  templateId?: InputMaybe<IdInFilter>;
};

export enum AssetHistoryOrderByCriteria {
  HistoryDate = 'history_date',
  Id = 'id'
}

export type AssetHistoryOrderByInput = {
  direction: SortOrder;
  key: AssetHistoryOrderByCriteria;
};

export enum AssetOrderByCriteria {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  Priority = 'priority'
}

export type AssetOrderByInput = {
  direction: SortOrder;
  key: AssetOrderByCriteria;
};

export enum AssetState {
  Completed = 'Completed',
  InfoReview = 'InfoReview',
  Review = 'Review',
  Shading = 'Shading'
}

export type AssetUpdateInput = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nextActor: NextActor;
  organizationId: Scalars['ID']['input'];
  state: AssetState;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type BlenderAddonDownload = {
  __typename: 'BlenderAddonDownload';
  blenderVersionMax?: Maybe<Scalars['String']['output']>;
  blenderVersionMin?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export enum CascadeAdvanceReason {
  Misconfigured = 'Misconfigured',
  NoCapacity = 'NoCapacity',
  PreemptionBlacklist = 'PreemptionBlacklist',
  PreviousFailure = 'PreviousFailure'
}

export enum CascadeStepEventCategory {
  Active = 'Active',
  Error = 'Error',
  Neutral = 'Neutral',
  Success = 'Success',
  Warning = 'Warning'
}

export enum CascadeStepStatus {
  Active = 'Active',
  Completed = 'Completed',
  Failed = 'Failed',
  Pending = 'Pending',
  Skipped = 'Skipped'
}

/** Result of completing onboarding */
export type CompleteOnboardingResult = {
  __typename: 'CompleteOnboardingResult';
  success: Scalars['Boolean']['output'];
  user: SignupUserInfo;
};

export type ConfiguraMaterialDatabaseBinding = {
  __typename: 'ConfiguraMaterialDatabaseBinding';
  id: Scalars['ID']['output'];
  lastPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  lastPublishedRevision?: Maybe<MaterialRevision>;
  latestJobTask?: Maybe<Job>;
  material: Material;
  textileId: Scalars['String']['output'];
  textileVersion?: Maybe<Scalars['Int']['output']>;
};

export type ConfiguraMaterialDatabaseBindingFilterInput = {
  id?: InputMaybe<IdInFilter>;
  materialId?: InputMaybe<IdInFilter>;
  organizationId?: InputMaybe<IdInFilter>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  textileId?: InputMaybe<StringInFilter>;
};

export enum ConfiguraMaterialDatabaseBindingOrderByCriteria {
  CreatedAt = 'createdAt',
  LastPublishedAt = 'lastPublishedAt',
  TextileId = 'textileId',
  TextileVersion = 'textileVersion',
  UpdatedAt = 'updatedAt'
}

export type ConfiguraMaterialDatabaseBindingOrderByInput = {
  direction: SortOrder;
  key: ConfiguraMaterialDatabaseBindingOrderByCriteria;
};

export type ConfiguraMaterialDatabaseProfile = {
  __typename: 'ConfiguraMaterialDatabaseProfile';
  /** Whether a first bind may create the Material Database entry when no textile carries the material's article ID. False refuses the publish instead — the entries are permanent, the Material Database has no delete. */
  allowTextileCreation: Scalars['Boolean']['output'];
  apiKeyEncrypted: Scalars['String']['output'];
  /** The organization's brand in its Configura company. Sent on textile creation and matched exactly on bind; null sends and checks nothing. */
  brand?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  organization: Organization;
  thumbnailMaterialOutputType: MaterialOutputType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

/** Per-material outcome of a batch publish. Exactly one of jobId, skippedMessage and refusalMessage is set. */
export type ConfiguraMaterialDatabasePublishBatchEntry = {
  __typename: 'ConfiguraMaterialDatabasePublishBatchEntry';
  /** True when this publish created the Configura textile during its first bind, so a batch summary can count the entries it minted */
  createdTextile: Scalars['Boolean']['output'];
  /** The publish job submitted for this material */
  jobId?: Maybe<Scalars['ID']['output']>;
  materialId: Scalars['ID']['output'];
  /** Set when this material could not be published; the message says what to fix */
  refusalMessage?: Maybe<Scalars['String']['output']>;
  /** Set when nothing needed doing: the Material Database already holds the latest revision, or a publish is already in flight */
  skippedMessage?: Maybe<Scalars['String']['output']>;
};

/** Outcome of a publish trigger: the binding — whose latestJobTask is the job just created — and whether the Configura textile was created by this publish's first bind. */
export type ConfiguraMaterialDatabasePublishResult = {
  __typename: 'ConfiguraMaterialDatabasePublishResult';
  binding: ConfiguraMaterialDatabaseBinding;
  /** True when this publish created the Configura textile during its first bind */
  createdTextile: Scalars['Boolean']['output'];
};

export type ConfiguratorArAssignment = {
  __typename: 'ConfiguratorArAssignment';
  dataObject: ConfiguratorArAssignmentDataObject;
  id: Scalars['String']['output'];
};

export type ConfiguratorArAssignmentDataObject = {
  __typename: 'ConfiguratorArAssignmentDataObject';
  id: Scalars['String']['output'];
  related: Array<ConfiguratorArRelatedDataObject>;
};

export type ConfiguratorArData = {
  __typename: 'ConfiguratorArData';
  gltfDataObject?: Maybe<ConfiguratorArDataObject>;
  organizationId: Scalars['String']['output'];
  organizationLegacyId: Scalars['Int']['output'];
  templateId: Scalars['String']['output'];
  templateLegacyId: Scalars['Int']['output'];
  usdzDataObject?: Maybe<ConfiguratorArDataObject>;
};

export type ConfiguratorArDataObject = {
  __typename: 'ConfiguratorArDataObject';
  downloadUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mediaType?: Maybe<Scalars['String']['output']>;
  objectName: Scalars['String']['output'];
};

export type ConfiguratorArJob = {
  __typename: 'ConfiguratorArJob';
  id: Scalars['String']['output'];
};

export type ConfiguratorArJobTask = {
  __typename: 'ConfiguratorArJobTask';
  id: Scalars['String']['output'];
  output?: Maybe<Scalars['Json']['output']>;
  state: JobState;
};

export type ConfiguratorArRelatedDataObject = {
  __typename: 'ConfiguratorArRelatedDataObject';
  id: Scalars['String']['output'];
};

export type ConfiguratorDataObject = {
  __typename: 'ConfiguratorDataObject';
  downloadUrl: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imageColorSpace?: Maybe<ImageColorSpace>;
  imageTilesDescriptor?: Maybe<ConfiguratorImageTilesDescriptor>;
  legacyId: Scalars['Int']['output'];
  mediaType?: Maybe<Scalars['String']['output']>;
  originalFileName: Scalars['String']['output'];
  related: Array<ConfiguratorRelatedDataObject>;
  size?: Maybe<Scalars['GraphQLBigInt']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** Image tiles descriptor for a configurator data object */
export type ConfiguratorImageTilesDescriptor = {
  __typename: 'ConfiguratorImageTilesDescriptor';
  imageHeight: Scalars['Int']['output'];
  imageWidth: Scalars['Int']['output'];
  tileBucketName: Scalars['String']['output'];
  tileChannels?: Maybe<Scalars['Int']['output']>;
  tileColorSpace: ImageColorSpace;
  tileDownloadUrlPrefix: Scalars['String']['output'];
  tileHeight: Scalars['Int']['output'];
  tileMargin: Scalars['Int']['output'];
  tileMediaType: Scalars['String']['output'];
  tileMipLevels: Scalars['Int']['output'];
  tileStorageFolderName: Scalars['String']['output'];
  tileWidth: Scalars['Int']['output'];
};

export type ConfiguratorMaterial = {
  __typename: 'ConfiguratorMaterial';
  articleId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latestCyclesRevision?: Maybe<ConfiguratorMaterialRevision>;
  legacyId: Scalars['Int']['output'];
  /** Article IDs of all materials in the same MaterialRange (by tag assignment) and organization, ordered by articleId */
  rangeArticleIds: Array<Scalars['String']['output']>;
  /** Names of all tags assigned to this material */
  tagNames: Array<Scalars['String']['output']>;
  /** Dimensions from the material's texture group (latest texture set revision) */
  textureGroupDimensions?: Maybe<ConfiguratorTextureGroupDimensions>;
};

export type ConfiguratorMaterialRevision = {
  __typename: 'ConfiguratorMaterialRevision';
  graphNode: Scalars['JsonObject']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  material: ConfiguratorMaterial;
};

export type ConfiguratorPdfData = {
  __typename: 'ConfiguratorPdfData';
  fontBoldUrl?: Maybe<Scalars['String']['output']>;
  fontUrl?: Maybe<Scalars['String']['output']>;
  pdfTemplateUrl?: Maybe<Scalars['String']['output']>;
  styleSettings?: Maybe<PdfStyleSettings>;
};

/** Related data object for a configurator data object */
export type ConfiguratorRelatedDataObject = {
  __typename: 'ConfiguratorRelatedDataObject';
  downloadUrl: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  imageColorSpace?: Maybe<ImageColorSpace>;
  legacyId: Scalars['Int']['output'];
  mediaType?: Maybe<Scalars['String']['output']>;
  originalFileName: Scalars['String']['output'];
  size?: Maybe<Scalars['GraphQLBigInt']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ConfiguratorTemplate = {
  __typename: 'ConfiguratorTemplate';
  articleId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latestRevision?: Maybe<ConfiguratorTemplateRevision>;
  legacyId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  organizationLegacyId: Scalars['Int']['output'];
  pdfData: ConfiguratorPdfData;
  revision?: Maybe<ConfiguratorTemplateRevision>;
  /** Names of all tags assigned to this template */
  tagNames: Array<Scalars['String']['output']>;
};


export type ConfiguratorTemplateRevisionArgs = {
  legacyId: Scalars['Int']['input'];
};

export type ConfiguratorTemplateRevision = {
  __typename: 'ConfiguratorTemplateRevision';
  graph?: Maybe<Scalars['Json']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
};

/** Dimensions from the latest TextureSetRevision of a material's texture group */
export type ConfiguratorTextureGroupDimensions = {
  __typename: 'ConfiguratorTextureGroupDimensions';
  height?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type ConfiguratorTextureRevision = {
  __typename: 'ConfiguratorTextureRevision';
  dataObject: ConfiguratorTextureRevisionDataObject;
  displacement?: Maybe<Scalars['Float']['output']>;
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  legacyId: Scalars['Int']['output'];
  texture?: Maybe<ConfiguratorTextureRevisionTexture>;
  width: Scalars['Float']['output'];
};

/** Data object reference for a configurator texture revision */
export type ConfiguratorTextureRevisionDataObject = {
  __typename: 'ConfiguratorTextureRevisionDataObject';
  id: Scalars['String']['output'];
  legacyId: Scalars['Int']['output'];
};

/** Texture reference for a configurator texture revision */
export type ConfiguratorTextureRevisionTexture = {
  __typename: 'ConfiguratorTextureRevisionTexture';
  type: TextureType;
};

export type ConfiguratorTextureSetRevision = {
  __typename: 'ConfiguratorTextureSetRevision';
  displacement?: Maybe<Scalars['Float']['output']>;
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  mapAssignments: Array<ConfiguratorTextureSetRevisionMapAssignment>;
  width: Scalars['Float']['output'];
};

/** Data object reference for a configurator texture set revision map assignment */
export type ConfiguratorTextureSetRevisionDataObject = {
  __typename: 'ConfiguratorTextureSetRevisionDataObject';
  id: Scalars['String']['output'];
  legacyId: Scalars['Int']['output'];
};

export type ConfiguratorTextureSetRevisionMapAssignment = {
  __typename: 'ConfiguratorTextureSetRevisionMapAssignment';
  dataObject: ConfiguratorTextureSetRevisionDataObject;
  textureType: TextureType;
};

export enum ContentTypeModel {
  Asset = 'Asset',
  AssetHistory = 'AssetHistory',
  DataObject = 'DataObject',
  DataObjectAssignment = 'DataObjectAssignment',
  Hdri = 'Hdri',
  IdFromCatalog = 'IdFromCatalog',
  IdFromCatalogToPriceGraph = 'IdFromCatalogToPriceGraph',
  Job = 'Job',
  JobFarmGroup = 'JobFarmGroup',
  JobFarmInstance = 'JobFarmInstance',
  JobTask = 'JobTask',
  JsonFile = 'JsonFile',
  Material = 'Material',
  MaterialAssignment = 'MaterialAssignment',
  MaterialAssignmentHistory = 'MaterialAssignmentHistory',
  MaterialConnection = 'MaterialConnection',
  MaterialHistory = 'MaterialHistory',
  MaterialNode = 'MaterialNode',
  MaterialReference = 'MaterialReference',
  MaterialRevision = 'MaterialRevision',
  Model = 'Model',
  ModelHistory = 'ModelHistory',
  Organization = 'Organization',
  Picture = 'Picture',
  PictureAssetAssignmentHistory = 'PictureAssetAssignmentHistory',
  PictureHistory = 'PictureHistory',
  PictureRevision = 'PictureRevision',
  ProductionStatistics = 'ProductionStatistics',
  Project = 'Project',
  RenderJob = 'RenderJob',
  ScanJob = 'ScanJob',
  ScanSubJob = 'ScanSubJob',
  Scene = 'Scene',
  SceneRevision = 'SceneRevision',
  Set = 'Set',
  StorageDeleteTask = 'StorageDeleteTask',
  Tag = 'Tag',
  TagAssignment = 'TagAssignment',
  Task = 'Task',
  TaskComment = 'TaskComment',
  TaskPin = 'TaskPin',
  Template = 'Template',
  TemplateRevision = 'TemplateRevision',
  Texture = 'Texture',
  TextureGroup = 'TextureGroup',
  TextureRevision = 'TextureRevision',
  TextureSet = 'TextureSet',
  TextureSetRevision = 'TextureSetRevision',
  User = 'User',
  UserAssignment = 'UserAssignment',
  UserAssignmentHistory = 'UserAssignmentHistory'
}

export type CreateDataObjectAssignmentInlineInput = {
  assignmentKey?: InputMaybe<Scalars['String']['input']>;
  assignmentType: DataObjectAssignmentType;
  dataObject?: InputMaybe<CreateDataObjectInlineInput>;
  dataObjectId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateDataObjectInlineInput = {
  bucketName?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  imageColorProfile?: InputMaybe<Scalars['String']['input']>;
  imageColorSpace?: InputMaybe<ImageColorSpace>;
  imageDataType?: InputMaybe<ImageDataType>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  objectName?: InputMaybe<Scalars['String']['input']>;
  originalFileName: Scalars['String']['input'];
  relatedToId?: InputMaybe<Scalars['ID']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  state: DataObjectState;
  type?: InputMaybe<DataObjectType>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export enum Currency {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Bov = 'BOV',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Che = 'CHE',
  Chf = 'CHF',
  Chw = 'CHW',
  Clf = 'CLF',
  Clp = 'CLP',
  Cnh = 'CNH',
  Cny = 'CNY',
  Cop = 'COP',
  Cou = 'COU',
  Crc = 'CRC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mru = 'MRU',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Mxv = 'MXV',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sle = 'SLE',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Stn = 'STN',
  Svc = 'SVC',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Usn = 'USN',
  Uyi = 'UYI',
  Uyu = 'UYU',
  Uyw = 'UYW',
  Uzs = 'UZS',
  Ved = 'VED',
  Ves = 'VES',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xag = 'XAG',
  Xau = 'XAU',
  Xba = 'XBA',
  Xbb = 'XBB',
  Xbc = 'XBC',
  Xbd = 'XBD',
  Xcd = 'XCD',
  Xdr = 'XDR',
  Xof = 'XOF',
  Xpd = 'XPD',
  Xpf = 'XPF',
  Xpt = 'XPT',
  Xsu = 'XSU',
  Xts = 'XTS',
  Xua = 'XUA',
  Xxx = 'XXX',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmw = 'ZMW',
  Zwg = 'ZWG'
}

export type DataObject = {
  __typename: 'DataObject';
  assignments: Array<DataObjectAssignment>;
  assignmentsCount: Scalars['Int']['output'];
  bucketName: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  downloadUrl: Scalars['String']['output'];
  hdris: Array<Hdri>;
  hdrisCount: Scalars['Int']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imageChannels?: Maybe<Scalars['Int']['output']>;
  imageColorProfile?: Maybe<Scalars['String']['output']>;
  /** The image's color space. Note that this does not match the color space reported by the OS or libraries like sharp. For example, rendered EXR files always have ImageColorSpace.Linear while sharp reports 'scrgb' and Mac OS 'RGB' */
  imageColorSpace?: Maybe<ImageColorSpace>;
  imageDataType?: Maybe<ImageDataType>;
  imageTilesDescriptor?: Maybe<ImageTilesDescriptor>;
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  materialRevisions: Array<MaterialRevision>;
  materialRevisionsCount: Scalars['Int']['output'];
  mediaType?: Maybe<Scalars['String']['output']>;
  metadataProcessingJob?: Maybe<Job>;
  objectName: Scalars['String']['output'];
  organization: Organization;
  originalFileName: Scalars['String']['output'];
  processedByVersion?: Maybe<Scalars['String']['output']>;
  related: Array<DataObject>;
  relatedCount: Scalars['Int']['output'];
  relatedTo?: Maybe<DataObject>;
  signedUploadUrl: Scalars['String']['output'];
  size?: Maybe<Scalars['GraphQLBigInt']['output']>;
  state: DataObjectState;
  textureRevisions: Array<TextureRevision>;
  textureRevisionsCount: Scalars['Int']['output'];
  textureSetRevisionMapAssignments: Array<TextureSetRevisionMapAssignment>;
  textureSetRevisionMapAssignmentsCount: Scalars['Int']['output'];
  textureSetRevisionSourceDataObjectReferences: Array<TextureSetRevisionSourceDataObjectReference>;
  textureSetRevisionSourceDataObjectReferencesCount: Scalars['Int']['output'];
  thumbnail?: Maybe<DataObject>;
  thumbnailAvailable: Scalars['Boolean']['output'];
  thumbnailProcessingJob?: Maybe<Job>;
  type?: Maybe<DataObjectType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  width?: Maybe<Scalars['Int']['output']>;
};


export type DataObjectDownloadUrlArgs = {
  fileType?: InputMaybe<DownloadFileType>;
  resolution?: InputMaybe<DownloadResolution>;
};


export type DataObjectSignedUploadUrlArgs = {
  allowCache?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DataObjectThumbnailArgs = {
  fileType?: InputMaybe<DownloadFileType>;
  resolution?: InputMaybe<DownloadResolution>;
};

export type DataObjectAssignment = {
  __typename: 'DataObjectAssignment';
  assignedTo?: Maybe<DataObjectAssignmentSubject>;
  assignmentKey?: Maybe<Scalars['String']['output']>;
  assignmentType: DataObjectAssignmentType;
  contentTypeModel: ContentTypeModel;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  dataObject: DataObject;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  objectId: Scalars['String']['output'];
  objectLegacyId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type DataObjectAssignmentCreateWithoutObjectInput = {
  assignmentKey: Scalars['String']['input'];
  assignmentType: DataObjectAssignmentType;
  dataObject?: InputMaybe<DataObjectCreateInput>;
  dataObjectId?: InputMaybe<Scalars['String']['input']>;
  dataObjectType?: InputMaybe<Array<DataObjectType>>;
};

export type DataObjectAssignmentFilterInput = {
  assignmentKey?: InputMaybe<StringFilterInput>;
  assignmentType?: InputMaybe<Array<DataObjectAssignmentType>>;
  contentTypeModel?: InputMaybe<ContentTypeModel>;
  dataObjectId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  objectId?: InputMaybe<Scalars['ID']['input']>;
  objectLegacyId?: InputMaybe<Scalars['Int']['input']>;
};

export enum DataObjectAssignmentOrderByCriteria {
  AssignmentKey = 'assignmentKey',
  AssignmentType = 'assignmentType',
  Id = 'id'
}

export type DataObjectAssignmentOrderByInput = {
  direction: SortOrder;
  key: DataObjectAssignmentOrderByCriteria;
};

export type DataObjectAssignmentSubject = Asset | Hdri | JobTask | JsonFile | Material | MaterialRevision | Model | Organization | Picture | PictureRevision | Project | ScanJob | ScanSubJob | Scene | SceneRevision | Set | Tag | Template | TemplateRevision | Texture | TextureGroup | TextureRevision | TextureSet | User;

export enum DataObjectAssignmentType {
  Attachment = 'Attachment',
  BatchExport = 'BatchExport',
  CachedTemplateGltf = 'CachedTemplateGltf',
  CachedTemplateUsdz = 'CachedTemplateUsdz',
  CryptoMatte01 = 'CryptoMatte01',
  CryptoMatte02 = 'CryptoMatte02',
  CryptoMatte03 = 'CryptoMatte03',
  CustomerLogo = 'CustomerLogo',
  DrawingData = 'DrawingData',
  Font = 'Font',
  FontBold = 'FontBold',
  GalleryImage = 'GalleryImage',
  GalleryImageMain = 'GalleryImageMain',
  Icon = 'Icon',
  JobTaskData = 'JobTaskData',
  JobTaskInternalData = 'JobTaskInternalData',
  MaterialCetSimple = 'MaterialCetSimple',
  MaterialFabricOverviewRender = 'MaterialFabricOverviewRender',
  MaterialMapsExport = 'MaterialMapsExport',
  MaterialThumbnail_7x7Inches = 'MaterialThumbnail_7x7Inches',
  MaterialThumbnail_8x8Inches = 'MaterialThumbnail_8x8Inches',
  MaterialThumbnail_9x9Inches = 'MaterialThumbnail_9x9Inches',
  MaterialThumbnail_10x10 = 'MaterialThumbnail_10x10',
  MaterialThumbnail_13_5x13_5Inches = 'MaterialThumbnail_13_5x13_5Inches',
  MaterialThumbnail_15x15 = 'MaterialThumbnail_15x15',
  MaterialThumbnail_16x16Inches = 'MaterialThumbnail_16x16Inches',
  MaterialThumbnail_20x20 = 'MaterialThumbnail_20x20',
  MaterialThumbnail_27x27Inches = 'MaterialThumbnail_27x27Inches',
  MaterialThumbnail_30x30 = 'MaterialThumbnail_30x30',
  MaterialThumbnail_32x32Inches = 'MaterialThumbnail_32x32Inches',
  MaterialTileableRender = 'MaterialTileableRender',
  MeshDataDrc = 'MeshDataDrc',
  MeshDataDrcProxy = 'MeshDataDrcProxy',
  MeshDataPly = 'MeshDataPly',
  PdfTemplate = 'PdfTemplate',
  PictureData = 'PictureData',
  PictureDataLinear = 'PictureDataLinear',
  PictureDataSecondary = 'PictureDataSecondary',
  PictureDataTertiary = 'PictureDataTertiary',
  ProfilePicture = 'ProfilePicture',
  ScanAssemblyWorkPackage = 'ScanAssemblyWorkPackage',
  ScanCalibrationData = 'ScanCalibrationData',
  ScanFittingWorkPackage = 'ScanFittingWorkPackage',
  ScanLog = 'ScanLog',
  ScanMergedFile = 'ScanMergedFile',
  ScanReferenceFile = 'ScanReferenceFile',
  TemplateConfigIcon = 'TemplateConfigIcon',
  TemplateDataOther = 'TemplateDataOther',
  TextureEditDescriptor = 'TextureEditDescriptor',
  TextureEditMask = 'TextureEditMask',
  TilingGraph = 'TilingGraph'
}

export type DataObjectAssignmentsFilterInput = {
  every?: InputMaybe<DataObjectAssignmentFilterInput>;
  none?: InputMaybe<DataObjectAssignmentFilterInput>;
  some?: InputMaybe<DataObjectAssignmentFilterInput>;
};

export type DataObjectByUuid = {
  __typename: 'DataObjectByUuid';
  downloadUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mediaType?: Maybe<Scalars['String']['output']>;
  state: DataObjectState;
  thumbnail?: Maybe<DataObjectByUuidThumbnail>;
  thumbnailProcessingJob?: Maybe<DataObjectByUuidThumbnailProcessingJob>;
};


export type DataObjectByUuidDownloadUrlArgs = {
  fileType?: InputMaybe<DownloadFileType>;
  resolution?: InputMaybe<DownloadResolution>;
};


export type DataObjectByUuidThumbnailArgs = {
  fileType?: InputMaybe<DownloadFileType>;
  resolution?: InputMaybe<DownloadResolution>;
};

/** Thumbnail data object returned by dataObjectsById */
export type DataObjectByUuidThumbnail = {
  __typename: 'DataObjectByUuidThumbnail';
  downloadUrl: Scalars['String']['output'];
};

/** Thumbnail processing job returned by dataObjectsById */
export type DataObjectByUuidThumbnailProcessingJob = {
  __typename: 'DataObjectByUuidThumbnailProcessingJob';
  state: JobState;
};

export type DataObjectCreateInput = {
  bucketName: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  imageColorProfile?: InputMaybe<Scalars['String']['input']>;
  imageColorSpace?: InputMaybe<ImageColorSpace>;
  imageDataType?: InputMaybe<ImageDataType>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  objectName: Scalars['String']['input'];
  originalFileName: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Float']['input']>;
  state: DataObjectState;
  type?: InputMaybe<DataObjectType>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type DataObjectFilterInput = {
  assignedToContentType?: InputMaybe<ContentTypeModel>;
  assignedToId?: InputMaybe<Scalars['ID']['input']>;
  assignedToLegacyId?: InputMaybe<Scalars['Int']['input']>;
  assignmentKey?: InputMaybe<Scalars['String']['input']>;
  assignmentType?: InputMaybe<Array<DataObjectAssignmentType>>;
  bucketName?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdInFilter>;
  /** If true, only return objects that are related to a parent. If false, only return objects that are not related to a parent. */
  isRelated?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId?: InputMaybe<IntFilterInput>;
  mediaType?: InputMaybe<StringFilterInput>;
  objectName?: InputMaybe<StringFilterInput>;
  organizationId?: InputMaybe<IdInFilter>;
  /** If provided, only return objects that are related to a parent matching the UUID filter. */
  relatedTo?: InputMaybe<IdInFilter>;
  state?: InputMaybe<Array<DataObjectState>>;
};

export enum DataObjectOrderByCriteria {
  Id = 'id',
  LegacyId = 'legacyId',
  ObjectName = 'objectName',
  OriginalFileName = 'originalFileName'
}

export type DataObjectOrderByInput = {
  direction: SortOrder;
  key: DataObjectOrderByCriteria;
};

export enum DataObjectState {
  Completed = 'Completed',
  Init = 'Init',
  Processing = 'Processing',
  ProcessingFailed = 'ProcessingFailed',
  UploadFinished = 'UploadFinished'
}

export enum DataObjectType {
  Archive = 'Archive',
  Image = 'Image',
  ImageTiles = 'ImageTiles',
  Mesh = 'Mesh',
  Model = 'Model',
  ModelDrc = 'ModelDrc',
  ModelObj = 'ModelObj',
  Other = 'Other',
  Pdf = 'Pdf',
  Scan = 'Scan',
  Text = 'Text',
  TextJson = 'TextJson',
  Texture = 'Texture',
  TmpFile = 'TmpFile',
  Video = 'Video'
}

export type DateTimeFilterInput = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum DownloadFileType {
  Exr = 'exr',
  Jpg = 'jpg',
  Png = 'png',
  Tiff = 'tiff'
}

export enum DownloadResolution {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
  Tiny = 'Tiny'
}

export enum DownloadType {
  Cet = 'Cet',
  Pbr = 'Pbr',
  Thumbnail = 'Thumbnail',
  Tile = 'Tile'
}

export type ExchangeConnection = {
  __typename: 'ExchangeConnection';
  destinationId: Scalars['String']['output'];
  destinationParameter: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  sourceParameter: Scalars['String']['output'];
};

export type ExchangeConnectionCreateInput = {
  destinationId: Scalars['String']['input'];
  destinationParameter: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  sourceParameter: Scalars['String']['input'];
};

export type ExchangeNode = {
  __typename: 'ExchangeNode';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parameters: Scalars['Json']['output'];
  textureRevisionId?: Maybe<Scalars['String']['output']>;
  textureSetRevisionId?: Maybe<Scalars['String']['output']>;
};

export type ExchangeNodeCreateInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parameters: Array<Scalars['JsonObject']['input']>;
  textureRevisionId?: InputMaybe<Scalars['String']['input']>;
  textureSetRevisionId?: InputMaybe<Scalars['String']['input']>;
};

export type ExchangeNodesAndConnections = {
  __typename: 'ExchangeNodesAndConnections';
  connections: Array<ExchangeConnection>;
  nodes: Array<ExchangeNode>;
};

export type ExchangeNodesAndConnectionsCreateInput = {
  connections: Array<ExchangeConnectionCreateInput>;
  nodes: Array<ExchangeNodeCreateInput>;
};

export type ExchangeValidationError = {
  __typename: 'ExchangeValidationError';
  message: Scalars['String']['output'];
  nodeId?: Maybe<Scalars['String']['output']>;
};

export enum FabricOverviewGenerateTemplateType {
  FullWidthSlim = 'FullWidthSlim',
  FullWidthSlimWithRepeat = 'FullWidthSlimWithRepeat',
  FullWidthWide = 'FullWidthWide'
}

export enum FittingSchema {
  Clo = 'Clo',
  Colormass = 'Colormass'
}

export type FloatFilterInput = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

/** GPU memory for a task run, in MiB: sampled from the device while the task ran, counting every process on the GPU. */
export type GpuMemoryUsageInput = {
  /** The GPU's total memory. */
  availableMb?: InputMaybe<Scalars['Float']['input']>;
  /** The most GPU memory in use on the device while the task ran. */
  usedMb: Scalars['Float']['input'];
};

export type Hdri = {
  __typename: 'Hdri';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataObject?: Maybe<DataObject>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  galleryImage?: Maybe<DataObject>;
  hdriReferences: Array<TemplateRevision>;
  id: Scalars['ID']['output'];
  jobAssignments: Array<JobAssignment>;
  jobAssignmentsCount: Scalars['Int']['output'];
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  shareAssignments: Array<ShareAssignment>;
  shareAssignmentsCount: Scalars['Int']['output'];
  tagAssignments: Array<TagAssignment>;
  tagAssignmentsCount: Scalars['Int']['output'];
  taskInfos: TaskInfos;
  tasks: Array<Task>;
  tasksCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type HdriDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type HdriJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};


export type HdriShareAssignmentsArgs = {
  filter?: InputMaybe<ShareAssignmentFilterInput>;
  orderBy?: InputMaybe<ShareAssignmentOrderByInput>;
};


export type HdriTagAssignmentsArgs = {
  tagTypes?: InputMaybe<Array<TagType>>;
};

export type HdriFilterInput = {
  created?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdInFilter>;
  legacyId?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  organizationId?: InputMaybe<IdInFilter>;
  organizationLegacyId?: InputMaybe<IntInFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum HdriOrderByCriteria {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name'
}

export type HdriOrderByInput = {
  direction: SortOrder;
  key: HdriOrderByCriteria;
};

export enum HistoryType {
  Added = 'Added',
  Deleted = 'Deleted',
  Moved = 'Moved'
}

export type IdFilterInput = {
  contains?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  equals?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<IdFilterInput>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type IdFromCatalog = {
  __typename: 'IdFromCatalog';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  disambiguator?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  originalId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  uuid: Scalars['ID']['output'];
};

export type IdFromCatalogToPriceGraph = {
  __typename: 'IdFromCatalogToPriceGraph';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  idFromCatalog: IdFromCatalog;
  idFromCatalogUuid: Scalars['ID']['output'];
  priceGraphUuid: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type IdFromCatalogToPriceGraphFilterInput = {
  disambiguator?: InputMaybe<Scalars['String']['input']>;
  organizationUuid: Scalars['ID']['input'];
  originalIds: Array<Scalars['String']['input']>;
};

export enum IdFromCatalogToPriceGraphOrderByCriteria {
  PriceGraphUuid = 'priceGraphUuid'
}

export type IdFromCatalogToPriceGraphOrderByInput = {
  direction: SortOrder;
  key: IdFromCatalogToPriceGraphOrderByCriteria;
};

export type IdInFilter = {
  equals?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum ImageColorSpace {
  Gamma_2_0 = 'Gamma_2_0',
  Gamma_2_2 = 'Gamma_2_2',
  Linear = 'Linear',
  Srgb = 'Srgb',
  Unknown = 'Unknown'
}

export enum ImageDataType {
  Color = 'Color',
  NonColor = 'NonColor',
  Unknown = 'Unknown'
}

export type ImageTilesDescriptor = {
  __typename: 'ImageTilesDescriptor';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  dataObject: DataObject;
  id: Scalars['ID']['output'];
  imageHeight: Scalars['Int']['output'];
  imageWidth: Scalars['Int']['output'];
  tileBucketName: Scalars['String']['output'];
  tileChannels?: Maybe<Scalars['Int']['output']>;
  tileColorProfile?: Maybe<Scalars['String']['output']>;
  /** The tile's color space. Note that this does not match the color space reported by the OS or libraries like sharp. For example, rendered EXR files always have ImageColorSpace.Linear while sharp reports 'scrgb' and Mac OS 'RGB' */
  tileColorSpace: ImageColorSpace;
  tileDownloadUrlPrefix: Scalars['String']['output'];
  tileHeight: Scalars['Int']['output'];
  tileMargin: Scalars['Int']['output'];
  tileMediaType: Scalars['String']['output'];
  tileMipLevels: Scalars['Int']['output'];
  tileStorageFolderName: Scalars['String']['output'];
  tileWidth: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type InlineTextureSetRevisionMapAssignmentInput = {
  dataObjectId: Scalars['ID']['input'];
  textureType: TextureType;
};

export type IntFilterInput = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  not?: InputMaybe<IntFilterInput>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntInFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum InvocationMethod {
  CloudTasks = 'CloudTasks',
  ComputeEngine = 'ComputeEngine',
  Http = 'Http',
  JobsV2 = 'JobsV2',
  None = 'None'
}

export type Job = {
  __typename: 'Job';
  assignments: Array<JobAssignment>;
  cancelled?: Maybe<Scalars['DateTime']['output']>;
  claimedBy?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  discarded?: Maybe<Scalars['DateTime']['output']>;
  executionPlan?: Maybe<Scalars['Json']['output']>;
  finished?: Maybe<Scalars['DateTime']['output']>;
  graph?: Maybe<Scalars['Json']['output']>;
  id: Scalars['ID']['output'];
  jobTasks: Array<JobTask>;
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  materialOutput?: Maybe<MaterialOutput>;
  message?: Maybe<Scalars['String']['output']>;
  metadataProcessingJobForDataObject?: Maybe<DataObject>;
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  output?: Maybe<Scalars['Json']['output']>;
  priority: Scalars['Int']['output'];
  progress?: Maybe<Scalars['Int']['output']>;
  started?: Maybe<Scalars['DateTime']['output']>;
  state: JobState;
  taskEvents: Array<JobTaskEvent>;
  thumbnailProcessingJobForDataObjects: Array<DataObject>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type JobDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};

export type JobAssignment = {
  __typename: 'JobAssignment';
  assignedTo?: Maybe<JobAssignmentSubject>;
  assignmentKey?: Maybe<Scalars['String']['output']>;
  contentTypeModel: ContentTypeModel;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  job: Job;
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  objectLegacyId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type JobAssignmentFilterInput = {
  /** When true, only return assignments whose job is active (not cancelled and not discarded). A superseded render leaves its assignment behind for history, so this is how callers ask for the one currently active job of a slot. */
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  assignmentKey?: InputMaybe<StringFilterInput>;
  contentTypeModel?: InputMaybe<ContentTypeModel>;
  /** true → only assignments whose job was discarded; false → only those whose job was not (cancelled jobs are kept, so a cancelled render can still be shown and restarted); omitted → both. */
  discarded?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  objectId?: InputMaybe<Scalars['ID']['input']>;
  objectLegacyId?: InputMaybe<Scalars['Int']['input']>;
};

export enum JobAssignmentOrderByCriteria {
  AssignmentKey = 'assignmentKey',
  Id = 'id'
}

export type JobAssignmentOrderByInput = {
  direction: SortOrder;
  key: JobAssignmentOrderByCriteria;
};

export type JobAssignmentSubject = Asset | Hdri | Material | Model | Picture | Project | Set | Template | TextureSet;

export type JobFarmGroup = {
  __typename: 'JobFarmGroup';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  instances: Array<JobFarmInstance>;
  name: Scalars['String']['output'];
  organization: Organization;
  otherConfig?: Maybe<Scalars['Json']['output']>;
  queueGroup: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type JobFarmGroupFilterInput = {
  id?: InputMaybe<IdInFilter>;
  name?: InputMaybe<StringFilterInput>;
  organizationId?: InputMaybe<IdInFilter>;
  queueGroup?: InputMaybe<StringInFilter>;
};

export enum JobFarmGroupOrderByCriteria {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name'
}

export type JobFarmGroupOrderByInput = {
  direction: SortOrder;
  key: JobFarmGroupOrderByCriteria;
};

export type JobFarmInstance = {
  __typename: 'JobFarmInstance';
  claim?: Maybe<JobTask>;
  /** @deprecated Not yet implemented */
  control: JobFarmInstanceControl;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  group?: Maybe<JobFarmGroup>;
  hwFingerprint: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastReport?: Maybe<Scalars['DateTime']['output']>;
  otherInfo?: Maybe<Scalars['Json']['output']>;
  state: JobFarmInstanceState;
  type: JobFarmInstanceType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  user: User;
  version: Scalars['String']['output'];
};

export enum JobFarmInstanceControl {
  ExitNow = 'ExitNow',
  ExitWhenIdle = 'ExitWhenIdle',
  Pause = 'Pause',
  Run = 'Run',
  UpdateNow = 'UpdateNow',
  UpdateWhenIdle = 'UpdateWhenIdle'
}

export type JobFarmInstanceFilterInput = {
  groupId?: InputMaybe<IdInFilter>;
  hwFingerprint?: InputMaybe<StringInFilter>;
  id?: InputMaybe<IdInFilter>;
  lastReport?: InputMaybe<DateTimeFilterInput>;
  state?: InputMaybe<Array<JobFarmInstanceState>>;
  type?: InputMaybe<JobFarmInstanceType>;
  userId?: InputMaybe<IdInFilter>;
  version?: InputMaybe<StringFilterInput>;
};

export enum JobFarmInstanceOrderByCriteria {
  CreatedAt = 'createdAt',
  Id = 'id'
}

export type JobFarmInstanceOrderByInput = {
  direction: SortOrder;
  key: JobFarmInstanceOrderByCriteria;
};

export enum JobFarmInstanceState {
  NotResponding = 'NotResponding',
  Paused = 'Paused',
  Running = 'Running',
  Stopped = 'Stopped',
  Updating = 'Updating'
}

export enum JobFarmInstanceType {
  RenderNodeApp = 'RenderNodeApp'
}

export type JobFilterInput = {
  createdByIds?: InputMaybe<IdInFilter>;
  /** true → only jobs retired from their slot; false → only jobs that have not been discarded; omitted → both. */
  discarded?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdInFilter>;
  jobType?: InputMaybe<Array<JobType>>;
  legacyId?: InputMaybe<IntInFilter>;
  organizationId?: InputMaybe<IdInFilter>;
  organizationLegacyId?: InputMaybe<IntInFilter>;
  queueGroup?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<JobState>>;
  taskType?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** One event in a coordinator instance's merged lifecycle (a task event or an instance event). */
export type JobInstanceHistoryEvent = {
  __typename: 'JobInstanceHistoryEvent';
  advanceReason?: Maybe<CascadeAdvanceReason>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  eventType: Scalars['String']['output'];
  jobLegacyId?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  observedAt: Scalars['DateTime']['output'];
  previousStatus?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  resourceGroupId?: Maybe<ResourceGroupId>;
  /** "task" (a JobTaskEvent) or "instance" (an InstanceEvent). */
  source: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  taskLegacyId?: Maybe<Scalars['Int']['output']>;
  taskType?: Maybe<Scalars['String']['output']>;
  taskUuid?: Maybe<Scalars['String']['output']>;
};

export enum JobOrderByCriteria {
  Id = 'id',
  LegacyId = 'legacyId',
  Started = 'started'
}

export type JobOrderByInput = {
  direction: SortOrder;
  key: JobOrderByCriteria;
};

export enum JobState {
  Cancelled = 'Cancelled',
  Complete = 'Complete',
  Failed = 'Failed',
  Init = 'Init',
  Missing = 'Missing',
  Runnable = 'Runnable',
  Running = 'Running'
}

export type JobTask = {
  __typename: 'JobTask';
  assignments: Array<JobTaskAssignment>;
  attemptCount: Scalars['Int']['output'];
  cancelled?: Maybe<Scalars['DateTime']['output']>;
  cascade: Array<JobTaskCascadeStep>;
  cascadeGroupId?: Maybe<ResourceGroupId>;
  claimedBy?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: User;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  deferredUntil?: Maybe<Scalars['DateTime']['output']>;
  finished?: Maybe<Scalars['DateTime']['output']>;
  graph?: Maybe<Scalars['Json']['output']>;
  hashInParent?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  job?: Maybe<JobTask>;
  jobType?: Maybe<JobType>;
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  maxAttempts: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  metadataProcessingJobForDataObject?: Maybe<DataObject>;
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  output?: Maybe<Scalars['Json']['output']>;
  priority: Scalars['Int']['output'];
  progress?: Maybe<Scalars['Int']['output']>;
  queueGroup?: Maybe<Scalars['String']['output']>;
  queueToken?: Maybe<Scalars['String']['output']>;
  resourceGroupPin?: Maybe<ResourceGroupId>;
  started?: Maybe<Scalars['DateTime']['output']>;
  state: JobTaskState;
  taskEvents: Array<JobTaskEvent>;
  taskType?: Maybe<Scalars['String']['output']>;
  thumbnailProcessingJobForDataObjects: Array<DataObject>;
  updateDeadline?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  versionCounter: Scalars['Int']['output'];
};


export type JobTaskDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type JobTaskJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};

export type JobTaskAssignment = {
  __typename: 'JobTaskAssignment';
  assignedTo?: Maybe<JobTaskAssignmentSubject>;
  assignmentKey?: Maybe<Scalars['String']['output']>;
  contentTypeModel: ContentTypeModel;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  jobTask: JobTask;
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type JobTaskAssignmentFilterInput = {
  assignmentKey?: InputMaybe<StringFilterInput>;
  contentTypeModel?: InputMaybe<ContentTypeModel>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobTaskId?: InputMaybe<Scalars['ID']['input']>;
  objectId?: InputMaybe<Scalars['ID']['input']>;
  objectLegacyId?: InputMaybe<Scalars['Int']['input']>;
};

export enum JobTaskAssignmentOrderByCriteria {
  AssignmentKey = 'assignmentKey',
  Id = 'id'
}

export type JobTaskAssignmentOrderByInput = {
  direction: SortOrder;
  key: JobTaskAssignmentOrderByCriteria;
};

export type JobTaskAssignmentSubject = Asset | Hdri | Material | Model | Picture | Project | Set | Template;

/** One step of a task's resource cascade, with its display state pre-derived by the server. */
export type JobTaskCascadeStep = {
  __typename: 'JobTaskCascadeStep';
  events: Array<JobTaskCascadeStepEvent>;
  label: Scalars['String']['output'];
  platform: ResourceGroupPlatform;
  resourceGroupId: ResourceGroupId;
  status: CascadeStepStatus;
};

/** One event that happened on a cascade step — a row in the step's popover. */
export type JobTaskCascadeStepEvent = {
  __typename: 'JobTaskCascadeStepEvent';
  category: CascadeStepEventCategory;
  label: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  observedAt: Scalars['DateTime']['output'];
};

export type JobTaskEvent = {
  __typename: 'JobTaskEvent';
  advanceReason?: Maybe<CascadeAdvanceReason>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  eventType: JobTaskEventType;
  id: Scalars['ID']['output'];
  instanceName?: Maybe<Scalars['String']['output']>;
  machineType?: Maybe<Scalars['String']['output']>;
  memoryStats?: Maybe<Scalars['Json']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  observedAt: Scalars['DateTime']['output'];
  performedByName?: Maybe<Scalars['String']['output']>;
  queueGroup?: Maybe<Scalars['String']['output']>;
  resourceGroupId?: Maybe<ResourceGroupId>;
  taskKey: Scalars['String']['output'];
  taskLegacyId?: Maybe<Scalars['Int']['output']>;
  taskType?: Maybe<Scalars['String']['output']>;
  taskUuid?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

export enum JobTaskEventType {
  Active = 'Active',
  Cancelled = 'Cancelled',
  CascadeAdvanced = 'CascadeAdvanced',
  Completed = 'Completed',
  Created = 'Created',
  Designated = 'Designated',
  Discarded = 'Discarded',
  Failed = 'Failed',
  Fatal = 'Fatal',
  Heartbeat = 'Heartbeat',
  Invoked = 'Invoked',
  MemoryPressure = 'MemoryPressure',
  Misconfigured = 'Misconfigured',
  Nudged = 'Nudged',
  OutOfMemory = 'OutOfMemory',
  Preempted = 'Preempted',
  Progress = 'Progress',
  Provisioned = 'Provisioned',
  Queued = 'Queued',
  Repinned = 'Repinned',
  Rerun = 'Rerun',
  Restarted = 'Restarted',
  Runnable = 'Runnable',
  Running = 'Running',
  Skipped = 'Skipped',
  Stockout = 'Stockout',
  TimedOut = 'TimedOut',
  Updated = 'Updated'
}

export type JobTaskFilterInput = {
  claimedBy?: InputMaybe<StringInFilter>;
  createdByIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<IdInFilter>;
  jobId?: InputMaybe<IdInFilter>;
  legacyId?: InputMaybe<IntInFilter>;
  organizationId?: InputMaybe<IdInFilter>;
  organizationLegacyId?: InputMaybe<IntInFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<JobTaskState>>;
  taskType?: InputMaybe<Scalars['String']['input']>;
  versionCounter?: InputMaybe<Scalars['Int']['input']>;
};

/** Memory statistics for a task run: how much was available, how much was used, and whether it ran out. */
export type JobTaskMemoryStatsInput = {
  gpu?: InputMaybe<GpuMemoryUsageInput>;
  /** Which memory the task ran out of, if it did. */
  oom?: InputMaybe<MemoryKind>;
  system?: InputMaybe<SystemMemoryUsageInput>;
};

export enum JobTaskOrderByCriteria {
  Id = 'id',
  LegacyId = 'legacyId',
  Started = 'started',
  VersionCounter = 'versionCounter'
}

export type JobTaskOrderByInput = {
  direction: SortOrder;
  key: JobTaskOrderByCriteria;
};

export type JobTaskRunnableFilterEntry = {
  /** @deprecated No longer used */
  maxVersion?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated No longer used */
  minVersion?: InputMaybe<Scalars['Int']['input']>;
  /** A string corresponding to a registered task type (e.g. `AssetRendering.ShaderBall.postRenderStep`). It must have a matching entry in the JobTaskType database table. No relation to the enum of the same name. */
  taskType: Scalars['String']['input'];
};

export type JobTaskRunnableFilterInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  queueGroup: Scalars['String']['input'];
  queueToken?: InputMaybe<Scalars['String']['input']>;
  taskTypes?: InputMaybe<Array<JobTaskRunnableFilterEntry>>;
};

export enum JobTaskState {
  Cancelled = 'Cancelled',
  Complete = 'Complete',
  Failed = 'Failed',
  Fatal = 'Fatal',
  Init = 'Init',
  Missing = 'Missing',
  Preempted = 'Preempted',
  Queued = 'Queued',
  Runnable = 'Runnable',
  Running = 'Running',
  Timeout = 'Timeout'
}

export type JobTaskType = {
  __typename: 'JobTaskType';
  cancelTimeout?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  defaultTimeout?: Maybe<Scalars['Int']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invocationMethod: InvocationMethod;
  maxTimeout?: Maybe<Scalars['Int']['output']>;
  queueGroup: Scalars['String']['output'];
  taskType: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type JobTaskTypeFilterInput = {
  endpoint?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdInFilter>;
  queueGroup?: InputMaybe<StringFilterInput>;
  taskType?: InputMaybe<StringFilterInput>;
};

export enum JobTaskTypeOrderByCriteria {
  LegacyId = 'legacyId',
  QueueGroup = 'queueGroup',
  TaskType = 'taskType'
}

export type JobTaskTypeOrderByInput = {
  direction: SortOrder;
  key: JobTaskTypeOrderByCriteria;
};

export enum JobType {
  ArGeneration = 'ArGeneration',
  Baking = 'Baking',
  BatchDownload = 'BatchDownload',
  DataObjectThumbnails = 'DataObjectThumbnails',
  Generic = 'Generic',
  MaterialAi = 'MaterialAi',
  MaterialMapsExport = 'MaterialMapsExport',
  MaterialOutputsPublishing = 'MaterialOutputsPublishing',
  MaterialShaderBall = 'MaterialShaderBall',
  MaterialThumbnail = 'MaterialThumbnail',
  MaterialTileableImage = 'MaterialTileableImage',
  RenderScene = 'RenderScene',
  RenderTemplate = 'RenderTemplate',
  TemplateThumbnail = 'TemplateThumbnail',
  TextureSetRevisionThumbnails = 'TextureSetRevisionThumbnails',
  UploadProcessing = 'UploadProcessing'
}

export type JsonFile = {
  __typename: 'JsonFile';
  content: Scalars['Json']['output'];
  created: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  jsonFileType: JsonFileType;
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  organization: Organization;
  outputDataObject?: Maybe<DataObject>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type JsonFileDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type JsonFileAssignment = {
  __typename: 'JsonFileAssignment';
  assignedTo?: Maybe<JsonFileAssignmentSubject>;
  assignmentKey?: Maybe<Scalars['String']['output']>;
  assignmentType: JsonFileAssignmentType;
  contentTypeModel: ContentTypeModel;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  jsonFile: JsonFile;
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  objectId: Scalars['String']['output'];
  objectLegacyId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type JsonFileAssignmentFilterInput = {
  assignmentKey?: InputMaybe<StringFilterInput>;
  assignmentType?: InputMaybe<Array<JsonFileAssignmentType>>;
  contentTypeModel?: InputMaybe<ContentTypeModel>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jsonFileContent?: InputMaybe<Array<JsonFileConfigInput>>;
  jsonFileId?: InputMaybe<IdInFilter>;
  legacyId?: InputMaybe<IntInFilter>;
  objectId?: InputMaybe<Scalars['ID']['input']>;
  objectLegacyId?: InputMaybe<Scalars['Int']['input']>;
};

export type JsonFileAssignmentOrderByInput = {
  assignmentKey?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  objectId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type JsonFileAssignmentSubject = Asset | Hdri | JobTask | Material | MaterialRevision | Model | Organization | Picture | PictureRevision | Project | ScanJob | ScanSubJob | Scene | SceneRevision | Set | Tag | Template | TemplateRevision | Texture | TextureGroup | TextureRevision | TextureSet | User;

export enum JsonFileAssignmentType {
  MaterialMapsExportConfig = 'MaterialMapsExportConfig',
  TextureEdits = 'TextureEdits'
}

export type JsonFileConfigInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  engine?: InputMaybe<Scalars['String']['input']>;
  fileType?: InputMaybe<DownloadFileType>;
  name?: InputMaybe<Scalars['String']['input']>;
  normalY?: InputMaybe<Scalars['String']['input']>;
  resolution?: InputMaybe<DownloadResolution>;
  state?: InputMaybe<Scalars['String']['input']>;
  workflow?: InputMaybe<Scalars['String']['input']>;
};

export type JsonFileCreateWithoutAssignmentInput = {
  content: Scalars['Json']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationLegacyId?: InputMaybe<Scalars['Int']['input']>;
  type: JsonFileType;
};

export type JsonFileFilterInput = {
  created?: InputMaybe<DateTimeFilterInput>;
  createdById?: InputMaybe<IdInFilter>;
  id?: InputMaybe<IdInFilter>;
  legacyId?: InputMaybe<IntInFilter>;
  organizationId?: InputMaybe<IdInFilter>;
  type?: InputMaybe<Array<JsonFileType>>;
};

export enum JsonFileOrderByCriteria {
  CreatedAt = 'createdAt',
  Id = 'id'
}

export type JsonFileOrderByInput = {
  direction: SortOrder;
  key: JsonFileOrderByCriteria;
};

export enum JsonFileType {
  MaterialMapsExportConfig = 'MaterialMapsExportConfig',
  TextureEdits = 'TextureEdits'
}

export enum LoginProvider {
  Colormass = 'Colormass',
  Google = 'Google',
  Microsoft = 'Microsoft',
  None = 'None',
  Richemont = 'Richemont'
}

export type LoginResult = {
  __typename: 'LoginResult';
  /** JWT token for authentication. To use, add a header `Authorization: "Bearer <token>"`. Expires in 30 days. */
  token: Scalars['String']['output'];
  /** The user that has just been logged in */
  user: User;
};

export type Material = {
  __typename: 'Material';
  aiCategorizedAt?: Maybe<Scalars['DateTime']['output']>;
  aiDescription?: Maybe<Scalars['String']['output']>;
  articleId?: Maybe<Scalars['String']['output']>;
  /** Assets assigned to this material via a MaterialAssignment. This is a convenience field that is equivalent to `materialAssignments.assets`. */
  assets: Array<Asset>;
  assetsCount: Scalars['Int']['output'];
  colors?: Maybe<Array<MaterialColor>>;
  comment?: Maybe<Scalars['String']['output']>;
  configuraMaterialDatabasePublishState: Scalars['Json']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  currentUserAssignment?: Maybe<User>;
  cyclesRevisions?: Maybe<Array<MaterialRevision>>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  galleryImage?: Maybe<DataObject>;
  id: Scalars['ID']['output'];
  internalName?: Maybe<Scalars['String']['output']>;
  jobAssignments: Array<JobAssignment>;
  jobAssignmentsCount: Scalars['Int']['output'];
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  latestCyclesRevision?: Maybe<MaterialRevision>;
  latestRevision?: Maybe<MaterialRevision>;
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  materialTypes?: Maybe<Array<MaterialType>>;
  meshSpecific: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nextActor: NextActor;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['String']['output']>;
  /** The organization of materials that are both private and referenced by templates cannot be changed. */
  organizationLocked: Scalars['Boolean']['output'];
  outputForType?: Maybe<MaterialOutput>;
  outputs: Array<MaterialOutput>;
  patterns?: Maybe<Array<MaterialPattern>>;
  paymentState: PaymentState;
  pinnedImage?: Maybe<DataObject>;
  priorityOrder?: Maybe<Scalars['GraphQLBigInt']['output']>;
  public: Scalars['Boolean']['output'];
  /** When true and `public` is also true, logged-in users from other organizations can download this material's assets. */
  publicDownloads: Scalars['Boolean']['output'];
  revisions: Array<MaterialRevision>;
  revisionsCount: Scalars['Int']['output'];
  sampleArrival?: Maybe<Scalars['DateTime']['output']>;
  shareAssignments: Array<ShareAssignment>;
  shareAssignmentsCount: Scalars['Int']['output'];
  state: MaterialState;
  tagAssignments: Array<TagAssignment>;
  tagAssignmentsCount: Scalars['Int']['output'];
  taskInfos: TaskInfos;
  textureGroup?: Maybe<TextureGroup>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  userAssignments: Array<UserAssignment>;
  userAssignmentsCount: Scalars['Int']['output'];
  /** Materials that are referenced by templates cannot be changed from public to private. */
  visibilityLocked: Scalars['Boolean']['output'];
};


export type MaterialDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type MaterialJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};


export type MaterialOutputForTypeArgs = {
  type: MaterialOutputType;
};


export type MaterialShareAssignmentsArgs = {
  filter?: InputMaybe<ShareAssignmentFilterInput>;
  orderBy?: InputMaybe<ShareAssignmentOrderByInput>;
};


export type MaterialTagAssignmentsArgs = {
  tagTypes?: InputMaybe<Array<TagType>>;
};


export type MaterialUserAssignmentsArgs = {
  filter?: InputMaybe<UserAssignmentFilterInput>;
};

export type MaterialAssignment = {
  __typename: 'MaterialAssignment';
  asset: Asset;
  assetId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  material?: Maybe<Material>;
  materialId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type MaterialAssignmentFilterInput = {
  asset?: InputMaybe<AssetFilterInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  material?: InputMaybe<MaterialFilterInput>;
};

export type MaterialAssignmentHistory = {
  __typename: 'MaterialAssignmentHistory';
  asset?: Maybe<Asset>;
  createdBy?: Maybe<User>;
  historyChangeReason?: Maybe<Scalars['String']['output']>;
  historyDate?: Maybe<Scalars['DateTime']['output']>;
  historyType: HistoryType;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  material?: Maybe<Material>;
};

export type MaterialAssignmentHistoryFilterInput = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  assignmentId?: InputMaybe<IdInFilter>;
  historyChangeReason?: InputMaybe<StringFilterInput>;
  historyDate?: InputMaybe<DateTimeFilterInput>;
  historyType?: InputMaybe<Array<HistoryType>>;
  id?: InputMaybe<IdInFilter>;
  materialId?: InputMaybe<Scalars['ID']['input']>;
};

export enum MaterialAssignmentHistoryOrderByCriteria {
  ArticleId = 'articleId',
  HistoryDate = 'history_date',
  Id = 'id',
  Name = 'name',
  NextActor = 'nextActor',
  PaymentState = 'paymentState',
  PriorityOrder = 'priorityOrder',
  Public = 'public',
  State = 'state'
}

export type MaterialAssignmentHistoryOrderByInput = {
  direction: SortOrder;
  key: MaterialAssignmentHistoryOrderByCriteria;
};

export type MaterialCardByUuid = {
  __typename: 'MaterialCardByUuid';
  currentUserAssignment?: Maybe<MaterialCardUser>;
  id: Scalars['ID']['output'];
  nextActor: NextActor;
  organization?: Maybe<MaterialCardOrganization>;
  state: MaterialState;
  tagAssignments: Array<MaterialCardTagAssignment>;
  taskInfos: MaterialCardTaskInfos;
};

/** Gallery image returned by materialCardDataById */
export type MaterialCardGalleryImage = {
  __typename: 'MaterialCardGalleryImage';
  id: Scalars['ID']['output'];
};

/** Organization returned by materialCardDataById */
export type MaterialCardOrganization = {
  __typename: 'MaterialCardOrganization';
  id: Scalars['ID']['output'];
};

/** Tag returned by materialCardDataById */
export type MaterialCardTag = {
  __typename: 'MaterialCardTag';
  color?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<MaterialCardTagCreatedBy>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legacyId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<MaterialCardTagOrganization>;
  type: TagType;
};

/** Tag assignment returned by materialCardDataById */
export type MaterialCardTagAssignment = {
  __typename: 'MaterialCardTagAssignment';
  id: Scalars['ID']['output'];
  tag: MaterialCardTag;
};

/** Tag creator returned by materialCardDataById */
export type MaterialCardTagCreatedBy = {
  __typename: 'MaterialCardTagCreatedBy';
  id: Scalars['ID']['output'];
};

/** Tag organization returned by materialCardDataById */
export type MaterialCardTagOrganization = {
  __typename: 'MaterialCardTagOrganization';
  id: Scalars['ID']['output'];
  legacyId: Scalars['Int']['output'];
};

/** Task infos returned by materialCardDataById */
export type MaterialCardTaskInfos = {
  __typename: 'MaterialCardTaskInfos';
  archived: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  inProgress: Scalars['Int']['output'];
  waitingForFeedback: Scalars['Int']['output'];
};

/** User returned by materialCardDataById */
export type MaterialCardUser = {
  __typename: 'MaterialCardUser';
  firstName?: Maybe<Scalars['String']['output']>;
  galleryImage?: Maybe<MaterialCardGalleryImage>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export enum MaterialColor {
  Black = 'Black',
  Blue = 'Blue',
  Brown = 'Brown',
  Green = 'Green',
  Grey = 'Grey',
  Multicolor = 'Multicolor',
  Orange = 'Orange',
  Pink = 'Pink',
  Purple = 'Purple',
  Red = 'Red',
  White = 'White',
  Yellow = 'Yellow'
}

export type MaterialDownloadData = {
  __typename: 'MaterialDownloadData';
  /** Material UUID */
  materialId: Scalars['String']['output'];
  /** Organization UUID */
  organizationId: Scalars['String']['output'];
  pbrDownloadUrl?: Maybe<Scalars['String']['output']>;
  thumbnailDownloadUrl?: Maybe<Scalars['String']['output']>;
  tileDownloadUrl?: Maybe<Scalars['String']['output']>;
};


export type MaterialDownloadDataPbrDownloadUrlArgs = {
  fileType?: InputMaybe<DownloadFileType>;
  resolution?: InputMaybe<DownloadResolution>;
};


export type MaterialDownloadDataThumbnailDownloadUrlArgs = {
  assignmentType: DataObjectAssignmentType;
  fileType?: InputMaybe<DownloadFileType>;
  resolution?: InputMaybe<DownloadResolution>;
};


export type MaterialDownloadDataTileDownloadUrlArgs = {
  fileType?: InputMaybe<DownloadFileType>;
  resolution?: InputMaybe<DownloadResolution>;
};

export type MaterialEditorMaterial = {
  __typename: 'MaterialEditorMaterial';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<MaterialEditorMaterialRevision>;
  revisions: Array<MaterialEditorMaterialRevision>;
};


export type MaterialEditorMaterialRevisionArgs = {
  revisionId?: InputMaybe<Scalars['ID']['input']>;
};

export type MaterialEditorMaterialRevision = {
  __typename: 'MaterialEditorMaterialRevision';
  graphNode?: Maybe<Scalars['JsonObject']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  textureRevision: MaterialEditorTextureRevision;
  textureSet: MaterialEditorTextureSet;
  textureSetRevision: MaterialEditorTextureSetRevision;
};


export type MaterialEditorMaterialRevisionTextureRevisionArgs = {
  legacyId: Scalars['Int']['input'];
};


export type MaterialEditorMaterialRevisionTextureSetArgs = {
  legacyId: Scalars['Int']['input'];
};


export type MaterialEditorMaterialRevisionTextureSetRevisionArgs = {
  id: Scalars['ID']['input'];
};

export type MaterialEditorTexture = {
  __typename: 'MaterialEditorTexture';
  id: Scalars['ID']['output'];
  latestRevision?: Maybe<MaterialEditorTextureRevision>;
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  revisions: Array<TextureRevision>;
  textureGroupId: Scalars['String']['output'];
  type: TextureType;
};

export type MaterialEditorTextureRevision = {
  __typename: 'MaterialEditorTextureRevision';
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  state: TextureRevisionState;
  texture?: Maybe<MaterialEditorTexture>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  width: Scalars['Float']['output'];
};

export type MaterialEditorTextureSet = {
  __typename: 'MaterialEditorTextureSet';
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  revisions: Array<MaterialEditorTextureSetRevision>;
};

export type MaterialEditorTextureSetRevision = {
  __typename: 'MaterialEditorTextureSetRevision';
  createdAt: Scalars['DateTime']['output'];
  displacement?: Maybe<Scalars['Float']['output']>;
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  mapAssignments: Array<TextureSetRevisionMapAssignment>;
  name?: Maybe<Scalars['String']['output']>;
  processingState?: Maybe<JobState>;
  textureSet?: Maybe<MaterialEditorTextureSet>;
  width: Scalars['Float']['output'];
};

/** Per-material outcome of a batch export ensure. */
export type MaterialExportBatchEntry = {
  __typename: 'MaterialExportBatchEntry';
  /** The generation job to wait for — set for Generated, Regenerated and AlreadyRunning */
  jobId?: Maybe<Scalars['ID']['output']>;
  materialId: Scalars['ID']['output'];
  /** Set for Refused; says what to fix */
  message?: Maybe<Scalars['String']['output']>;
  outcome: MaterialExportOutcome;
  /** Set for a Refused entry the ensure decided; null when the batch refused it before asking (unknown id, not authorized) */
  refusal?: Maybe<MaterialExportRefusal>;
};

/** Generated: no export existed. Regenerated: a stale or failed export row was reused. AlreadyRunning: an in-flight generation was returned instead of starting a second one. UpToDate: nothing to do. Refused: the refusal says why — nothing was written, and retrying changes nothing until the material does. */
export enum MaterialExportOutcome {
  AlreadyRunning = 'AlreadyRunning',
  Generated = 'Generated',
  Refused = 'Refused',
  Regenerated = 'Regenerated',
  UpToDate = 'UpToDate'
}

/** Why an export was refused for this material as it stands. */
export type MaterialExportRefusal = {
  __typename: 'MaterialExportRefusal';
  /** Per-slot detail for the graph reasons; empty otherwise */
  issues: Array<MaterialGraphIssue>;
  /** Written to be shown to the person who asked */
  message: Scalars['String']['output'];
  reason: MaterialExportRefusalReason;
};

/** UnsupportedGraph: the material graph has a shape the exporter cannot read (see the issues). DanglingGraphReference: a texture reference in the graph points at a map that does not exist. NoRevision, NoName, NoOrganization: the material lacks it. Naming: the export's filenames cannot be derived for this material. */
export enum MaterialExportRefusalReason {
  DanglingGraphReference = 'DanglingGraphReference',
  Naming = 'Naming',
  NoName = 'NoName',
  NoOrganization = 'NoOrganization',
  NoRevision = 'NoRevision',
  UnsupportedGraph = 'UnsupportedGraph'
}

/** What ensuring one material's export came to. */
export type MaterialExportResult = {
  __typename: 'MaterialExportResult';
  /** The generation job to wait for — set for Generated, Regenerated and AlreadyRunning */
  job?: Maybe<Job>;
  outcome: MaterialExportOutcome;
  /** Set for Refused */
  refusal?: Maybe<MaterialExportRefusal>;
};

export type MaterialFilterInput = {
  articleId?: InputMaybe<StringInFilter>;
  colors?: InputMaybe<Array<MaterialColor>>;
  comment?: InputMaybe<StringFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  hasAiDescription?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssignedUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasCyclesMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdInFilter>;
  internalName?: InputMaybe<StringFilterInput>;
  legacyId?: InputMaybe<IntInFilter>;
  materialTypes?: InputMaybe<Array<MaterialType>>;
  meshSpecific?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<StringFilterInput>;
  nextActor?: InputMaybe<Array<NextActor>>;
  organizationId?: InputMaybe<IdInFilter>;
  organizationLegacyId?: InputMaybe<IntInFilter>;
  patterns?: InputMaybe<Array<MaterialPattern>>;
  paymentState?: InputMaybe<Array<PaymentState>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  publicDownloads?: InputMaybe<Scalars['Boolean']['input']>;
  sampleArrived?: InputMaybe<Scalars['Boolean']['input']>;
  scannedByNone?: InputMaybe<Scalars['Boolean']['input']>;
  scannedByUserId?: InputMaybe<IdInFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<MaterialState>>;
  tagId?: InputMaybe<IdInFilter>;
  tagLegacyId?: InputMaybe<IntInFilter>;
  userId?: InputMaybe<IdInFilter>;
};

/** One BSDF slot the exporter cannot read, and why. */
export type MaterialGraphIssue = {
  __typename: 'MaterialGraphIssue';
  /** The Principled BSDF input the slot feeds, e.g. baseColor */
  bsdfInput: Scalars['String']['output'];
  category: MaterialGraphIssueCategory;
  /** The exporter's own account, in its vocabulary */
  message: Scalars['String']['output'];
  /** The node the exporter stopped at, when one node is to blame */
  nodeClass?: Maybe<Scalars['String']['output']>;
  severity: MaterialGraphIssueSeverity;
};

export enum MaterialGraphIssueCategory {
  /** Only visible once the referenced textures are resolved */
  Data = 'Data',
  /** Decidable from the graph alone */
  Shape = 'Shape'
}

export enum MaterialGraphIssueSeverity {
  /** The export proceeds, carrying nothing for what the issue names */
  Advisory = 'Advisory',
  /** The export is refused until this is fixed */
  Blocking = 'Blocking'
}

export type MaterialHistory = {
  __typename: 'MaterialHistory';
  articleId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  historyChangeReason?: Maybe<Scalars['String']['output']>;
  historyDate?: Maybe<Scalars['DateTime']['output']>;
  historyType: HistoryType;
  id: Scalars['ID']['output'];
  internalName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  material?: Maybe<Material>;
  name?: Maybe<Scalars['String']['output']>;
  nextActor: NextActor;
  paymentState: PaymentState;
  public: Scalars['Boolean']['output'];
  sampleArrival?: Maybe<Scalars['DateTime']['output']>;
  state: MaterialState;
};

export type MaterialHistoryFilterInput = {
  articleId?: InputMaybe<StringInFilter>;
  comment?: InputMaybe<StringFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  historyChangeReason?: InputMaybe<StringFilterInput>;
  historyDate?: InputMaybe<DateTimeFilterInput>;
  historyType?: InputMaybe<Array<HistoryType>>;
  id?: InputMaybe<IdInFilter>;
  internalName?: InputMaybe<StringFilterInput>;
  materialId?: InputMaybe<IdInFilter>;
  meshSpecific?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<StringFilterInput>;
  nextActor?: InputMaybe<Array<NextActor>>;
  organizationId?: InputMaybe<IdInFilter>;
  paymentState?: InputMaybe<Array<PaymentState>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sampleArrival?: InputMaybe<DateTimeFilterInput>;
  state?: InputMaybe<Array<MaterialState>>;
  userId?: InputMaybe<IdInFilter>;
};

export enum MaterialHistoryOrderByCriteria {
  ArticleId = 'articleId',
  HistoryDate = 'history_date',
  Id = 'id',
  Name = 'name',
  NextActor = 'nextActor',
  PaymentState = 'paymentState',
  PriorityOrder = 'priorityOrder',
  Public = 'public',
  State = 'state'
}

export type MaterialHistoryOrderByInput = {
  direction: SortOrder;
  key: MaterialHistoryOrderByCriteria;
};

export enum MaterialOrderByCriteria {
  ArticleId = 'articleId',
  Id = 'id',
  LegacyId = 'legacyId',
  Name = 'name',
  NextActor = 'nextActor',
  PaymentState = 'paymentState',
  Priority = 'priority',
  Public = 'public',
  State = 'state'
}

export type MaterialOrderByInput = {
  direction: SortOrder;
  key: MaterialOrderByCriteria;
};

export type MaterialOutput = {
  __typename: 'MaterialOutput';
  config?: Maybe<JsonFile>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  job?: Maybe<Job>;
  material: Material;
  materialRevision?: Maybe<MaterialRevision>;
  result?: Maybe<DataObject>;
  type: MaterialOutputType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export enum MaterialOutputType {
  ConfiguraExport = 'ConfiguraExport',
  FabricOverview = 'FabricOverview',
  PbrExportCustom = 'PbrExportCustom',
  PbrExportDefaultExrOriginal = 'PbrExportDefaultExrOriginal',
  PbrExportDefaultJpegLow = 'PbrExportDefaultJpegLow',
  PbrExportDefaultJpegOriginal = 'PbrExportDefaultJpegOriginal',
  PbrExportDefaultTiffLow = 'PbrExportDefaultTiffLow',
  PbrExportDefaultTiffOriginal = 'PbrExportDefaultTiffOriginal',
  PconExport = 'PconExport',
  ShaderBall = 'ShaderBall',
  Thumbnail7x7inches = 'Thumbnail7x7inches',
  Thumbnail8x8inches = 'Thumbnail8x8inches',
  Thumbnail9x9inches = 'Thumbnail9x9inches',
  Thumbnail10x10cm = 'Thumbnail10x10cm',
  Thumbnail13_5x13_5inches = 'Thumbnail13_5x13_5inches',
  Thumbnail15x15cm = 'Thumbnail15x15cm',
  Thumbnail16x16inches = 'Thumbnail16x16inches',
  Thumbnail20x20cm = 'Thumbnail20x20cm',
  Thumbnail27x27inches = 'Thumbnail27x27inches',
  Thumbnail30x30cm = 'Thumbnail30x30cm',
  Thumbnail32x32inches = 'Thumbnail32x32inches',
  TileableImage = 'TileableImage'
}

export enum MaterialPattern {
  OrganicRandom = 'OrganicRandom',
  Other = 'Other',
  SolidUniform = 'SolidUniform',
  TiledRepetitive = 'TiledRepetitive',
  Woven = 'Woven'
}

export type MaterialReference = {
  __typename: 'MaterialReference';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  materialRevision: MaterialRevision;
  templateRevision: TemplateRevision;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type MaterialRevision = {
  __typename: 'MaterialRevision';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  exchangeNodesAndConnections: ExchangeNodesAndConnections;
  graphNode: Scalars['JsonObject']['output'];
  graphSchema?: Maybe<Scalars['String']['output']>;
  hasCyclesMaterial: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  matFileDataObject?: Maybe<DataObject>;
  material: Material;
  number: Scalars['Int']['output'];
  /** All template revisions that reference this material revision via materialReferences */
  templateRevisions: Array<Maybe<TemplateRevision>>;
  /** Count of template revisions that reference this material revision */
  templateRevisionsCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type MaterialRevisionDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type MaterialRevisionJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};

export type MaterialRevisionFilterInput = {
  comment?: InputMaybe<StringFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  createdById?: InputMaybe<IdInFilter>;
  hasCyclesMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdInFilter>;
  legacyId?: InputMaybe<IntInFilter>;
  matFileDataObjectId?: InputMaybe<IntFilterInput>;
  materialId?: InputMaybe<IdInFilter>;
  number?: InputMaybe<IntFilterInput>;
};

export enum MaterialRevisionOrderByCriteria {
  Id = 'id',
  MaterialId = 'material_id',
  Number = 'number'
}

export type MaterialRevisionOrderByInput = {
  direction: SortOrder;
  key: MaterialRevisionOrderByCriteria;
};

/** Reference from a material revision to a texture set revision, extracted from graphJson */
export type MaterialRevisionTextureSetReference = {
  __typename: 'MaterialRevisionTextureSetReference';
  materialRevision: MaterialRevision;
  textureSetRevision: TextureSetRevision;
};

export enum MaterialState {
  Completed = 'Completed',
  Draft = 'Draft',
  InfoReview = 'InfoReview',
  OnHold = 'OnHold',
  Review = 'Review',
  Scanning = 'Scanning',
  Shading = 'Shading',
  Tiling = 'Tiling'
}

export enum MaterialType {
  Ceramic = 'Ceramic',
  ConcreteAndAsphalt = 'ConcreteAndAsphalt',
  Fabric = 'Fabric',
  FloorOther = 'FloorOther',
  FloorTiles = 'FloorTiles',
  FloorWooden = 'FloorWooden',
  Glass = 'Glass',
  Leather = 'Leather',
  Metal = 'Metal',
  OrganicAndVegetation = 'OrganicAndVegetation',
  Other = 'Other',
  Paint = 'Paint',
  Paper = 'Paper',
  Plastic = 'Plastic',
  Rubber = 'Rubber',
  StoneMarbleGranite = 'StoneMarbleGranite',
  Wall = 'Wall',
  Wood = 'Wood'
}

export type Membership = {
  __typename: 'Membership';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  organization: Organization;
  packages: Array<Package>;
  role: MembershipRole;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  user: User;
};

export type MembershipCreateInput = {
  organizationId: Scalars['ID']['input'];
  role: MembershipRole;
};

export enum MembershipRole {
  Admin = 'Admin',
  Editor = 'Editor'
}

/** A runner-reported memory event: a warning that memory is running low, or that the task ran out of memory. */
export enum MemoryEventType {
  MemoryPressure = 'MemoryPressure',
  OutOfMemory = 'OutOfMemory'
}

/** Which memory: the machine's system RAM, or the GPU's memory. */
export enum MemoryKind {
  Gpu = 'Gpu',
  System = 'System'
}

/** The memory a runner found available when it started a task, in MiB: the limits only, nothing used yet. */
export type MemoryLimitsInput = {
  /** The GPU's total memory. */
  gpuMb?: InputMaybe<Scalars['Float']['input']>;
  /** The system RAM limit that would kill the task (a container cap, or the machine's RAM). */
  systemMb?: InputMaybe<Scalars['Float']['input']>;
};

/** How system RAM 'used' was measured. Exact: the kernel's high-watermark for just this task. Sampled: periodic readings of the whole worker, which may miss a brief spike and may include memory retained from earlier tasks. */
export enum MemoryPrecision {
  Exact = 'Exact',
  Sampled = 'Sampled'
}

export type Model = {
  __typename: 'Model';
  activeUserAssignment?: Maybe<UserAssignment>;
  articleId?: Maybe<Scalars['String']['output']>;
  assets: Array<Asset>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  currentUserAssignment?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  galleryImage?: Maybe<DataObject>;
  id: Scalars['ID']['output'];
  internalName?: Maybe<Scalars['String']['output']>;
  jobAssignments: Array<JobAssignment>;
  jobAssignmentsCount: Scalars['Int']['output'];
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nextActor: NextActor;
  organization?: Maybe<Organization>;
  paymentState: PaymentState;
  public: Scalars['Boolean']['output'];
  shareAssignments: Array<ShareAssignment>;
  shareAssignmentsCount: Scalars['Int']['output'];
  state: ModelState;
  tagAssignments: Array<TagAssignment>;
  tagAssignmentsCount: Scalars['Int']['output'];
  taskInfos: TaskInfos;
  tasks: Array<Task>;
  type: ModelType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  userAssignments: Array<UserAssignment>;
  userAssignmentsCount: Scalars['Int']['output'];
};


export type ModelDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type ModelJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};


export type ModelShareAssignmentsArgs = {
  filter?: InputMaybe<ShareAssignmentFilterInput>;
  orderBy?: InputMaybe<ShareAssignmentOrderByInput>;
};


export type ModelTagAssignmentsArgs = {
  tagTypes?: InputMaybe<Array<TagType>>;
};


export type ModelUserAssignmentsArgs = {
  filter?: InputMaybe<UserAssignmentFilterInput>;
};

export type ModelFilterInput = {
  hasAssignedUser?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdInFilter>;
  legacyId?: InputMaybe<IntInFilter>;
  nextActor?: InputMaybe<Array<NextActor>>;
  organizationId?: InputMaybe<IdInFilter>;
  organizationLegacyId?: InputMaybe<IntInFilter>;
  paymentState?: InputMaybe<Array<PaymentState>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<ModelState>>;
  tagId?: InputMaybe<IdInFilter>;
  userId?: InputMaybe<IdInFilter>;
};

export type ModelHistory = {
  __typename: 'ModelHistory';
  articleId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  historyChangeReason?: Maybe<Scalars['String']['output']>;
  historyDate?: Maybe<Scalars['DateTime']['output']>;
  historyType: HistoryType;
  id: Scalars['ID']['output'];
  internalName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  model?: Maybe<Model>;
  name?: Maybe<Scalars['String']['output']>;
  nextActor: NextActor;
  organization?: Maybe<Organization>;
  paymentState: PaymentState;
  public: Scalars['Boolean']['output'];
  state: ModelState;
  type: ModelType;
};

export type ModelHistoryFilterInput = {
  articleId?: InputMaybe<StringInFilter>;
  comment?: InputMaybe<StringFilterInput>;
  date?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  historyChangeReason?: InputMaybe<StringFilterInput>;
  historyDate?: InputMaybe<DateTimeFilterInput>;
  historyType?: InputMaybe<Array<HistoryType>>;
  id?: InputMaybe<IdInFilter>;
  internalName?: InputMaybe<StringFilterInput>;
  modelId?: InputMaybe<IdInFilter>;
  name?: InputMaybe<StringFilterInput>;
  nextActor?: InputMaybe<Array<NextActor>>;
  organizationId?: InputMaybe<IdInFilter>;
  paymentState?: InputMaybe<Array<PaymentState>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Array<ModelState>>;
  type?: InputMaybe<Array<ModelType>>;
  userId?: InputMaybe<IdInFilter>;
};

export enum ModelHistoryOrderByCriteria {
  ArticleId = 'articleId',
  HistoryDate = 'history_date',
  Id = 'id',
  Name = 'name',
  NextActor = 'nextActor',
  PaymentState = 'paymentState',
  PriorityOrder = 'priorityOrder',
  Public = 'public',
  State = 'state'
}

export type ModelHistoryOrderByInput = {
  direction: SortOrder;
  key: ModelHistoryOrderByCriteria;
};

export enum ModelOrderByCriteria {
  Id = 'id',
  LegacyId = 'legacyId',
  Name = 'name',
  PaymentState = 'paymentState',
  Priority = 'priority',
  Public = 'public',
  State = 'state'
}

export type ModelOrderByInput = {
  direction: SortOrder;
  key: ModelOrderByCriteria;
};

export enum ModelState {
  Completed = 'Completed',
  Draft = 'Draft',
  InfoReview = 'InfoReview',
  Modelling = 'Modelling',
  OnHold = 'OnHold',
  Review = 'Review'
}

export enum ModelType {
  Product = 'Product',
  Scene = 'Scene'
}

export type Mutation = {
  __typename: 'Mutation';
  batchUpdateArStatistics: Scalars['Int']['output'];
  batchUpdateAssets: Scalars['Int']['output'];
  batchUpdateDataObjectAssignments: Scalars['Int']['output'];
  batchUpdateMaterials: Scalars['Int']['output'];
  batchUpdateModels: Scalars['Int']['output'];
  batchUpdatePictures: Scalars['Int']['output'];
  batchUpdateRenderJobs: Scalars['Int']['output'];
  batchUpdateSceneStatistics: Scalars['Int']['output'];
  /** Mark as cancelled and process job graph */
  cancelJob: Job;
  /** Trigger AI-powered categorization for a material using Gemini Vision */
  categorizeMaterialWithAi: Material;
  /** Find an unclaimed, runnable job task matching filter criteria and claim it for processing */
  claimRunnableJobTask?: Maybe<JobTask>;
  /** Claim a specific task for processing. Failed tasks can be retried if claimed this way. */
  claimTask?: Maybe<JobTask>;
  cloneScanJobForRefitting: ScanJob;
  /** Mark as completed and resynchronize data object assignments of type `JobTaskData` */
  completeJobTask: JobTask;
  /** Complete user onboarding questionnaire */
  completeOnboarding: CompleteOnboardingResult;
  configuratorCreateDataObjectAssignment: ConfiguratorArAssignment;
  configuratorCreateJob: ConfiguratorArJob;
  /** Generate AR files (GLTF + USDZ) for a template revision. Uses configurator-level authorization. */
  configuratorGenerateAr: ConfiguratorArJob;
  copyMaterial: Material;
  copyTemplate: Template;
  createArStatistics: ArStatistics;
  createAsset: Asset;
  createCheckoutSession: Scalars['String']['output'];
  createDataObject: DataObject;
  createDataObjectAssignment: DataObjectAssignment;
  /** Create and start a job to generate thumbnails for a data object. */
  createDataObjectThumbnails: Job;
  createHdri: Hdri;
  createImageTilesDescriptor: ImageTilesDescriptor;
  /** Create a new job and start it straightaway */
  createJob: Job;
  createJobAssignment: JobAssignment;
  createJobFarmGroup: JobFarmGroup;
  createJobFarmInstance: JobFarmInstance;
  /** Create a single job task. Useful for tests. */
  createJobTask: JobTask;
  createJobTaskAssignment: JobTaskAssignment;
  createJobTaskType: JobTaskType;
  createJsonFile: JsonFile;
  createJsonFileAssignment: JsonFileAssignment;
  createMaterial: Material;
  createMaterialAssignment: MaterialAssignment;
  createMaterialOutput: MaterialOutput;
  createMaterialReference: MaterialReference;
  createMaterialRevisionFromExchangeNodesAndConnections: MaterialRevision;
  createMaterialRevisionFromGraphNode: MaterialRevision;
  createMembership: Membership;
  createModel: Model;
  createOrUpdateMaterial: Material;
  createOrUpdateMaterialBd: Material;
  createOrUpdatePrices?: Maybe<Scalars['Void']['output']>;
  createOrganization: Organization;
  createOrganizationGroup: OrganizationGroup;
  createPicture: Picture;
  createPictureAssetAssignment: PictureAssetAssignment;
  createPictureRevision: PictureRevision;
  createPriceGraph: PriceGraph;
  createPrices: Scalars['Void']['output'];
  createProject: Project;
  createRenderJob: RenderJob;
  createSalesEnquiry: SalesEnquiry;
  createScanJob: ScanJob;
  createScanSubJob: ScanSubJob;
  createScene: Scene;
  createSceneRevision: SceneRevision;
  createSceneStatistics: SceneStatistics;
  createSet: Set;
  createStorageDeleteTask: StorageDeleteTask;
  createStripeBillingPortalSession: Scalars['String']['output'];
  createTag: Tag;
  createTagAssignment: TagAssignment;
  createTask: Task;
  createTaskComment: TaskComment;
  createTaskPin: TaskPin;
  createTemplate: Template;
  createTemplateRevision: TemplateRevision;
  createTexture: Texture;
  createTextureEditGroup: TextureEditGroup;
  createTextureGroup: TextureGroup;
  createTextureRevision: TextureRevision;
  createTextureSet: TextureSet;
  createTextureSetRevision: TextureSetRevision;
  /** Create and start a job to generate thumbnails for a texture set revision. */
  createTextureSetRevisionThumbnails: Job;
  /** Create and start a job to generate thumbnails for a typed set of data objects. */
  createTypedDataObjectSetThumbnails: Job;
  /** Create a raw job without starting it. Useful for tests and other cases that require tight control of the job's state. */
  createUnstartedJob: Job;
  createUser: User;
  createUserAssignment: UserAssignment;
  deleteArStatistics?: Maybe<Scalars['Void']['output']>;
  deleteAsset?: Maybe<Scalars['Void']['output']>;
  deleteConfiguraMaterialDatabaseProfile?: Maybe<Scalars['Void']['output']>;
  deleteDataObject?: Maybe<Scalars['Void']['output']>;
  deleteDataObjectAssignment?: Maybe<Scalars['Void']['output']>;
  deleteDataObjectAssignments: Scalars['Int']['output'];
  deleteHdri?: Maybe<Scalars['Void']['output']>;
  deleteIdFromCustomerToPriceGraph?: Maybe<Scalars['Void']['output']>;
  deleteImageTilesDescriptor?: Maybe<Scalars['Void']['output']>;
  deleteJobAssignment?: Maybe<Scalars['Void']['output']>;
  deleteJobFarmGroup?: Maybe<Scalars['Void']['output']>;
  deleteJobFarmInstance?: Maybe<Scalars['Void']['output']>;
  deleteJobTaskAssignment?: Maybe<Scalars['Void']['output']>;
  deleteJobTaskType?: Maybe<Scalars['Void']['output']>;
  deleteJsonFile?: Maybe<Scalars['Void']['output']>;
  deleteJsonFileAssignment?: Maybe<Scalars['Void']['output']>;
  deleteMaterial?: Maybe<Scalars['Void']['output']>;
  deleteMaterialAssignment?: Maybe<Scalars['Void']['output']>;
  deleteMaterialBd?: Maybe<Scalars['Void']['output']>;
  deleteMaterialByArticleId?: Maybe<Scalars['Void']['output']>;
  deleteMaterialOutput?: Maybe<Scalars['Void']['output']>;
  deleteMaterialReference?: Maybe<Scalars['Void']['output']>;
  deleteMaterialRevision?: Maybe<Scalars['Void']['output']>;
  deleteMembership?: Maybe<Scalars['Void']['output']>;
  deleteModel?: Maybe<Scalars['Void']['output']>;
  deleteOrganization?: Maybe<Scalars['Void']['output']>;
  deleteOrganizationGroup?: Maybe<Scalars['Void']['output']>;
  deletePicture?: Maybe<Scalars['Void']['output']>;
  deletePictureAssetAssignment?: Maybe<Scalars['Void']['output']>;
  deletePictureRevision?: Maybe<Scalars['Void']['output']>;
  deletePriceGraph?: Maybe<Scalars['Void']['output']>;
  deletePrices?: Maybe<Scalars['Void']['output']>;
  deleteProject?: Maybe<Scalars['Void']['output']>;
  deleteRenderJob?: Maybe<Scalars['Void']['output']>;
  deleteSalesEnquiry?: Maybe<Scalars['Void']['output']>;
  deleteScanJob?: Maybe<Scalars['Void']['output']>;
  deleteScanSubJob?: Maybe<Scalars['Void']['output']>;
  deleteScene?: Maybe<Scalars['Void']['output']>;
  deleteSceneRevision?: Maybe<Scalars['Void']['output']>;
  deleteSceneStatistics?: Maybe<Scalars['Void']['output']>;
  deleteSet?: Maybe<Scalars['Void']['output']>;
  deleteStorageDeleteTask?: Maybe<Scalars['Void']['output']>;
  deleteTag?: Maybe<Scalars['Void']['output']>;
  deleteTagAssignment?: Maybe<Scalars['Void']['output']>;
  deleteTask?: Maybe<Scalars['Void']['output']>;
  deleteTaskComment?: Maybe<Scalars['Void']['output']>;
  deleteTaskPin?: Maybe<Scalars['Void']['output']>;
  deleteTemplate?: Maybe<Scalars['Void']['output']>;
  deleteTemplateRevision?: Maybe<Scalars['Void']['output']>;
  deleteTexture?: Maybe<Scalars['Void']['output']>;
  deleteTextureEditGroup?: Maybe<Scalars['Void']['output']>;
  deleteTextureGroup?: Maybe<Scalars['Void']['output']>;
  deleteTextureRevision?: Maybe<Scalars['Void']['output']>;
  deleteTextureSet?: Maybe<Scalars['Void']['output']>;
  deleteTextureSetRevision: TextureSetRevision;
  deleteUser?: Maybe<Scalars['Void']['output']>;
  deleteUserAssignment?: Maybe<Scalars['Void']['output']>;
  deleteUserAssignments: Scalars['Int']['output'];
  /** Retire a job from its assignment slot so a replacement can take it, without deleting it. A finished job (Complete/Failed) keeps its state and output — only marked discarded; a still-running job is cancelled as well. Either way `discarded` is set and the job stays on record. Discarding an already discarded job is a no-op. Requires `cancel` for a live job and `delete` for a finished one. */
  discardJobTask: Job;
  /** Permanently dismiss the self-service starting/tutorials screen for the current user. */
  dismissStartingScreen: User;
  endTrialNow: Organization;
  /** Ensure the material has a Configura export generated from its latest cycles revision. Publishing ensures one as part of its own flow, so this is for generating an export outside it. */
  ensureConfiguraExport: MaterialExportResult;
  /** Ensure the material has the given PBR export generated from its latest cycles revision. The outcome says what happened: a generation job to wait for, nothing to do, or a refusal naming what to fix. A custom export is identified by its settings, so requesting the same five twice ensures one export rather than creating a second. */
  ensurePbrExport: MaterialExportResult;
  ensurePbrExportBatch: Array<MaterialExportBatchEntry>;
  /** Ensure the material has a pCon export generated from its latest cycles revision. The outcome says what happened: a generation job to wait for, nothing to do, or a refusal naming what to fix. */
  ensurePconExport: MaterialExportResult;
  ensurePconExportBatch: Array<MaterialExportBatchEntry>;
  /** Mark job task as failed */
  failJobTask: JobTask;
  /** Generate an API key for an API service user. Use in `X-Api-Key` header to authenticate API users. This type of key does not expire and should be rotated regularly. */
  generateApiKey: Scalars['String']['output'];
  /** Generate AR files (GLTF + USDZ) for a template revision. */
  generateAr: Job;
  importTextureSet: TextureSet;
  inviteUser: User;
  /** Complete an SSO login using the authorization code and state returned by the identity provider. */
  logInViaSso: LoginResult;
  /** Log in a user. Select the `token` field to get a JWT token for authentication. */
  login: LoginResult;
  /** Mark a running job task as preempted (spot VM termination, MIG-initiated shutdown). Retries identically to Failed. */
  markJobTaskAsPreempted: JobTask;
  /** Trigger job graph processing for all active jobs to advance them more quickly */
  nudgeAllJobs: Scalars['Int']['output'];
  /** Trigger job graph processing to advance the job more quickly */
  nudgeJob: Job;
  pinMaterialImage: DataObject;
  /** Create and start a job to generate thumbnails and set metadata for a completed upload. */
  processUpload: Job;
  recordConfiguraMaterialDatabaseBindingPublish: ConfiguraMaterialDatabaseBinding;
  /** Record a runner-reported memory event for a task (MemoryPressure or OutOfMemory) with its memory statistics. Records an event only; it does not change task state. */
  recordJobTaskMemoryEvent?: Maybe<JobTask>;
  /** Register a new user with email and password */
  registerUser: RegisterUserResult;
  /** Register a new user via SSO (Google/Microsoft). Names are collected during onboarding. */
  registerUserSso: RegisterUserSsoResult;
  /** Delete and recreate all child tasks, then restart the job */
  rerunAllTasksInJob: Job;
  /** Resend verification email */
  resendVerificationEmail: Scalars['Boolean']['output'];
  /** Restore a job's priority to the default it would have been created with — its creator's default, or their organization's. Distinct from `updateJob(priority: 0)`, which pins the job to zero: for a deprioritized creator, zero is a promotion. */
  resetJobPriority: Job;
  resetPassword: Scalars['String']['output'];
  /** Reprocess job from the top, keeping completed tasks */
  restartJob: Job;
  /** Save onboarding progress without completing onboarding */
  saveOnboardingProgress: Scalars['Boolean']['output'];
  sendPasswordResetEmail: Scalars['Boolean']['output'];
  setConfiguraMaterialDatabaseProfile: ConfiguraMaterialDatabaseProfile;
  setMaterialShaderBallImage: MaterialOutput;
  startFreeTrial: Organization;
  /** Begin an SSO login for the given tenant slug. Returns the identity provider's authorization URL to redirect the user to, or null if the slug is not a configured SSO tenant. */
  startSsoLogin?: Maybe<Scalars['String']['output']>;
  triggerConfiguraMaterialDatabasePublish: ConfiguraMaterialDatabasePublishResult;
  triggerConfiguraMaterialDatabasePublishBatch: Array<ConfiguraMaterialDatabasePublishBatchEntry>;
  unpinMaterialImage: Scalars['Boolean']['output'];
  updateArStatistics: ArStatistics;
  updateAsset: Asset;
  updateDataObject: DataObject;
  updateDataObjectAssignment: DataObjectAssignment;
  updateHdri: Hdri;
  updateImageTilesDescriptor: ImageTilesDescriptor;
  updateJob: Job;
  updateJobAssignment: JobAssignment;
  updateJobFarmGroup: JobFarmGroup;
  updateJobFarmInstance: JobFarmInstance;
  updateJobTask: JobTask;
  updateJobTaskAssignment: JobTaskAssignment;
  /** Pin a child job task to a specific resource group, overriding the cascade's placement. JobsV2 only — the coordinator starts placement here; v1-invoked tasks ignore it. Staff only. Pass null to clear the pin. */
  updateJobTaskResourceGroup: JobTask;
  updateJobTaskType: JobTaskType;
  updateJsonFile: JsonFile;
  updateJsonFileAssignment: JsonFileAssignment;
  updateMaterial: Material;
  updateMaterialOutput: MaterialOutput;
  updateMaterialOutputByJob: MaterialOutput;
  updateMaterialReference: MaterialReference;
  updateMaterialRevision: MaterialRevision;
  updateModel: Model;
  updateOrganization: Organization;
  updateOrganizationGroup: OrganizationGroup;
  updatePicture: Picture;
  updatePictureRevision: PictureRevision;
  updatePriceGraph: PriceGraph;
  updatePrices: Scalars['Void']['output'];
  updateProject: Project;
  updateRenderJob: RenderJob;
  updateScanJob: ScanJob;
  updateScanSubJob: ScanSubJob;
  updateScene: Scene;
  updateSceneRevision: SceneRevision;
  updateSceneStatistics: SceneStatistics;
  updateSet: Set;
  updateStorageDeleteTask: StorageDeleteTask;
  updateTag: Tag;
  updateTagAssignment: TagAssignment;
  updateTask: Task;
  updateTaskComment: TaskComment;
  updateTaskPin: TaskPin;
  updateTemplate: Template;
  updateTemplateRevision: TemplateRevision;
  updateTexture: Texture;
  updateTextureEditGroup: TextureEditGroup;
  updateTextureGroup: TextureGroup;
  updateTextureRevision: TextureRevision;
  updateTextureSet: TextureSet;
  updateTextureSetRevision: TextureSetRevision;
  updateUser: User;
  updateUserAssignment: UserAssignment;
  /** Verify user email address */
  verifyEmail: VerifyEmailResult;
  /** Log in a user using an access token from the Google/Microsoft OAuth server. */
  verifyExternalLogin: LoginResult;
};


export type MutationBatchUpdateArStatisticsArgs = {
  filter?: InputMaybe<ArStatisticsFilterInput>;
  templateRevisionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationBatchUpdateAssetsArgs = {
  addTagId?: InputMaybe<Scalars['ID']['input']>;
  assignUserId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AssetFilterInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  nextActor?: InputMaybe<NextActor>;
  removeTagId?: InputMaybe<Scalars['ID']['input']>;
  removeUserAssignment?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<AssetState>;
};


export type MutationBatchUpdateDataObjectAssignmentsArgs = {
  contentTypeModel: ContentTypeModel;
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  objectId: Scalars['ID']['input'];
};


export type MutationBatchUpdateMaterialsArgs = {
  addTagId?: InputMaybe<Scalars['ID']['input']>;
  assignUserId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<MaterialFilterInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  nextActor?: InputMaybe<NextActor>;
  paymentState?: InputMaybe<PaymentState>;
  removeTagId?: InputMaybe<Scalars['ID']['input']>;
  removeUserAssignment?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<MaterialState>;
};


export type MutationBatchUpdateModelsArgs = {
  addTagId?: InputMaybe<Scalars['ID']['input']>;
  assignUserId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<ModelFilterInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  nextActor?: InputMaybe<NextActor>;
  paymentState?: InputMaybe<PaymentState>;
  removeTagId?: InputMaybe<Scalars['ID']['input']>;
  removeUserAssignment?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<ModelState>;
};


export type MutationBatchUpdatePicturesArgs = {
  addTagId?: InputMaybe<Scalars['ID']['input']>;
  assignUserId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<PictureFilterInput>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  nextActor?: InputMaybe<NextActor>;
  paymentState?: InputMaybe<PaymentState>;
  removeTagId?: InputMaybe<Scalars['ID']['input']>;
  removeUserAssignment?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<PictureState>;
};


export type MutationBatchUpdateRenderJobsArgs = {
  filter?: InputMaybe<RenderJobFilterInput>;
  templateRevisionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationBatchUpdateSceneStatisticsArgs = {
  filter?: InputMaybe<SceneStatisticsFilterInput>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCancelJobArgs = {
  id: Scalars['ID']['input'];
  instanceId?: InputMaybe<Scalars['String']['input']>;
  queueToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCategorizeMaterialWithAiArgs = {
  id: Scalars['ID']['input'];
};


export type MutationClaimRunnableJobTaskArgs = {
  filter: JobTaskRunnableFilterInput;
  instanceId: Scalars['String']['input'];
  memoryLimits?: InputMaybe<MemoryLimitsInput>;
  updateTimeout: Scalars['Int']['input'];
};


export type MutationClaimTaskArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  instanceId: Scalars['String']['input'];
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  memoryLimits?: InputMaybe<MemoryLimitsInput>;
  queueGroup: Scalars['String']['input'];
  queueToken?: InputMaybe<Scalars['String']['input']>;
  updateTimeout: Scalars['Int']['input'];
};


export type MutationCloneScanJobForRefittingArgs = {
  input: MutationCloneScanJobForRefittingInput;
};


export type MutationCompleteJobTaskArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  memoryStats?: InputMaybe<JobTaskMemoryStatsInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  output: Scalars['Json']['input'];
  queueToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCompleteOnboardingArgs = {
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  has3dExperience?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  newsletterOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationConfiguratorCreateDataObjectAssignmentArgs = {
  input: MutationConfiguratorCreateDataObjectAssignmentInput;
};


export type MutationConfiguratorCreateJobArgs = {
  input: MutationConfiguratorCreateJobInput;
};


export type MutationConfiguratorGenerateArArgs = {
  input: MutationConfiguratorGenerateArInput;
};


export type MutationCopyMaterialArgs = {
  materialId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCopyTemplateArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreateArStatisticsArgs = {
  input: MutationCreateArStatisticsInput;
};


export type MutationCreateAssetArgs = {
  input: MutationCreateAssetInput;
};


export type MutationCreateCheckoutSessionArgs = {
  input: MutationCreateCheckoutSessionInput;
};


export type MutationCreateDataObjectArgs = {
  input?: InputMaybe<MutationCreateDataObjectInput>;
};


export type MutationCreateDataObjectAssignmentArgs = {
  input: MutationCreateDataObjectAssignmentInput;
};


export type MutationCreateDataObjectThumbnailsArgs = {
  awaitScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  dataObjectId?: InputMaybe<Scalars['ID']['input']>;
  dataObjectLegacyId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<ThumbnailOptionsInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationLegacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateHdriArgs = {
  input: MutationCreateHdriInput;
};


export type MutationCreateImageTilesDescriptorArgs = {
  input?: InputMaybe<MutationCreateImageTilesDescriptorInput>;
};


export type MutationCreateJobArgs = {
  input: MutationCreateJobInput;
};


export type MutationCreateJobAssignmentArgs = {
  input: MutationCreateJobAssignmentInput;
};


export type MutationCreateJobFarmGroupArgs = {
  input: MutationCreateJobFarmGroupInput;
};


export type MutationCreateJobFarmInstanceArgs = {
  input: MutationCreateJobFarmInstanceInput;
};


export type MutationCreateJobTaskArgs = {
  input: MutationCreateJobTaskInput;
};


export type MutationCreateJobTaskAssignmentArgs = {
  input: MutationCreateJobTaskAssignmentInput;
};


export type MutationCreateJobTaskTypeArgs = {
  input: MutationCreateJobTaskTypeInput;
};


export type MutationCreateJsonFileArgs = {
  input: MutationCreateJsonFileInput;
};


export type MutationCreateJsonFileAssignmentArgs = {
  input: MutationCreateJsonFileAssignmentInput;
};


export type MutationCreateMaterialArgs = {
  input: MutationCreateMaterialInput;
};


export type MutationCreateMaterialAssignmentArgs = {
  input: MutationCreateMaterialAssignmentInput;
};


export type MutationCreateMaterialOutputArgs = {
  input: MutationCreateMaterialOutputInput;
};


export type MutationCreateMaterialReferenceArgs = {
  input: MutationCreateMaterialReferenceInput;
};


export type MutationCreateMaterialRevisionFromExchangeNodesAndConnectionsArgs = {
  input: MutationCreateMaterialRevisionFromExchangeNodesAndConnectionsInput;
};


export type MutationCreateMaterialRevisionFromGraphNodeArgs = {
  input: MutationCreateMaterialRevisionFromGraphNodeInput;
};


export type MutationCreateMembershipArgs = {
  input: MutationCreateMembershipInput;
};


export type MutationCreateModelArgs = {
  input: MutationCreateModelInput;
};


export type MutationCreateOrUpdateMaterialArgs = {
  input: MutationCreateOrUpdateMaterialInput;
};


export type MutationCreateOrUpdateMaterialBdArgs = {
  input: MutationCreateOrUpdateMaterialBdInput;
};


export type MutationCreateOrUpdatePricesArgs = {
  organizationId: Scalars['ID']['input'];
  prices: Array<PriceInput>;
};


export type MutationCreateOrganizationArgs = {
  input: MutationCreateOrganizationInput;
};


export type MutationCreateOrganizationGroupArgs = {
  input: MutationCreateOrganizationGroupInput;
};


export type MutationCreatePictureArgs = {
  input: MutationCreatePictureInput;
};


export type MutationCreatePictureAssetAssignmentArgs = {
  input: MutationCreatePictureAssetAssignmentInput;
};


export type MutationCreatePictureRevisionArgs = {
  input: MutationCreatePictureRevisionInput;
};


export type MutationCreatePriceGraphArgs = {
  input: MutationCreatePriceGraphInput;
};


export type MutationCreatePricesArgs = {
  organizationId: Scalars['ID']['input'];
  prices: Array<PriceInput>;
};


export type MutationCreateProjectArgs = {
  input: MutationCreateProjectInput;
};


export type MutationCreateRenderJobArgs = {
  input: MutationCreateRenderJobInput;
};


export type MutationCreateSalesEnquiryArgs = {
  input: MutationCreateSalesEnquiryInput;
};


export type MutationCreateScanJobArgs = {
  input: MutationCreateScanJobInput;
};


export type MutationCreateScanSubJobArgs = {
  input: MutationCreateScanSubJobInput;
};


export type MutationCreateSceneArgs = {
  input: MutationCreateSceneInput;
};


export type MutationCreateSceneRevisionArgs = {
  input: MutationCreateSceneRevisionInput;
};


export type MutationCreateSceneStatisticsArgs = {
  input: MutationCreateSceneStatisticsInput;
};


export type MutationCreateSetArgs = {
  input: MutationCreateSetInput;
};


export type MutationCreateStorageDeleteTaskArgs = {
  input: MutationCreateStorageDeleteTaskInput;
};


export type MutationCreateStripeBillingPortalSessionArgs = {
  organizationId: Scalars['ID']['input'];
  returnUrlPath?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTagArgs = {
  input: MutationCreateTagInput;
};


export type MutationCreateTagAssignmentArgs = {
  input: MutationCreateTagAssignmentInput;
};


export type MutationCreateTaskArgs = {
  input: MutationCreateTaskInput;
};


export type MutationCreateTaskCommentArgs = {
  input: MutationCreateTaskCommentInput;
};


export type MutationCreateTaskPinArgs = {
  input: MutationCreateTaskPinInput;
};


export type MutationCreateTemplateArgs = {
  input: MutationCreateTemplateInput;
};


export type MutationCreateTemplateRevisionArgs = {
  input: MutationCreateTemplateRevisionInput;
};


export type MutationCreateTextureArgs = {
  input: MutationCreateTextureInput;
};


export type MutationCreateTextureEditGroupArgs = {
  input: MutationCreateTextureEditGroupInput;
};


export type MutationCreateTextureGroupArgs = {
  input: MutationCreateTextureGroupInput;
};


export type MutationCreateTextureRevisionArgs = {
  input: MutationCreateTextureRevisionInput;
};


export type MutationCreateTextureSetArgs = {
  input: MutationCreateTextureSetInput;
};


export type MutationCreateTextureSetRevisionArgs = {
  input: MutationCreateTextureSetRevisionInput;
};


export type MutationCreateTextureSetRevisionThumbnailsArgs = {
  awaitScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<ThumbnailOptionsInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationLegacyId?: InputMaybe<Scalars['Int']['input']>;
  textureSetRevisionId: Scalars['ID']['input'];
};


export type MutationCreateTypedDataObjectSetThumbnailsArgs = {
  awaitScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<ThumbnailOptionsInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationLegacyId?: InputMaybe<Scalars['Int']['input']>;
  typedDataObjectSet: Array<TypedDataObjectInput>;
};


export type MutationCreateUnstartedJobArgs = {
  input: MutationCreateUnstartedJobInput;
};


export type MutationCreateUserArgs = {
  input: MutationCreateUserInput;
};


export type MutationCreateUserAssignmentArgs = {
  input: MutationCreateUserAssignmentInput;
};


export type MutationDeleteArStatisticsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAssetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteConfiguraMaterialDatabaseProfileArgs = {
  organizationId: Scalars['ID']['input'];
};


export type MutationDeleteDataObjectArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteDataObjectAssignmentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteDataObjectAssignmentsArgs = {
  input: MutationDeleteDataObjectAssignmentsInput;
};


export type MutationDeleteHdriArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteIdFromCustomerToPriceGraphArgs = {
  priceGraphId: Scalars['ID']['input'];
};


export type MutationDeleteImageTilesDescriptorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJobAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJobFarmGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJobFarmInstanceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJobTaskAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJobTaskTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJsonFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDeleteJsonFileAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMaterialArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMaterialAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMaterialBdArgs = {
  articleId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteMaterialByArticleIdArgs = {
  articleId: Scalars['String']['input'];
};


export type MutationDeleteMaterialOutputArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMaterialReferenceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMaterialRevisionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMembershipArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteModelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteOrganizationGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePictureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePictureAssetAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePictureRevisionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePriceGraphArgs = {
  priceGraphId: Scalars['ID']['input'];
};


export type MutationDeletePricesArgs = {
  organizationId: Scalars['ID']['input'];
  originalIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRenderJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSalesEnquiryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteScanJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteScanSubJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSceneArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSceneRevisionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSceneStatisticsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStorageDeleteTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTagArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteTagAssignmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaskPinArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTemplateRevisionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTextureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTextureEditGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTextureGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTextureRevisionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTextureSetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTextureSetRevisionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserAssignmentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteUserAssignmentsArgs = {
  input: MutationDeleteUserAssignmentsInput;
};


export type MutationDiscardJobTaskArgs = {
  id: Scalars['ID']['input'];
  instanceId?: InputMaybe<Scalars['String']['input']>;
  queueToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEndTrialNowArgs = {
  input: MutationEndTrialNowInput;
};


export type MutationEnsureConfiguraExportArgs = {
  materialId: Scalars['ID']['input'];
};


export type MutationEnsurePbrExportArgs = {
  materialId: Scalars['ID']['input'];
  settings?: InputMaybe<PbrExportSettingsInput>;
  type: PbrExportType;
};


export type MutationEnsurePbrExportBatchArgs = {
  input: MutationEnsurePbrExportBatchInput;
};


export type MutationEnsurePconExportArgs = {
  materialId: Scalars['ID']['input'];
};


export type MutationEnsurePconExportBatchArgs = {
  input: MutationEnsurePconExportBatchInput;
};


export type MutationFailJobTaskArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
  isFatal?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  memoryStats?: InputMaybe<JobTaskMemoryStatsInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  queueToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateApiKeyArgs = {
  input: MutationGenerateApiKeyInput;
};


export type MutationGenerateArArgs = {
  assignmentKey: Scalars['String']['input'];
  awaitScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationLegacyId?: InputMaybe<Scalars['Int']['input']>;
  templateParametersBase64: Scalars['String']['input'];
  templateRevisionId: Scalars['ID']['input'];
};


export type MutationImportTextureSetArgs = {
  input: MutationImportTextureSetInput;
};


export type MutationInviteUserArgs = {
  input: MutationInviteUserInput;
};


export type MutationLogInViaSsoArgs = {
  input: MutationLogInViaSsoInput;
};


export type MutationLoginArgs = {
  input: MutationLoginInput;
};


export type MutationMarkJobTaskAsPreemptedArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  queueToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationNudgeJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPinMaterialImageArgs = {
  input: MutationPinMaterialImageInput;
};


export type MutationProcessUploadArgs = {
  awaitScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  dataObjectId: Scalars['String']['input'];
  options?: InputMaybe<ProcessUploadOptionsInput>;
};


export type MutationRecordConfiguraMaterialDatabaseBindingPublishArgs = {
  input: MutationRecordConfiguraMaterialDatabaseBindingPublishInput;
};


export type MutationRecordJobTaskMemoryEventArgs = {
  eventType: MemoryEventType;
  id?: InputMaybe<Scalars['ID']['input']>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  queueToken?: InputMaybe<Scalars['String']['input']>;
  stats: JobTaskMemoryStatsInput;
};


export type MutationRegisterUserArgs = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};


export type MutationRegisterUserSsoArgs = {
  code: Scalars['String']['input'];
  provider: LoginProvider;
};


export type MutationRerunAllTasksInJobArgs = {
  awaitScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  instanceId?: InputMaybe<Scalars['String']['input']>;
  queueToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResendVerificationEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationResetJobPriorityArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  input: MutationResetPasswordInput;
};


export type MutationRestartJobArgs = {
  awaitScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  graph?: InputMaybe<Scalars['Json']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationSaveOnboardingProgressArgs = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  has3dExperience?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  newsletterOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendPasswordResetEmailArgs = {
  input: MutationSendPasswordResetEmailInput;
};


export type MutationSetConfiguraMaterialDatabaseProfileArgs = {
  input: MutationSetConfiguraMaterialDatabaseProfileInput;
};


export type MutationSetMaterialShaderBallImageArgs = {
  input: MutationSetMaterialShaderBallImageInput;
};


export type MutationStartFreeTrialArgs = {
  input: MutationStartFreeTrialInput;
};


export type MutationStartSsoLoginArgs = {
  input: MutationStartSsoLoginInput;
};


export type MutationTriggerConfiguraMaterialDatabasePublishArgs = {
  input: MutationTriggerConfiguraMaterialDatabasePublishInput;
};


export type MutationTriggerConfiguraMaterialDatabasePublishBatchArgs = {
  input: MutationTriggerConfiguraMaterialDatabasePublishBatchInput;
};


export type MutationUnpinMaterialImageArgs = {
  input: MutationUnpinMaterialImageInput;
};


export type MutationUpdateArStatisticsArgs = {
  input: MutationUpdateArStatisticsInput;
};


export type MutationUpdateAssetArgs = {
  input: MutationUpdateAssetInput;
};


export type MutationUpdateDataObjectArgs = {
  input: MutationUpdateDataObjectInput;
};


export type MutationUpdateDataObjectAssignmentArgs = {
  input: MutationUpdateDataObjectAssignmentInput;
};


export type MutationUpdateHdriArgs = {
  input: MutationUpdateHdriInput;
};


export type MutationUpdateImageTilesDescriptorArgs = {
  input: MutationUpdateImageTilesDescriptorInput;
};


export type MutationUpdateJobArgs = {
  input: MutationUpdateJobInput;
};


export type MutationUpdateJobAssignmentArgs = {
  input: MutationUpdateJobAssignmentInput;
};


export type MutationUpdateJobFarmGroupArgs = {
  input: MutationUpdateJobFarmGroupInput;
};


export type MutationUpdateJobFarmInstanceArgs = {
  input: MutationUpdateJobFarmInstanceInput;
};


export type MutationUpdateJobTaskArgs = {
  input: MutationUpdateJobTaskInput;
};


export type MutationUpdateJobTaskAssignmentArgs = {
  input: MutationUpdateJobTaskAssignmentInput;
};


export type MutationUpdateJobTaskResourceGroupArgs = {
  input: MutationUpdateJobTaskResourceGroupInput;
};


export type MutationUpdateJobTaskTypeArgs = {
  input: MutationUpdateJobTaskTypeInput;
};


export type MutationUpdateJsonFileArgs = {
  input: MutationUpdateJsonFileInput;
};


export type MutationUpdateJsonFileAssignmentArgs = {
  input: MutationUpdateJsonFileAssignmentInput;
};


export type MutationUpdateMaterialArgs = {
  input: MutationUpdateMaterialInput;
};


export type MutationUpdateMaterialOutputArgs = {
  input: MutationUpdateMaterialOutputInput;
};


export type MutationUpdateMaterialOutputByJobArgs = {
  input: MutationUpdateMaterialOutputByJobInput;
};


export type MutationUpdateMaterialReferenceArgs = {
  input: MutationUpdateMaterialReferenceInput;
};


export type MutationUpdateMaterialRevisionArgs = {
  input: MutationUpdateMaterialRevisionInput;
};


export type MutationUpdateModelArgs = {
  input: MutationUpdateModelInput;
};


export type MutationUpdateOrganizationArgs = {
  input: MutationUpdateOrganizationInput;
};


export type MutationUpdateOrganizationGroupArgs = {
  input: MutationUpdateOrganizationGroupInput;
};


export type MutationUpdatePictureArgs = {
  input: MutationUpdatePictureInput;
};


export type MutationUpdatePictureRevisionArgs = {
  input: MutationUpdatePictureRevisionInput;
};


export type MutationUpdatePriceGraphArgs = {
  input: MutationUpdatePriceGraphInput;
};


export type MutationUpdatePricesArgs = {
  organizationId: Scalars['ID']['input'];
  prices: Array<PriceInput>;
};


export type MutationUpdateProjectArgs = {
  input: MutationUpdateProjectInput;
};


export type MutationUpdateRenderJobArgs = {
  input: MutationUpdateRenderJobInput;
};


export type MutationUpdateScanJobArgs = {
  input: MutationUpdateScanJobInput;
};


export type MutationUpdateScanSubJobArgs = {
  input: MutationUpdateScanSubJobInput;
};


export type MutationUpdateSceneArgs = {
  input: MutationUpdateSceneInput;
};


export type MutationUpdateSceneRevisionArgs = {
  input: MutationUpdateSceneRevisionInput;
};


export type MutationUpdateSceneStatisticsArgs = {
  input: MutationUpdateSceneStatisticsInput;
};


export type MutationUpdateSetArgs = {
  input: MutationUpdateSetInput;
};


export type MutationUpdateStorageDeleteTaskArgs = {
  input: MutationUpdateStorageDeleteTaskInput;
};


export type MutationUpdateTagArgs = {
  input: MutationUpdateTagInput;
};


export type MutationUpdateTagAssignmentArgs = {
  input: MutationUpdateTagAssignmentInput;
};


export type MutationUpdateTaskArgs = {
  input: MutationUpdateTaskInput;
};


export type MutationUpdateTaskCommentArgs = {
  input: MutationUpdateTaskCommentInput;
};


export type MutationUpdateTaskPinArgs = {
  input: MutationUpdateTaskPinInput;
};


export type MutationUpdateTemplateArgs = {
  input: MutationUpdateTemplateInput;
};


export type MutationUpdateTemplateRevisionArgs = {
  input: MutationUpdateTemplateRevisionInput;
};


export type MutationUpdateTextureArgs = {
  input: MutationUpdateTextureInput;
};


export type MutationUpdateTextureEditGroupArgs = {
  input: MutationUpdateTextureEditGroupInput;
};


export type MutationUpdateTextureGroupArgs = {
  input: MutationUpdateTextureGroupInput;
};


export type MutationUpdateTextureRevisionArgs = {
  input: MutationUpdateTextureRevisionInput;
};


export type MutationUpdateTextureSetArgs = {
  input: MutationUpdateTextureSetInput;
};


export type MutationUpdateTextureSetRevisionArgs = {
  input: MutationUpdateTextureSetRevisionInput;
};


export type MutationUpdateUserArgs = {
  input: MutationUpdateUserInput;
};


export type MutationUpdateUserAssignmentArgs = {
  input: MutationUpdateUserAssignmentInput;
};


export type MutationVerifyEmailArgs = {
  token: Scalars['String']['input'];
};


export type MutationVerifyExternalLoginArgs = {
  input: MutationVerifyExternalLoginInput;
};

export type MutationCloneScanJobForRefittingInput = {
  fittingSchema: FittingSchema;
  scanJobId: Scalars['ID']['input'];
};

export type MutationConfiguratorCreateDataObjectAssignmentInput = {
  assignmentKey?: InputMaybe<Scalars['String']['input']>;
  contentTypeModel: ContentTypeModel;
  dataObjectId: Scalars['ID']['input'];
  objectId: Scalars['ID']['input'];
  type: DataObjectAssignmentType;
};

export type MutationConfiguratorCreateJobInput = {
  graph?: InputMaybe<Scalars['Json']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationLegacyId: Scalars['Int']['input'];
};

export type MutationConfiguratorGenerateArInput = {
  assignmentKey: Scalars['String']['input'];
  templateParametersBase64: Scalars['String']['input'];
  templateRevisionId: Scalars['ID']['input'];
};

export type MutationCreateArStatisticsInput = {
  configString: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  templateRevisionId?: InputMaybe<Scalars['ID']['input']>;
  templateRevisionLegacyId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationCreateAssetInput = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  dataObjectAssignments?: InputMaybe<Array<CreateDataObjectAssignmentInlineInput>>;
  modelId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nextActor: NextActor;
  organizationId: Scalars['ID']['input'];
  pictureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  state: AssetState;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCreateCheckoutSessionInput = {
  cancelUrl: Scalars['String']['input'];
  priceLookupKey: Scalars['String']['input'];
  skipTrial?: InputMaybe<Scalars['Boolean']['input']>;
  successUrl: Scalars['String']['input'];
};

export type MutationCreateDataObjectAssignmentInput = {
  assignmentKey?: InputMaybe<Scalars['String']['input']>;
  contentTypeModel: ContentTypeModel;
  dataObjectId?: InputMaybe<Scalars['ID']['input']>;
  dataObjectLegacyId?: InputMaybe<Scalars['Int']['input']>;
  legacyAssignmentType?: InputMaybe<Scalars['String']['input']>;
  objectId?: InputMaybe<Scalars['ID']['input']>;
  objectLegacyId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<DataObjectAssignmentType>;
};

export type MutationCreateDataObjectInput = {
  bucketName?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  imageChannels?: InputMaybe<Scalars['Int']['input']>;
  imageColorProfile?: InputMaybe<Scalars['String']['input']>;
  imageColorSpace?: InputMaybe<ImageColorSpace>;
  imageDataType?: InputMaybe<ImageDataType>;
  imageTilesDescriptorId?: InputMaybe<Scalars['ID']['input']>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  objectName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationLegacyId?: InputMaybe<Scalars['Int']['input']>;
  originalFileName: Scalars['String']['input'];
  processedByVersion?: InputMaybe<Scalars['String']['input']>;
  relatedToId?: InputMaybe<Scalars['ID']['input']>;
  relatedToLegacyId?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Ignored. `size` is maintained from Cloud Storage by @cm/storage-sync (prod only); see backend/packages/storage-sync/README.md. */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated No longer used. Create and start a job to perform upload processing. */
  state?: InputMaybe<DataObjectState>;
  type?: InputMaybe<DataObjectType>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationCreateHdriInput = {
  createdById?: InputMaybe<Scalars['ID']['input']>;
  dataObjectId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationLegacyId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationCreateImageTilesDescriptorInput = {
  createdById?: InputMaybe<Scalars['ID']['input']>;
  dataObjectId: Scalars['String']['input'];
  imageHeight: Scalars['Int']['input'];
  imageWidth: Scalars['Int']['input'];
  tileBucketName: Scalars['String']['input'];
  tileChannels?: InputMaybe<Scalars['Int']['input']>;
  tileColorProfile?: InputMaybe<Scalars['String']['input']>;
  tileColorSpace: ImageColorSpace;
  tileHeight: Scalars['Int']['input'];
  tileMargin: Scalars['Int']['input'];
  tileMediaType: Scalars['String']['input'];
  tileMipLevels: Scalars['Int']['input'];
  tileStorageFolderName: Scalars['String']['input'];
  tileWidth: Scalars['Int']['input'];
};

export type MutationCreateJobAssignmentInput = {
  assignmentKey?: InputMaybe<Scalars['String']['input']>;
  contentTypeModel: ContentTypeModel;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  jobLegacyId?: InputMaybe<Scalars['Int']['input']>;
  objectId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use `objectId` instead */
  objectLegacyId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationCreateJobFarmGroupInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationLegacyId?: InputMaybe<Scalars['Int']['input']>;
  otherConfig?: InputMaybe<Scalars['Json']['input']>;
  queueGroup: Scalars['String']['input'];
};

export type MutationCreateJobFarmInstanceInput = {
  groupId?: InputMaybe<Scalars['ID']['input']>;
  hwFingerprint: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  lastReport?: InputMaybe<Scalars['DateTime']['input']>;
  otherInfo?: InputMaybe<Scalars['Json']['input']>;
  state: JobFarmInstanceState;
  type: JobFarmInstanceType;
  userId?: InputMaybe<Scalars['ID']['input']>;
  version: Scalars['String']['input'];
};

export type MutationCreateJobInput = {
  awaitScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  graph?: InputMaybe<Scalars['Json']['input']>;
  jobType?: InputMaybe<JobType>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use dedicated mutation instead */
  metadataProcessingJobForDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use dedicated mutation instead */
  metadataProcessingJobForDataObjectLegacyId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use `organizationId` instead */
  organizationLegacyId?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<JobState>;
  /** @deprecated Use dedicated mutation instead */
  thumbnailProcessingJobForDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use dedicated mutation instead */
  thumbnailProcessingJobForDataObjectLegacyId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationCreateJobTaskAssignmentInput = {
  assignmentKey?: InputMaybe<Scalars['String']['input']>;
  contentTypeModel: ContentTypeModel;
  jobTaskId?: InputMaybe<Scalars['ID']['input']>;
  jobTaskLegacyId?: InputMaybe<Scalars['Int']['input']>;
  objectId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use `objectId` instead */
  objectLegacyId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationCreateJobTaskInput = {
  cancelled?: InputMaybe<Scalars['DateTime']['input']>;
  claimedBy?: InputMaybe<Scalars['String']['input']>;
  deferredUntil?: InputMaybe<Scalars['DateTime']['input']>;
  finished?: InputMaybe<Scalars['DateTime']['input']>;
  graph?: InputMaybe<Scalars['Json']['input']>;
  hashInParent?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use `organizationId` instead */
  organizationLegacyId?: InputMaybe<Scalars['Int']['input']>;
  output?: InputMaybe<Scalars['Json']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  queueGroup?: InputMaybe<Scalars['String']['input']>;
  queueToken?: InputMaybe<Scalars['String']['input']>;
  started?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<JobTaskState>;
};

export type MutationCreateJobTaskTypeInput = {
  cancelTimeout?: InputMaybe<Scalars['Int']['input']>;
  defaultTimeout?: InputMaybe<Scalars['Int']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invocationMethod: InvocationMethod;
  maxTimeout?: InputMaybe<Scalars['Int']['input']>;
  queueGroup: Scalars['String']['input'];
  /** The job task's type as a string. Note that this is different from a task's type field (of type `TaskType`) */
  taskType: Scalars['String']['input'];
};

export type MutationCreateJsonFileAssignmentInput = {
  assignmentKey?: InputMaybe<Scalars['String']['input']>;
  contentTypeModel: ContentTypeModel;
  jsonFile?: InputMaybe<JsonFileCreateWithoutAssignmentInput>;
  jsonFileId?: InputMaybe<Scalars['ID']['input']>;
  objectId?: InputMaybe<Scalars['ID']['input']>;
  objectLegacyId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<JsonFileAssignmentType>;
};

export type MutationCreateJsonFileInput = {
  content: Scalars['Json']['input'];
  createdById?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationLegacyId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<JsonFileType>;
};

export type MutationCreateMaterialAssignmentInput = {
  assetId: Scalars['ID']['input'];
  materialId: Scalars['ID']['input'];
};

export type MutationCreateMaterialInput = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  meshSpecific?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nextActor: NextActor;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  paymentState: PaymentState;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sampleArrival?: InputMaybe<Scalars['DateTime']['input']>;
  state: MaterialState;
  tagAssignments?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Create texture groups inline. */
  textureGroup?: InputMaybe<TextureGroupInlineCreateInput>;
};

export type MutationCreateMaterialOutputInput = {
  configId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobId: Scalars['ID']['input'];
  materialId: Scalars['ID']['input'];
  materialRevisionId?: InputMaybe<Scalars['ID']['input']>;
  type: MaterialOutputType;
};

export type MutationCreateMaterialReferenceInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  materialRevisionId: Scalars['ID']['input'];
  templateRevisionId: Scalars['ID']['input'];
};

export type MutationCreateMaterialRevisionFromExchangeNodesAndConnectionsInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  exchangeNodesAndConnections: ExchangeNodesAndConnectionsCreateInput;
  graphSchema: Scalars['String']['input'];
  matFileDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  materialId: Scalars['ID']['input'];
  materialReferenceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  number?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationCreateMaterialRevisionFromGraphNodeInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  graphNode: Scalars['JsonObject']['input'];
  graphSchema: Scalars['String']['input'];
  matFileDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  materialId: Scalars['ID']['input'];
  materialReferenceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  number?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationCreateMembershipInput = {
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationCreateModelInput = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextActor: NextActor;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  paymentState: PaymentState;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  state: ModelState;
  type: ModelType;
};

export type MutationCreateOrUpdateMaterialBdInput = {
  articleId: Scalars['String']['input'];
  diffuseMapDataObjectId: Scalars['ID']['input'];
  displacement?: InputMaybe<Scalars['Float']['input']>;
  height: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  normalMapDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  width: Scalars['Float']['input'];
};

export type MutationCreateOrUpdateMaterialInput = {
  anisotropyMapDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  anisotropyRotationMapDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  anisotropyStrengthMapDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  articleId: Scalars['String']['input'];
  /** Optional comment for the material revision. Defaults to 'Created via API' */
  comment?: InputMaybe<Scalars['String']['input']>;
  diffuseMapDataObjectId: Scalars['ID']['input'];
  displacement?: InputMaybe<Scalars['Float']['input']>;
  displacementMapDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  f0MapDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  height: Scalars['Float']['input'];
  iorMapDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  maskMapDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  metalnessMapDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  normalMapDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  /** Whether the material is publicly visible. Defaults to false */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  roughnessMapDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  specularStrengthMapDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  specularTintMapDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  transmissionMapDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  width: Scalars['Float']['input'];
};

export type MutationCreateOrganizationGroupInput = {
  name: Scalars['String']['input'];
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationCreateOrganizationInput = {
  defaultScannerUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  salesEmail?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrganizationType>;
  url?: InputMaybe<Scalars['String']['input']>;
  visibleInFilters?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationCreatePictureAssetAssignmentInput = {
  assetId: Scalars['ID']['input'];
  pictureId?: InputMaybe<Scalars['ID']['input']>;
  pictureLegacyId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationCreatePictureInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextActor: NextActor;
  number?: InputMaybe<Scalars['Int']['input']>;
  paymentState: PaymentState;
  priorityOrder?: InputMaybe<Scalars['Int']['input']>;
  setId: Scalars['String']['input'];
  state?: InputMaybe<PictureState>;
};

export type MutationCreatePictureRevisionInlineDataObjectAssignmentInput = {
  assignmentKey?: InputMaybe<Scalars['String']['input']>;
  dataObjectId: Scalars['ID']['input'];
  type: DataObjectAssignmentType;
};

export type MutationCreatePictureRevisionInput = {
  createdById?: InputMaybe<Scalars['ID']['input']>;
  dataObjectAssignment?: InputMaybe<MutationCreatePictureRevisionInlineDataObjectAssignmentInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  pictureId: Scalars['ID']['input'];
};

export type MutationCreatePriceGraphInput = {
  graph: Scalars['Json']['input'];
  organizationId: Scalars['ID']['input'];
  originalIdsFromCatalog: Array<Scalars['String']['input']>;
  state?: InputMaybe<PriceGraphState>;
  templateId: Scalars['ID']['input'];
};

export type MutationCreateProjectInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type MutationCreateRenderJobInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  completed?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  instanceId?: InputMaybe<Scalars['ID']['input']>;
  log?: InputMaybe<Scalars['String']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  samples?: InputMaybe<Scalars['Int']['input']>;
  started?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<RenderJobState>;
  statusMessage?: InputMaybe<Scalars['String']['input']>;
  templateRevisionId: Scalars['ID']['input'];
};

export type MutationCreateSalesEnquiryInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactName: Scalars['String']['input'];
  context?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationLegacyId?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateScanJobInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  completed?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  instanceId?: InputMaybe<Scalars['ID']['input']>;
  lastFailedState?: InputMaybe<ScanJobState>;
  progress?: InputMaybe<Scalars['String']['input']>;
  retryCount?: InputMaybe<Scalars['Int']['input']>;
  sampleRotation?: InputMaybe<Scalars['Int']['input']>;
  started?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<ScanJobState>;
  stateStarted?: InputMaybe<Scalars['DateTime']['input']>;
  textureSetId: Scalars['ID']['input'];
};

export type MutationCreateScanSubJobInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  completed?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  instanceId?: InputMaybe<Scalars['ID']['input']>;
  lastFailedState?: InputMaybe<ScanSubJobState>;
  progress?: InputMaybe<Scalars['String']['input']>;
  retryCount?: InputMaybe<Scalars['Int']['input']>;
  scanJobId: Scalars['ID']['input'];
  started?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<ScanSubJobState>;
  tileX: Scalars['Int']['input'];
  tileY: Scalars['Int']['input'];
};

export type MutationCreateSceneInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  pictureId: Scalars['ID']['input'];
  revisionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  revisions?: InputMaybe<Array<SceneCreateSceneRevisionInlineInput>>;
  statistics?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationCreateSceneRevisionInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  graph?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  sceneId: Scalars['ID']['input'];
};

export type MutationCreateSceneStatisticsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  templateLegacyId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationCreateSetInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  pictureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectId: Scalars['ID']['input'];
};

export type MutationCreateStorageDeleteTaskInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  gcsBucketName: Scalars['String']['input'];
  gcsObjectName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCreateTagAssignmentInput = {
  contentTypeModel: ContentTypeModel;
  id?: InputMaybe<Scalars['ID']['input']>;
  objectId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};

export type MutationCreateTagInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fullWidth?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  otherInfo?: InputMaybe<Scalars['String']['input']>;
  overviewTemplateType?: InputMaybe<FabricOverviewGenerateTemplateType>;
  railroaded?: InputMaybe<Scalars['Boolean']['input']>;
  repeatHeight?: InputMaybe<Scalars['Float']['input']>;
  repeatWidth?: InputMaybe<Scalars['Float']['input']>;
  tagAssignmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagReferenceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type: TagType;
};

export type MutationCreateTaskCommentInput = {
  createdById?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  taskId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type MutationCreateTaskInput = {
  commentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contentTypeModel: ContentTypeModel;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  objectId: Scalars['ID']['input'];
  pinIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  state: TaskState;
  title?: InputMaybe<Scalars['String']['input']>;
  type: TaskType;
};

export type MutationCreateTaskPinInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  taskId: Scalars['ID']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type MutationCreateTemplateInput = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  exSceneId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  pictureId?: InputMaybe<Scalars['ID']['input']>;
  pictureLegacyId?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  state: TemplateState;
  statistics?: InputMaybe<Array<Scalars['ID']['input']>>;
  templateType: TemplateType;
};

export type MutationCreateTemplateRevisionInput = {
  completed: Scalars['Boolean']['input'];
  created?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  exSceneRevisionId?: InputMaybe<Scalars['Int']['input']>;
  graph?: InputMaybe<Scalars['Json']['input']>;
  templateId: Scalars['ID']['input'];
};

export type MutationCreateTextureEditGroupInput = {
  content?: InputMaybe<Scalars['Json']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  revisionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Prefer to use `revisionIds` instead */
  revisionLegacyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateTextureGroupInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  materialId?: InputMaybe<Scalars['ID']['input']>;
  meshSpecific?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationLegacyId?: InputMaybe<Scalars['Int']['input']>;
  textureSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Create texture sets inline. Overrides `textureSetIds`. */
  textureSets?: InputMaybe<Array<TextureSetInlineCreateInput>>;
};

export type MutationCreateTextureInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  revisionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  textureSetId: Scalars['ID']['input'];
  type: TextureType;
};

export type MutationCreateTextureRevisionInput = {
  createdById?: InputMaybe<Scalars['ID']['input']>;
  createdByVersion?: InputMaybe<Scalars['String']['input']>;
  dataObjectId: Scalars['ID']['input'];
  displacement?: InputMaybe<Scalars['Float']['input']>;
  height: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<TextureRevisionState>;
  textureId?: InputMaybe<Scalars['ID']['input']>;
  width: Scalars['Float']['input'];
};

export type MutationCreateTextureSetInput = {
  fittingSchema?: InputMaybe<FittingSchema>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scanJobId?: InputMaybe<Scalars['ID']['input']>;
  textureGroupId: Scalars['ID']['input'];
  textureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationCreateTextureSetRevisionInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  displacement?: InputMaybe<Scalars['Float']['input']>;
  editsJson?: InputMaybe<Scalars['Json']['input']>;
  editsProcessingJobId?: InputMaybe<Scalars['ID']['input']>;
  height: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  mapAssignments: Array<TextureSetRevisionMapAssignmentInput>;
  migratedFromTextureEditGroupId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  textureSetId: Scalars['ID']['input'];
  width: Scalars['Float']['input'];
};

export type MutationCreateUnstartedJobInput = {
  cancelled?: InputMaybe<Scalars['DateTime']['input']>;
  claimedBy?: InputMaybe<Scalars['String']['input']>;
  finished?: InputMaybe<Scalars['DateTime']['input']>;
  graph?: InputMaybe<Scalars['Json']['input']>;
  hashInParent?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  metadataProcessingJobForDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use `organizationId` instead */
  organizationLegacyId?: InputMaybe<Scalars['Int']['input']>;
  output?: InputMaybe<Scalars['Json']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  queueGroup?: InputMaybe<Scalars['String']['input']>;
  queueToken?: InputMaybe<Scalars['String']['input']>;
  started?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<JobState>;
  thumbnailProcessingJobForDataObjectId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCreateUserAssignmentInput = {
  contentTypeModel: ContentTypeModel;
  id?: InputMaybe<Scalars['String']['input']>;
  objectId: Scalars['ID']['input'];
  /** If true, remove all existing user assignments with the same combination of (objectId, contentTypeModel, state) before creating the new one. */
  removeExisting?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<UserAssignmentState>;
  type: UserAssignmentType;
  userId: Scalars['ID']['input'];
};

export type MutationCreateUserInput = {
  dateJoined?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  memberships?: InputMaybe<Array<MembershipCreateInput>>;
  password: Scalars['String']['input'];
  systemRole?: InputMaybe<SystemRole>;
  visibleInFilters?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationDeleteDataObjectAssignmentsInput = {
  contentTypeModel: ContentTypeModel;
  objectId: Scalars['ID']['input'];
  type: DataObjectAssignmentType;
};

export type MutationDeleteUserAssignmentsInput = {
  contentTypeModel: ContentTypeModel;
  objectId: Scalars['ID']['input'];
  state: UserAssignmentState;
  type: UserAssignmentType;
};

export type MutationEndTrialNowInput = {
  _dummy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationEnsurePbrExportBatchInput = {
  materialIds: Array<Scalars['ID']['input']>;
  type: PbrExportType;
};

export type MutationEnsurePconExportBatchInput = {
  materialIds: Array<Scalars['ID']['input']>;
};

export type MutationGenerateApiKeyInput = {
  email: Scalars['String']['input'];
  /** Optionally specify a value for the API key. If not specified, a random value will be generated and returned (recommended). */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MutationImportTextureSetInput = {
  sourceTextureSetRevisionId: Scalars['ID']['input'];
  targetMaterialId: Scalars['ID']['input'];
};

export type MutationInviteUserInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  memberships?: InputMaybe<Array<MembershipCreateInput>>;
  systemRole?: InputMaybe<SystemRole>;
  visibleInFilters?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationLogInViaSsoInput = {
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type MutationLoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MutationPinMaterialImageInput = {
  dataObjectId: Scalars['ID']['input'];
  materialId: Scalars['ID']['input'];
};

export type MutationRecordConfiguraMaterialDatabaseBindingPublishInput = {
  id: Scalars['ID']['input'];
  lastPublishedRevisionId: Scalars['ID']['input'];
  textileVersion: Scalars['Int']['input'];
};

export type MutationResetPasswordInput = {
  /** Optionally set the user's first name (used when completing an invitation) */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Optionally set the user's last name (used when completing an invitation) */
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type MutationSendPasswordResetEmailInput = {
  email: Scalars['String']['input'];
};

export type MutationSetConfiguraMaterialDatabaseProfileInput = {
  allowTextileCreation: Scalars['Boolean']['input'];
  apiKey: Scalars['String']['input'];
  brand?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  thumbnailMaterialOutputType: MaterialOutputType;
};

export type MutationSetMaterialShaderBallImageInput = {
  dataObjectId: Scalars['ID']['input'];
  materialId: Scalars['ID']['input'];
};

export type MutationStartFreeTrialInput = {
  _dummy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationStartSsoLoginInput = {
  slug: Scalars['String']['input'];
};

export type MutationTriggerConfiguraMaterialDatabasePublishBatchInput = {
  materialIds: Array<Scalars['ID']['input']>;
};

export type MutationTriggerConfiguraMaterialDatabasePublishInput = {
  materialId: Scalars['ID']['input'];
};

export type MutationUnpinMaterialImageInput = {
  materialId: Scalars['ID']['input'];
};

export type MutationUpdateArStatisticsInput = {
  configString?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  sceneRevisionId?: InputMaybe<Scalars['String']['input']>;
  templateRevisionId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateAssetInput = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  modelId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextActor?: InputMaybe<NextActor>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<AssetState>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateDataObjectAssignmentInput = {
  assignmentKey?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  type?: InputMaybe<DataObjectAssignmentType>;
};

export type MutationUpdateDataObjectInput = {
  bucketName?: InputMaybe<Scalars['String']['input']>;
  /** Explicitly disconnect the relatedTo relation. Required because setting relatedToId to null is ambiguous in GraphQL. */
  disconnectRelatedTo?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  imageChannels?: InputMaybe<Scalars['Int']['input']>;
  imageColorProfile?: InputMaybe<Scalars['String']['input']>;
  imageColorSpace?: InputMaybe<ImageColorSpace>;
  imageDataType?: InputMaybe<ImageDataType>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  mediaType?: InputMaybe<Scalars['String']['input']>;
  metadataProcessingJobId?: InputMaybe<Scalars['ID']['input']>;
  objectName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  originalFileName?: InputMaybe<Scalars['String']['input']>;
  processedByVersion?: InputMaybe<Scalars['String']['input']>;
  relatedToId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Ignored. `size` is maintained from Cloud Storage by @cm/storage-sync (prod only); see backend/packages/storage-sync/README.md. */
  size?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<DataObjectState>;
  thumbnailProcessingJobId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<DataObjectType>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationUpdateHdriInput = {
  dataObjectId?: InputMaybe<Scalars['ID']['input']>;
  dataObjectLegacyId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateImageTilesDescriptorInput = {
  dataObjectId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imageHeight?: InputMaybe<Scalars['Int']['input']>;
  imageWidth?: InputMaybe<Scalars['Int']['input']>;
  tileBucketName?: InputMaybe<Scalars['String']['input']>;
  tileChannels?: InputMaybe<Scalars['Int']['input']>;
  tileColorProfile?: InputMaybe<Scalars['String']['input']>;
  tileColorSpace?: InputMaybe<ImageColorSpace>;
  tileHeight?: InputMaybe<Scalars['Int']['input']>;
  tileMargin?: InputMaybe<Scalars['Int']['input']>;
  tileMediaType?: InputMaybe<Scalars['String']['input']>;
  tileMipLevels?: InputMaybe<Scalars['Int']['input']>;
  tileStorageFolderName?: InputMaybe<Scalars['String']['input']>;
  tileWidth?: InputMaybe<Scalars['Int']['input']>;
  updatedById?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateJobAssignmentInput = {
  assignmentKey?: InputMaybe<Scalars['String']['input']>;
  contentTypeModel?: InputMaybe<ContentTypeModel>;
  id: Scalars['ID']['input'];
  jobId?: InputMaybe<Scalars['ID']['input']>;
  objectId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateJobFarmGroupInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationLegacyId?: InputMaybe<Scalars['Int']['input']>;
  otherConfig?: InputMaybe<Scalars['Json']['input']>;
  queueGroup: Scalars['String']['input'];
};

export type MutationUpdateJobFarmInstanceInput = {
  groupId?: InputMaybe<Scalars['ID']['input']>;
  hwFingerprint?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastReport?: InputMaybe<Scalars['DateTime']['input']>;
  otherInfo?: InputMaybe<Scalars['Json']['input']>;
  state?: InputMaybe<JobFarmInstanceState>;
  type?: InputMaybe<JobFarmInstanceType>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateJobInput = {
  awaitScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationUpdateJobTaskAssignmentInput = {
  assignmentKey?: InputMaybe<Scalars['String']['input']>;
  contentTypeModel: ContentTypeModel;
  id: Scalars['ID']['input'];
  jobTaskId?: InputMaybe<Scalars['ID']['input']>;
  objectId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateJobTaskInput = {
  attemptCount?: InputMaybe<Scalars['Int']['input']>;
  attemptsRemaining?: InputMaybe<Scalars['Int']['input']>;
  awaitScheduling?: InputMaybe<Scalars['Boolean']['input']>;
  cancelled?: InputMaybe<Scalars['DateTime']['input']>;
  finished?: InputMaybe<Scalars['DateTime']['input']>;
  hashInParent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  instanceId?: InputMaybe<Scalars['String']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  output?: InputMaybe<Scalars['Json']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  queueGroup?: InputMaybe<Scalars['String']['input']>;
  queueToken?: InputMaybe<Scalars['String']['input']>;
  started?: InputMaybe<Scalars['DateTime']['input']>;
  taskType?: InputMaybe<Scalars['String']['input']>;
  updateDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  versionCounter?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationUpdateJobTaskResourceGroupInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Use `id` instead */
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  resourceGroupPin?: InputMaybe<ResourceGroupId>;
};

export type MutationUpdateJobTaskTypeInput = {
  /** @deprecated No longer used */
  cancelTimeout?: InputMaybe<Scalars['Int']['input']>;
  defaultTimeout?: InputMaybe<Scalars['Int']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  invocationMethod?: InputMaybe<InvocationMethod>;
  maxTimeout?: InputMaybe<Scalars['Int']['input']>;
  queueGroup?: InputMaybe<Scalars['String']['input']>;
  /** The job task's type as a string. Note that this is different from a task's type field (of type `TaskType`) */
  taskType?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateJsonFileAssignmentInput = {
  assignmentKey?: InputMaybe<Scalars['String']['input']>;
  contentTypeModel?: InputMaybe<ContentTypeModel>;
  id: Scalars['ID']['input'];
  jsonFileId?: InputMaybe<Scalars['ID']['input']>;
  objectId?: InputMaybe<Scalars['ID']['input']>;
  type: JsonFileAssignmentType;
};

export type MutationUpdateJsonFileInput = {
  content?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<JsonFileType>;
};

export type MutationUpdateMaterialInput = {
  aiCategorizationLog?: InputMaybe<Scalars['String']['input']>;
  aiCategorizationSource?: InputMaybe<Scalars['String']['input']>;
  aiCategorizedAt?: InputMaybe<Scalars['DateTime']['input']>;
  aiDescription?: InputMaybe<Scalars['String']['input']>;
  articleId?: InputMaybe<Scalars['String']['input']>;
  assetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  colors?: InputMaybe<Array<MaterialColor>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  internalName?: InputMaybe<Scalars['String']['input']>;
  materialTypes?: InputMaybe<Array<MaterialType>>;
  meshSpecific?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextActor?: InputMaybe<NextActor>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  patterns?: InputMaybe<Array<MaterialPattern>>;
  paymentState?: InputMaybe<PaymentState>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  publicDownloads?: InputMaybe<Scalars['Boolean']['input']>;
  sampleArrival?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<MaterialState>;
};

export type MutationUpdateMaterialOutputByJobInput = {
  jobId: Scalars['ID']['input'];
  materialId: Scalars['ID']['input'];
  resultId: Scalars['ID']['input'];
};

export type MutationUpdateMaterialOutputInput = {
  id: Scalars['ID']['input'];
  resultId: Scalars['ID']['input'];
};

export type MutationUpdateMaterialReferenceInput = {
  id: Scalars['ID']['input'];
  materialRevisionId?: InputMaybe<Scalars['ID']['input']>;
  templateRevisionId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateMaterialRevisionInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  graphSchema?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  matFileDataObjectId?: InputMaybe<Scalars['ID']['input']>;
  materialId?: InputMaybe<Scalars['ID']['input']>;
  materialReferenceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  number?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationUpdateModelInput = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  internalName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextActor?: InputMaybe<NextActor>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  paymentState?: InputMaybe<PaymentState>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<ModelState>;
  type?: InputMaybe<ModelType>;
};

export type MutationUpdateOrganizationGroupInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationUpdateOrganizationInput = {
  defaultJobsPriority?: InputMaybe<Scalars['Int']['input']>;
  defaultScannerUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  matExplorerMaterialId?: InputMaybe<Scalars['Int']['input']>;
  matExplorerTemplateId?: InputMaybe<Scalars['Int']['input']>;
  materialAssetsTemplateId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nodeEditorTemplateId?: InputMaybe<Scalars['Int']['input']>;
  pdfStyleSettings?: InputMaybe<PdfStyleSettingsInput>;
  salesEmail?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<OrganizationType>;
  url?: InputMaybe<Scalars['String']['input']>;
  visibleInFilters?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationUpdatePictureInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nextActor?: InputMaybe<NextActor>;
  number?: InputMaybe<Scalars['Int']['input']>;
  paymentState?: InputMaybe<PaymentState>;
  priorityOrder?: InputMaybe<Scalars['Int']['input']>;
  regenerateNumber?: InputMaybe<Scalars['Boolean']['input']>;
  setId?: InputMaybe<Scalars['ID']['input']>;
  setLegacyId?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<PictureState>;
};

export type MutationUpdatePictureRevisionInput = {
  id: Scalars['ID']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  pictureId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdatePriceGraphInput = {
  conflicts?: InputMaybe<Scalars['String']['input']>;
  graph?: InputMaybe<Scalars['Json']['input']>;
  organizationId: Scalars['ID']['input'];
  originalIdsFromCatalog: Array<Scalars['String']['input']>;
  priceGraphId: Scalars['ID']['input'];
  revisionNumber?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<PriceGraphState>;
};

export type MutationUpdateProjectInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateRenderJobInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  completed?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  instanceId?: InputMaybe<Scalars['ID']['input']>;
  log?: InputMaybe<Scalars['String']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  samples?: InputMaybe<Scalars['Int']['input']>;
  sceneRevisionId?: InputMaybe<Scalars['ID']['input']>;
  started?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<RenderJobState>;
  statusMessage?: InputMaybe<Scalars['String']['input']>;
  templateRevisionId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateScanJobInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  completed?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  instanceId?: InputMaybe<Scalars['ID']['input']>;
  progress?: InputMaybe<Scalars['String']['input']>;
  sampleRotation?: InputMaybe<Scalars['Int']['input']>;
  started?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<ScanJobState>;
  stateStarted?: InputMaybe<Scalars['DateTime']['input']>;
  textureSetId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateScanSubJobInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  completed?: InputMaybe<Scalars['DateTime']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  instanceId?: InputMaybe<Scalars['ID']['input']>;
  progress?: InputMaybe<Scalars['String']['input']>;
  scanJobId?: InputMaybe<Scalars['ID']['input']>;
  started?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<ScanSubJobState>;
  tileX?: InputMaybe<Scalars['Int']['input']>;
  tileY?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationUpdateSceneInput = {
  id: Scalars['String']['input'];
  pictureId?: InputMaybe<Scalars['String']['input']>;
  revisionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  statistics?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationUpdateSceneRevisionInput = {
  graph?: InputMaybe<Scalars['Json']['input']>;
  id: Scalars['ID']['input'];
  sceneId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateSceneStatisticsInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  sceneId?: InputMaybe<Scalars['ID']['input']>;
  sceneLegacyId?: InputMaybe<Scalars['Int']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  templateLegacyId?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationUpdateSetInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  pictureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateStorageDeleteTaskInput = {
  created?: InputMaybe<Scalars['DateTime']['input']>;
  gcsBucketName?: InputMaybe<Scalars['String']['input']>;
  gcsObjectName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationUpdateTagAssignmentInput = {
  id: Scalars['ID']['input'];
  tagId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateTagInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fullWidth?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  otherInfo?: InputMaybe<Scalars['String']['input']>;
  overviewTemplateType?: InputMaybe<FabricOverviewGenerateTemplateType>;
  railroaded?: InputMaybe<Scalars['Boolean']['input']>;
  repeatHeight?: InputMaybe<Scalars['Float']['input']>;
  repeatWidth?: InputMaybe<Scalars['Float']['input']>;
  tagAssignmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagReferenceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<TagType>;
};

export type MutationUpdateTaskCommentInput = {
  id: Scalars['ID']['input'];
  taskId?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateTaskInput = {
  commentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  pinIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<TaskState>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TaskType>;
};

export type MutationUpdateTaskPinInput = {
  id: Scalars['ID']['input'];
  taskId?: InputMaybe<Scalars['ID']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationUpdateTemplateInput = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  exSceneId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  paymentState?: InputMaybe<PaymentState>;
  pictureId?: InputMaybe<Scalars['String']['input']>;
  pictureLegacyId?: InputMaybe<Scalars['Int']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<TemplateState>;
  statistics?: InputMaybe<Array<Scalars['ID']['input']>>;
  templateType?: InputMaybe<TemplateType>;
};

export type MutationUpdateTemplateRevisionInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  graph?: InputMaybe<Scalars['Json']['input']>;
  id: Scalars['ID']['input'];
  number?: InputMaybe<Scalars['Int']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateTextureEditGroupInput = {
  content?: InputMaybe<Scalars['Json']['input']>;
  id: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateTextureGroupInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  materialId?: InputMaybe<Scalars['ID']['input']>;
  meshSpecific?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  textureSetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationUpdateTextureInput = {
  id: Scalars['ID']['input'];
  revisionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  textureSetId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TextureType>;
};

export type MutationUpdateTextureRevisionInput = {
  createdByVersion?: InputMaybe<Scalars['String']['input']>;
  dataObjectId?: InputMaybe<Scalars['ID']['input']>;
  displacement?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  state?: InputMaybe<TextureRevisionState>;
  textureId?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationUpdateTextureSetInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  scanJobId?: InputMaybe<Scalars['ID']['input']>;
  textureGroupId?: InputMaybe<Scalars['ID']['input']>;
  textureIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationUpdateTextureSetRevisionInput = {
  autoRescaleSize?: InputMaybe<Scalars['Boolean']['input']>;
  displacement?: InputMaybe<Scalars['Float']['input']>;
  editsJson?: InputMaybe<Scalars['Json']['input']>;
  editsProcessingJobId?: InputMaybe<Scalars['ID']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  mapAssignments?: InputMaybe<Array<TextureSetRevisionMapAssignmentInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['ID']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type MutationUpdateUserAssignmentInput = {
  id: Scalars['String']['input'];
  state?: InputMaybe<UserAssignmentState>;
  type?: InputMaybe<UserAssignmentType>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateUserInput = {
  dateJoined?: InputMaybe<Scalars['DateTime']['input']>;
  defaultJobsPriority?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  systemRole?: InputMaybe<SystemRole>;
  visibleInFilters?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationVerifyExternalLoginInput = {
  code: Scalars['String']['input'];
  /** External identity provider. Use either Google or Microsoft. */
  provider: LoginProvider;
};

export enum NextActor {
  Customer = 'Customer',
  ProjectManager = 'ProjectManager',
  Team1 = 'Team1',
  Team2 = 'Team2'
}

export type Organization = {
  __typename: 'Organization';
  accountType: AccountType;
  assets: Array<Asset>;
  assetsCount: Scalars['Int']['output'];
  configuraMaterialDatabaseProfile?: Maybe<ConfiguraMaterialDatabaseProfile>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  dataObjects: Array<DataObject>;
  defaultJobsPriority: Scalars['Int']['output'];
  defaultScannerUrl?: Maybe<Scalars['String']['output']>;
  font?: Maybe<DataObject>;
  fontBold?: Maybe<DataObject>;
  galleryImage?: Maybe<DataObject>;
  hdris: Array<Hdri>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  jobFarmGroups: Array<JobFarmGroup>;
  jobFarmGroupsCount: Scalars['Int']['output'];
  jobTasks: Array<JobTask>;
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  jsonFiles: Array<JsonFile>;
  lastActiveAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  matExplorerMaterial?: Maybe<Material>;
  matExplorerTemplate?: Maybe<Template>;
  materialAssetsTemplate?: Maybe<Template>;
  materials: Array<Material>;
  materialsCount: Scalars['Int']['output'];
  members: Array<Membership>;
  membersCount: Scalars['Int']['output'];
  models: Array<Model>;
  modelsCount: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nodeEditorTemplate?: Maybe<Template>;
  organizationGroup?: Maybe<OrganizationGroup>;
  pdfStyleSettings?: Maybe<PdfStyleSettings>;
  pdfTemplate?: Maybe<DataObject>;
  projects: Array<Project>;
  projectsCount: Scalars['Int']['output'];
  salesEmail?: Maybe<Scalars['String']['output']>;
  salesEnquiries: Array<SalesEnquiry>;
  salesEnquiriesCount: Scalars['Int']['output'];
  selfServiceSignup?: Maybe<Scalars['Boolean']['output']>;
  stripeCancelAtPeriodEnd?: Maybe<Scalars['Boolean']['output']>;
  stripeCurrentPeriodEnd?: Maybe<Scalars['DateTime']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePriceId?: Maybe<Scalars['String']['output']>;
  stripeProductName?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionStatus?: Maybe<Scalars['String']['output']>;
  tags: Array<Tag>;
  tagsCount: Scalars['Int']['output'];
  templates: Array<Template>;
  templatesCount: Scalars['Int']['output'];
  textureGroups: Array<TextureGroup>;
  textureGroupsCount: Scalars['Int']['output'];
  trialEndsAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<OrganizationType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  url?: Maybe<Scalars['String']['output']>;
  visibleInFilters?: Maybe<Scalars['Boolean']['output']>;
};


export type OrganizationDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};


export type OrganizationProjectsArgs = {
  orderBy?: InputMaybe<Array<ProjectOrderByInput>>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationFilterInput = {
  defaultScannerUrl?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdInFilter>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isSelfService?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId?: InputMaybe<IntFilterInput>;
  matExplorerMaterialId?: InputMaybe<IntFilterInput>;
  matExplorerTemplateId?: InputMaybe<IntFilterInput>;
  materialAssetsTemplateId?: InputMaybe<IntFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nodeEditorTemplateId?: InputMaybe<IntFilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<StringFilterInput>;
  visibleInFilters?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationGroup = {
  __typename: 'OrganizationGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizations: Array<Organization>;
};

export type OrganizationGroupFilterInput = {
  id?: InputMaybe<IdInFilter>;
  name?: InputMaybe<StringFilterInput>;
};

export enum OrganizationGroupOrderByCriteria {
  Id = 'id',
  Name = 'name'
}

export type OrganizationGroupOrderByInput = {
  direction: SortOrder;
  key: OrganizationGroupOrderByCriteria;
};

export enum OrganizationOrderByCriteria {
  CreatedAt = 'createdAt',
  Id = 'id',
  LastActiveAt = 'lastActiveAt',
  Name = 'name',
  VisibleInFilters = 'visibleInFilters'
}

export type OrganizationOrderByInput = {
  direction: SortOrder;
  key: OrganizationOrderByCriteria;
};

export enum OrganizationType {
  EnterpriseCloud = 'EnterpriseCloud'
}

export type Package = {
  __typename: 'Package';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  membership: Membership;
  type: PackageType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export enum PackageType {
  Configurator = 'Configurator',
  Exports = 'Exports',
  ProjectManagement = 'ProjectManagement',
  Rendering = 'Rendering'
}

export type Partnership = {
  __typename: 'Partnership';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  material: Material;
  model: Model;
  objectId: Scalars['ID']['output'];
  objectType: PartnershipSubject;
  organization: Organization;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  user: User;
};

export enum PartnershipSubject {
  Material = 'Material',
  Model = 'Model',
  Organization = 'Organization'
}

export enum PaymentState {
  InvoiceDrafted = 'InvoiceDrafted',
  InvoiceIssued = 'InvoiceIssued',
  OrderPlaced = 'OrderPlaced',
  Paid = 'Paid'
}

export enum PbrExportEngine {
  Cm = 'cm',
  Corona = 'corona',
  Cycles = 'cycles',
  Vray = 'vray'
}

export enum PbrExportFormat {
  Exr = 'exr',
  Jpeg = 'jpeg',
  Png = 'png',
  Tiff = 'tiff'
}

export enum PbrExportNormalY {
  Default = 'Default',
  YDown = 'YDown',
  YUp = 'YUp'
}

export enum PbrExportResolution {
  Dpi72 = 'dpi72',
  Original = 'original'
}

/** The five settings a PBR export is generated with. Required for PbrExportCustom, and rejected for the defaults, whose type names them. */
export type PbrExportSettingsInput = {
  engine: PbrExportEngine;
  format: PbrExportFormat;
  normalY: PbrExportNormalY;
  resolution: PbrExportResolution;
  workflow: PbrExportWorkflow;
};

/** The PBR exports a material can have: five defaults, each naming its own settings, and the custom export, which carries them. */
export enum PbrExportType {
  PbrExportCustom = 'PbrExportCustom',
  PbrExportDefaultExrOriginal = 'PbrExportDefaultExrOriginal',
  PbrExportDefaultJpegLow = 'PbrExportDefaultJpegLow',
  PbrExportDefaultJpegOriginal = 'PbrExportDefaultJpegOriginal',
  PbrExportDefaultTiffLow = 'PbrExportDefaultTiffLow',
  PbrExportDefaultTiffOriginal = 'PbrExportDefaultTiffOriginal'
}

export enum PbrExportWorkflow {
  MetalnessRoughness = 'metalnessRoughness',
  SpecularGlossiness = 'specularGlossiness'
}

export type PdfStyleSettings = {
  __typename: 'PdfStyleSettings';
  accentColor?: Maybe<Scalars['String']['output']>;
  headlineBold?: Maybe<Scalars['Boolean']['output']>;
  headlineCharSpacing?: Maybe<Scalars['Float']['output']>;
  headlineFontSize?: Maybe<Scalars['Float']['output']>;
  headlinePadding?: Maybe<Scalars['Float']['output']>;
  imagePadding?: Maybe<Scalars['Float']['output']>;
  marginBottom?: Maybe<Scalars['Float']['output']>;
  marginTop?: Maybe<Scalars['Float']['output']>;
  tableFontSize?: Maybe<Scalars['Float']['output']>;
  tableHeaderFontSize?: Maybe<Scalars['Float']['output']>;
  tableLineHeight?: Maybe<Scalars['Float']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
};

export type PdfStyleSettingsInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  headlineBold?: InputMaybe<Scalars['Boolean']['input']>;
  headlineCharSpacing?: InputMaybe<Scalars['Float']['input']>;
  headlineFontSize?: InputMaybe<Scalars['Float']['input']>;
  headlinePadding?: InputMaybe<Scalars['Float']['input']>;
  imagePadding?: InputMaybe<Scalars['Float']['input']>;
  marginBottom?: InputMaybe<Scalars['Float']['input']>;
  marginTop?: InputMaybe<Scalars['Float']['input']>;
  tableFontSize?: InputMaybe<Scalars['Float']['input']>;
  tableHeaderFontSize?: InputMaybe<Scalars['Float']['input']>;
  tableLineHeight?: InputMaybe<Scalars['Float']['input']>;
  textColor?: InputMaybe<Scalars['String']['input']>;
};

export type Picture = {
  __typename: 'Picture';
  assetAssignments: Array<PictureAssetAssignment>;
  assetInfos: PictureAssetInfos;
  /** Assets assigned to this picture via a PictureAssetAssignment. This is a convenience field that is equivalent to `assetAssignments.asset`. */
  assets: Array<Asset>;
  assetsCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  currentUserAssignment?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  galleryImage?: Maybe<DataObject>;
  id: Scalars['ID']['output'];
  jobAssignments: Array<JobAssignment>;
  jobAssignmentsCount: Scalars['Int']['output'];
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  latestRevision?: Maybe<PictureRevision>;
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nextActor: NextActor;
  number: Scalars['Int']['output'];
  organization: Organization;
  paymentState: PaymentState;
  priorityOrder: Scalars['GraphQLBigInt']['output'];
  revisions: Array<PictureRevision>;
  scene?: Maybe<Scene>;
  set: Set;
  shareAssignments: Array<ShareAssignment>;
  shareAssignmentsCount: Scalars['Int']['output'];
  state: PictureState;
  tagAssignments: Array<TagAssignment>;
  tagAssignmentsCount: Scalars['Int']['output'];
  taskInfos: TaskInfos;
  tasks: Array<Task>;
  template?: Maybe<Template>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  userAssignments: Array<UserAssignment>;
  userAssignmentsCount: Scalars['Int']['output'];
};


export type PictureDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type PictureDownloadUrlArgs = {
  fileType?: InputMaybe<DownloadFileType>;
  resolution?: InputMaybe<DownloadResolution>;
};


export type PictureJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};


export type PictureRevisionsArgs = {
  orderBy?: InputMaybe<Array<PictureRevisionOrderByInput>>;
};


export type PictureShareAssignmentsArgs = {
  filter?: InputMaybe<ShareAssignmentFilterInput>;
  orderBy?: InputMaybe<ShareAssignmentOrderByInput>;
};


export type PictureTagAssignmentsArgs = {
  tagTypes?: InputMaybe<Array<TagType>>;
};


export type PictureUserAssignmentsArgs = {
  filter?: InputMaybe<UserAssignmentFilterInput>;
};

export type PictureAssetAssignment = {
  __typename: 'PictureAssetAssignment';
  asset: Asset;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  picture: Picture;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type PictureAssetAssignmentFilterInput = {
  asset?: InputMaybe<AssetFilterInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  picture?: InputMaybe<PictureFilterInput>;
};

export type PictureAssetAssignmentHistory = {
  __typename: 'PictureAssetAssignmentHistory';
  asset?: Maybe<Asset>;
  assignment?: Maybe<PictureAssetAssignment>;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  picture?: Maybe<Picture>;
};

export type PictureAssetAssignmentHistoryFilterInput = {
  assetId?: InputMaybe<Scalars['ID']['input']>;
  assignmentId?: InputMaybe<IdInFilter>;
  historyChangeReason?: InputMaybe<StringFilterInput>;
  historyDate?: InputMaybe<DateTimeFilterInput>;
  historyType?: InputMaybe<Array<HistoryType>>;
  id?: InputMaybe<IdInFilter>;
  pictureId?: InputMaybe<Scalars['ID']['input']>;
};

export enum PictureAssetAssignmentHistoryOrderByCriteria {
  ArticleId = 'articleId',
  HistoryDate = 'history_date',
  Id = 'id',
  Name = 'name',
  NextActor = 'nextActor',
  PaymentState = 'paymentState',
  PriorityOrder = 'priorityOrder',
  Public = 'public',
  State = 'state'
}

export type PictureAssetAssignmentHistoryOrderByInput = {
  direction: SortOrder;
  key: PictureAssetAssignmentHistoryOrderByCriteria;
};

export type PictureAssetInfos = {
  __typename: 'PictureAssetInfos';
  completed: Scalars['Int']['output'];
  new: Scalars['Int']['output'];
  readyForShading: Scalars['Int']['output'];
  review: Scalars['Int']['output'];
  shading: Scalars['Int']['output'];
};

export type PictureFilterInput = {
  assetId?: InputMaybe<IdInFilter>;
  assetLegacyId?: InputMaybe<IntInFilter>;
  assetsCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  hasAssignedUser?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdInFilter>;
  legacyId?: InputMaybe<IntFilterInput>;
  nextActor?: InputMaybe<Array<NextActor>>;
  organizationId?: InputMaybe<IdInFilter>;
  organizationLegacyId?: InputMaybe<IntInFilter>;
  organizationUrl?: InputMaybe<StringFilterInput>;
  paymentState?: InputMaybe<Array<PaymentState>>;
  projectId?: InputMaybe<IdInFilter>;
  projectLegacyId?: InputMaybe<IntFilterInput>;
  projectNumber?: InputMaybe<IntInFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  setId?: InputMaybe<IdInFilter>;
  setLegacyId?: InputMaybe<IntFilterInput>;
  setNumber?: InputMaybe<IntInFilter>;
  state?: InputMaybe<Array<PictureState>>;
  tagId?: InputMaybe<IdInFilter>;
  tagLegacyId?: InputMaybe<IntInFilter>;
  userId?: InputMaybe<IdInFilter>;
};

export type PictureHistory = {
  __typename: 'PictureHistory';
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  historyChangeReason?: Maybe<Scalars['String']['output']>;
  historyDate?: Maybe<Scalars['DateTime']['output']>;
  historyType: HistoryType;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nextActor: NextActor;
  number: Scalars['Int']['output'];
  paymentState: PaymentState;
  picture?: Maybe<Picture>;
  priorityOrder: Scalars['GraphQLBigInt']['output'];
  set?: Maybe<Set>;
  state: PictureState;
};

export type PictureHistoryFilterInput = {
  description?: InputMaybe<StringFilterInput>;
  historyChangeReason?: InputMaybe<StringFilterInput>;
  historyDate?: InputMaybe<DateTimeFilterInput>;
  historyType?: InputMaybe<Array<HistoryType>>;
  id?: InputMaybe<IdInFilter>;
  name?: InputMaybe<StringFilterInput>;
  nextActor?: InputMaybe<Array<NextActor>>;
  number?: InputMaybe<IntFilterInput>;
  paymentState?: InputMaybe<Array<PaymentState>>;
  pictureId?: InputMaybe<IdInFilter>;
  priorityOrder?: InputMaybe<IntFilterInput>;
  setId?: InputMaybe<IdInFilter>;
  state?: InputMaybe<Array<PictureState>>;
  userId?: InputMaybe<IdInFilter>;
};

export enum PictureHistoryOrderByCriteria {
  ArticleId = 'articleId',
  HistoryDate = 'history_date',
  Id = 'id',
  Name = 'name',
  NextActor = 'nextActor',
  PaymentState = 'paymentState',
  PriorityOrder = 'priorityOrder',
  Public = 'public',
  State = 'state'
}

export type PictureHistoryOrderByInput = {
  direction: SortOrder;
  key: PictureHistoryOrderByCriteria;
};

export enum PictureOrderByCriteria {
  ArticleId = 'articleId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  NextActor = 'nextActor',
  Number = 'number',
  PaymentState = 'paymentState',
  PriorityOrder = 'priorityOrder',
  Public = 'public',
  SetNumber = 'setNumber',
  State = 'state'
}

export type PictureOrderByInput = {
  direction: SortOrder;
  key: PictureOrderByCriteria;
};

export type PictureRevision = {
  __typename: 'PictureRevision';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  picture: Picture;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type PictureRevisionDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type PictureRevisionJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};

export type PictureRevisionFilterInput = {
  created?: InputMaybe<DateTimeFilterInput>;
  createdById?: InputMaybe<IdInFilter>;
  id?: InputMaybe<IdInFilter>;
  number?: InputMaybe<IntFilterInput>;
  pictureId?: InputMaybe<IdInFilter>;
};

export enum PictureRevisionOrderByCriteria {
  Id = 'id',
  Number = 'number',
  PictureId = 'picture_id'
}

export type PictureRevisionOrderByInput = {
  direction: SortOrder;
  key: PictureRevisionOrderByCriteria;
};

export enum PictureState {
  Completed = 'Completed',
  Draft = 'Draft',
  FinalRender = 'FinalRender',
  InfoReview = 'InfoReview',
  OnHold = 'OnHold',
  Review = 'Review',
  Stage1 = 'Stage1',
  Stage2 = 'Stage2'
}

export type Price = {
  __typename: 'Price';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  currency: Currency;
  description?: Maybe<Scalars['String']['output']>;
  idFromCatalog: IdFromCatalog;
  price: Scalars['Float']['output'];
  priceIncludesVat: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type PriceFilterInput = {
  organizationId: IdInFilter;
  originalId?: InputMaybe<IdInFilter>;
};

export type PriceGraph = {
  __typename: 'PriceGraph';
  conflicts?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  graph: Scalars['Json']['output'];
  id: Scalars['ID']['output'];
  revisionNumber: Scalars['Int']['output'];
  state: PriceGraphState;
  templateId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type PriceGraphFilterInput = {
  state?: InputMaybe<PriceGraphState>;
  templateId?: InputMaybe<IdInFilter>;
};

export enum PriceGraphOrderByCriteria {
  CreatedAt = 'createdAt',
  Id = 'id',
  RevisionNumber = 'revisionNumber'
}

export type PriceGraphOrderByInput = {
  direction: SortOrder;
  key: PriceGraphOrderByCriteria;
};

export enum PriceGraphState {
  Draft = 'Draft',
  Invalid = 'Invalid',
  Ready = 'Ready'
}

export type PriceInput = {
  currency: Currency;
  description?: InputMaybe<Scalars['String']['input']>;
  disambiguator?: InputMaybe<Scalars['String']['input']>;
  originalId: Scalars['ID']['input'];
  price: Scalars['Float']['input'];
  priceIncludesVat: Scalars['Boolean']['input'];
};

export enum PriceOrderByCriteria {
  CreatedAt = 'createdAt'
}

export type PriceOrderByInput = {
  direction: SortOrder;
  key: PriceOrderByCriteria;
};

export type ProcessUploadOptionsInput = {
  generateTiles?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Project = {
  __typename: 'Project';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  jobAssignments: Array<JobAssignment>;
  jobAssignmentsCount: Scalars['Int']['output'];
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  organization: Organization;
  sets: Array<Set>;
  setsCount: Scalars['Int']['output'];
  shareAssignments: Array<ShareAssignment>;
  shareAssignmentsCount: Scalars['Int']['output'];
  tagAssignments: Array<TagAssignment>;
  tagAssignmentsCount: Scalars['Int']['output'];
  taskInfos: TaskInfos;
  tasks: Array<Task>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type ProjectDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};


export type ProjectSetsArgs = {
  orderBy?: InputMaybe<Array<SetOrderByInput>>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type ProjectShareAssignmentsArgs = {
  filter?: InputMaybe<ShareAssignmentFilterInput>;
  orderBy?: InputMaybe<ShareAssignmentOrderByInput>;
};


export type ProjectTagAssignmentsArgs = {
  tagTypes?: InputMaybe<Array<TagType>>;
};

export type ProjectFilterInput = {
  id?: InputMaybe<IdInFilter>;
  name?: InputMaybe<StringFilterInput>;
  number?: InputMaybe<IntFilterInput>;
  organizationId?: InputMaybe<IdInFilter>;
  setIds?: InputMaybe<IdInFilter>;
};

export enum ProjectOrderByCriteria {
  ArticleId = 'articleId',
  Id = 'id',
  LegacyId = 'legacyId',
  Name = 'name',
  NextActor = 'nextActor',
  Number = 'number',
  PaymentState = 'paymentState',
  PriorityOrder = 'priorityOrder',
  Public = 'public',
  State = 'state'
}

export type ProjectOrderByInput = {
  direction: SortOrder;
  key: ProjectOrderByCriteria;
};

export type Query = {
  __typename: 'Query';
  arStatisticsItem: ArStatistics;
  arStatisticsItems: Array<Maybe<ArStatistics>>;
  arStatisticsItemsCount: Scalars['Int']['output'];
  asset: Asset;
  assetHistoryItem: AssetHistory;
  assetHistoryItems: Array<Maybe<AssetHistory>>;
  assetHistoryItemsCount: Scalars['Int']['output'];
  assets: Array<Maybe<Asset>>;
  assetsCount: Scalars['Int']['output'];
  blenderAddonDownload?: Maybe<BlenderAddonDownload>;
  configuraMaterialDatabaseBinding: ConfiguraMaterialDatabaseBinding;
  configuraMaterialDatabaseBindings: Array<Maybe<ConfiguraMaterialDatabaseBinding>>;
  configuraMaterialDatabaseBindingsCount: Scalars['Int']['output'];
  configuratorArData?: Maybe<ConfiguratorArData>;
  configuratorData?: Maybe<ConfiguratorTemplate>;
  configuratorDataObjectAssignments: Array<ConfiguratorArAssignment>;
  /** Returns the thumbnail download URL for a data object, with permission check via template/material assignment */
  configuratorDataObjectThumbnail?: Maybe<Scalars['String']['output']>;
  configuratorDataObjects: Array<ConfiguratorDataObject>;
  configuratorHdri?: Maybe<ConfiguratorDataObject>;
  configuratorJobTask?: Maybe<ConfiguratorArJobTask>;
  configuratorMaterial?: Maybe<ConfiguratorMaterial>;
  configuratorMaterialRevisions: Array<ConfiguratorMaterialRevision>;
  configuratorMaterials: Array<ConfiguratorMaterial>;
  configuratorTextureRevisions: Array<ConfiguratorTextureRevision>;
  configuratorTextureSetRevisions: Array<ConfiguratorTextureSetRevision>;
  currentUser?: Maybe<User>;
  dataObject: DataObject;
  dataObjectAssignment: DataObjectAssignment;
  dataObjectAssignments: Array<Maybe<DataObjectAssignment>>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  dataObjects: Array<Maybe<DataObject>>;
  dataObjectsById: Array<DataObjectByUuid>;
  dataObjectsCount: Scalars['Int']['output'];
  exchangeNodesAndConnectionsErrors: Array<ExchangeValidationError>;
  exchangeNodesAndConnectionsForGraphNode: ExchangeNodesAndConnections;
  hdri: Hdri;
  hdris: Array<Maybe<Hdri>>;
  hdrisCount: Scalars['Int']['output'];
  idFromCatalogToPriceGraphItems: Array<Maybe<IdFromCatalogToPriceGraph>>;
  idFromCatalogToPriceGraphItemsCount: Scalars['Int']['output'];
  job: Job;
  jobAssignment: JobAssignment;
  jobAssignments: Array<Maybe<JobAssignment>>;
  jobAssignmentsCount: Scalars['Int']['output'];
  jobFarmGroup: JobFarmGroup;
  jobFarmGroups: Array<Maybe<JobFarmGroup>>;
  jobFarmGroupsCount: Scalars['Int']['output'];
  jobFarmInstance: JobFarmInstance;
  jobFarmInstances: Array<Maybe<JobFarmInstance>>;
  jobFarmInstancesCount: Scalars['Int']['output'];
  /** The merged task + instance event history for a coordinator VM, most recent first. */
  jobInstanceHistory: Array<JobInstanceHistoryEvent>;
  jobTask: JobTask;
  jobTaskAssignment: JobTaskAssignment;
  jobTaskAssignments: Array<Maybe<JobTaskAssignment>>;
  jobTaskAssignmentsCount: Scalars['Int']['output'];
  jobTaskType: JobTaskType;
  jobTaskTypes: Array<Maybe<JobTaskType>>;
  jobTaskTypesCount: Scalars['Int']['output'];
  jobTasks: Array<Maybe<JobTask>>;
  jobTasksCount: Scalars['Int']['output'];
  jobs: Array<Maybe<Job>>;
  jobsCount: Scalars['Int']['output'];
  jsonFile: JsonFile;
  jsonFileAssignment: JsonFileAssignment;
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFiles: Array<Maybe<JsonFile>>;
  jsonFilesCount: Scalars['Int']['output'];
  material: Material;
  materialAssignmentHistoryItem: MaterialAssignmentHistory;
  materialAssignmentHistoryItems: Array<Maybe<MaterialAssignmentHistory>>;
  materialAssignmentHistoryItemsCount: Scalars['Int']['output'];
  materialCardDataById: Array<MaterialCardByUuid>;
  materialDownloadData?: Maybe<MaterialDownloadData>;
  materialEditorData: MaterialEditorMaterial;
  materialHistoryItem: MaterialHistory;
  materialHistoryItems: Array<Maybe<MaterialHistory>>;
  materialHistoryItemsCount: Scalars['Int']['output'];
  materialRevision: MaterialRevision;
  materialRevisions: Array<Maybe<MaterialRevision>>;
  materialRevisionsCount: Scalars['Int']['output'];
  materials: Array<Maybe<Material>>;
  materialsCount: Scalars['Int']['output'];
  membership: Membership;
  model: Model;
  modelHistoryItem: ModelHistory;
  modelHistoryItems: Array<Maybe<ModelHistory>>;
  modelHistoryItemsCount: Scalars['Int']['output'];
  models: Array<Maybe<Model>>;
  modelsCount: Scalars['Int']['output'];
  organization: Organization;
  organizationGroup: OrganizationGroup;
  organizationGroups: Array<Maybe<OrganizationGroup>>;
  organizationGroupsCount: Scalars['Int']['output'];
  organizations: Array<Maybe<Organization>>;
  organizationsCount: Scalars['Int']['output'];
  picture: Picture;
  pictureAssetAssignmentHistoryItem: PictureAssetAssignmentHistory;
  pictureAssetAssignmentHistoryItems: Array<Maybe<PictureAssetAssignmentHistory>>;
  pictureAssetAssignmentHistoryItemsCount: Scalars['Int']['output'];
  pictureHistoryItem: PictureHistory;
  pictureHistoryItems: Array<Maybe<PictureHistory>>;
  pictureHistoryItemsCount: Scalars['Int']['output'];
  pictureRevision: PictureRevision;
  pictureRevisions: Array<Maybe<PictureRevision>>;
  pictureRevisionsCount: Scalars['Int']['output'];
  pictures: Array<Maybe<Picture>>;
  picturesCount: Scalars['Int']['output'];
  price: Price;
  priceGraph: PriceGraph;
  priceGraphs: Array<Maybe<PriceGraph>>;
  priceGraphsCount: Scalars['Int']['output'];
  prices: Array<Maybe<Price>>;
  pricesCount: Scalars['Int']['output'];
  project: Project;
  projects: Array<Maybe<Project>>;
  projectsCount: Scalars['Int']['output'];
  renderJob: RenderJob;
  renderJobs: Array<Maybe<RenderJob>>;
  renderJobsCount: Scalars['Int']['output'];
  renderServerDownloads: Array<RenderServerDownload>;
  scanJob: ScanJob;
  scanJobs: Array<Maybe<ScanJob>>;
  scanJobsCount: Scalars['Int']['output'];
  scanSubJob: ScanSubJob;
  scanSubJobs: Array<Maybe<ScanSubJob>>;
  scanSubJobsCount: Scalars['Int']['output'];
  scene: Scene;
  sceneRevision: SceneRevision;
  sceneRevisions: Array<Maybe<SceneRevision>>;
  sceneRevisionsCount: Scalars['Int']['output'];
  sceneStatisticsItem: SceneStatistics;
  sceneStatisticsItems: Array<Maybe<SceneStatistics>>;
  sceneStatisticsItemsCount: Scalars['Int']['output'];
  scenes: Array<Maybe<Scene>>;
  scenesCount: Scalars['Int']['output'];
  set: Set;
  sets: Array<Maybe<Set>>;
  setsCount: Scalars['Int']['output'];
  storageDeleteTask: StorageDeleteTask;
  storageDeleteTasks: Array<Maybe<StorageDeleteTask>>;
  storageDeleteTasksCount: Scalars['Int']['output'];
  subscriptionPlans: Scalars['String']['output'];
  tag: Tag;
  tagAssignment: TagAssignment;
  tagAssignments: Array<Maybe<TagAssignment>>;
  tagAssignmentsCount: Scalars['Int']['output'];
  tags: Array<Maybe<Tag>>;
  tagsCount: Scalars['Int']['output'];
  task: Task;
  taskComment: TaskComment;
  taskComments: Array<Maybe<TaskComment>>;
  taskCommentsCount: Scalars['Int']['output'];
  taskPin: TaskPin;
  taskPins: Array<Maybe<TaskPin>>;
  taskPinsCount: Scalars['Int']['output'];
  tasks: Array<Maybe<Task>>;
  tasksCount: Scalars['Int']['output'];
  template: Template;
  templateRevision: TemplateRevision;
  templateRevisions: Array<Maybe<TemplateRevision>>;
  templateRevisionsCount: Scalars['Int']['output'];
  templates: Array<Maybe<Template>>;
  templatesCount: Scalars['Int']['output'];
  texture: Texture;
  textureEditGroup: TextureEditGroup;
  textureEditGroups: Array<Maybe<TextureEditGroup>>;
  textureEditGroupsCount: Scalars['Int']['output'];
  textureGroup: TextureGroup;
  textureGroups: Array<Maybe<TextureGroup>>;
  textureGroupsCount: Scalars['Int']['output'];
  textureRevision: TextureRevision;
  textureRevisions: Array<Maybe<TextureRevision>>;
  textureRevisionsCount: Scalars['Int']['output'];
  textureSet: TextureSet;
  textureSetRevision: TextureSetRevision;
  textureSetRevisions: Array<Maybe<TextureSetRevision>>;
  textureSetRevisionsCount: Scalars['Int']['output'];
  textureSets: Array<Maybe<TextureSet>>;
  textureSetsCount: Scalars['Int']['output'];
  textures: Array<Maybe<Texture>>;
  texturesCount: Scalars['Int']['output'];
  user: User;
  userAssignment: UserAssignment;
  userAssignmentHistoryItem: UserAssignmentHistory;
  userAssignmentHistoryItems: Array<Maybe<UserAssignmentHistory>>;
  userAssignmentHistoryItemsCount: Scalars['Int']['output'];
  userAssignments: Array<Maybe<UserAssignment>>;
  userAssignmentsCount: Scalars['Int']['output'];
  users: Array<Maybe<User>>;
  usersCount: Scalars['Int']['output'];
};


export type QueryArStatisticsItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryArStatisticsItemsArgs = {
  filter?: InputMaybe<ArStatisticsFilterInput>;
  orderBy?: InputMaybe<Array<ArStatisticsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryArStatisticsItemsCountArgs = {
  filter?: InputMaybe<ArStatisticsFilterInput>;
};


export type QueryAssetArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAssetHistoryItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAssetHistoryItemsArgs = {
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AssetHistoryFilterInput>;
  orderBy?: InputMaybe<Array<AssetHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAssetHistoryItemsCountArgs = {
  filter?: InputMaybe<AssetHistoryFilterInput>;
};


export type QueryAssetsArgs = {
  filter?: InputMaybe<AssetFilterInput>;
  orderBy?: InputMaybe<Array<AssetOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAssetsCountArgs = {
  filter?: InputMaybe<AssetFilterInput>;
};


export type QueryConfiguraMaterialDatabaseBindingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConfiguraMaterialDatabaseBindingsArgs = {
  filter?: InputMaybe<ConfiguraMaterialDatabaseBindingFilterInput>;
  orderBy?: InputMaybe<Array<ConfiguraMaterialDatabaseBindingOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConfiguraMaterialDatabaseBindingsCountArgs = {
  filter?: InputMaybe<ConfiguraMaterialDatabaseBindingFilterInput>;
};


export type QueryConfiguratorArDataArgs = {
  assignmentKey: Scalars['String']['input'];
  templateRevisionId: Scalars['ID']['input'];
};


export type QueryConfiguratorDataArgs = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  sceneLegacyId?: InputMaybe<Scalars['Int']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  templateLegacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConfiguratorDataObjectAssignmentsArgs = {
  filter: DataObjectAssignmentFilterInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConfiguratorDataObjectThumbnailArgs = {
  fileType?: InputMaybe<DownloadFileType>;
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  resolution?: InputMaybe<DownloadResolution>;
};


export type QueryConfiguratorDataObjectsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  legacyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryConfiguratorHdriArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConfiguratorJobTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConfiguratorMaterialArgs = {
  articleId?: InputMaybe<Scalars['String']['input']>;
  materialId?: InputMaybe<Scalars['ID']['input']>;
  materialLegacyId?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationLegacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConfiguratorMaterialRevisionsArgs = {
  legacyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryConfiguratorMaterialsArgs = {
  articleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  legacyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryConfiguratorTextureRevisionsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  legacyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryConfiguratorTextureSetRevisionsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryDataObjectArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDataObjectAssignmentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<Array<DataObjectAssignmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDataObjectAssignmentsCountArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
};


export type QueryDataObjectsArgs = {
  filter?: InputMaybe<DataObjectFilterInput>;
  orderBy?: InputMaybe<Array<DataObjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDataObjectsByIdArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryDataObjectsCountArgs = {
  filter?: InputMaybe<DataObjectFilterInput>;
};


export type QueryExchangeNodesAndConnectionsErrorsArgs = {
  exchangeNodesAndConnections: ExchangeNodesAndConnectionsCreateInput;
};


export type QueryExchangeNodesAndConnectionsForGraphNodeArgs = {
  graphNode: Scalars['JsonObject']['input'];
};


export type QueryHdriArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHdrisArgs = {
  filter?: InputMaybe<HdriFilterInput>;
  orderBy?: InputMaybe<Array<HdriOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHdrisCountArgs = {
  filter?: InputMaybe<HdriFilterInput>;
};


export type QueryIdFromCatalogToPriceGraphItemsArgs = {
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<IdFromCatalogToPriceGraphFilterInput>;
  orderBy?: InputMaybe<Array<IdFromCatalogToPriceGraphOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIdFromCatalogToPriceGraphItemsCountArgs = {
  filter?: InputMaybe<IdFromCatalogToPriceGraphFilterInput>;
};


export type QueryJobArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobAssignmentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobAssignmentsArgs = {
  filter?: InputMaybe<JobAssignmentFilterInput>;
  orderBy?: InputMaybe<Array<JobAssignmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobAssignmentsCountArgs = {
  filter?: InputMaybe<JobAssignmentFilterInput>;
};


export type QueryJobFarmGroupArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobFarmGroupsArgs = {
  filter?: InputMaybe<JobFarmGroupFilterInput>;
  orderBy?: InputMaybe<Array<JobFarmGroupOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobFarmGroupsCountArgs = {
  filter?: InputMaybe<JobFarmGroupFilterInput>;
};


export type QueryJobFarmInstanceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobFarmInstancesArgs = {
  filter?: InputMaybe<JobFarmInstanceFilterInput>;
  orderBy?: InputMaybe<Array<JobFarmInstanceOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobFarmInstancesCountArgs = {
  filter?: InputMaybe<JobFarmInstanceFilterInput>;
};


export type QueryJobInstanceHistoryArgs = {
  instanceName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobTaskArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobTaskAssignmentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobTaskAssignmentsArgs = {
  filter?: InputMaybe<JobTaskAssignmentFilterInput>;
  orderBy?: InputMaybe<Array<JobTaskAssignmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobTaskAssignmentsCountArgs = {
  filter?: InputMaybe<JobTaskAssignmentFilterInput>;
};


export type QueryJobTaskTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobTaskTypesArgs = {
  filter?: InputMaybe<JobTaskTypeFilterInput>;
  orderBy?: InputMaybe<Array<JobTaskTypeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobTaskTypesCountArgs = {
  filter?: InputMaybe<JobTaskTypeFilterInput>;
};


export type QueryJobTasksArgs = {
  filter?: InputMaybe<JobTaskFilterInput>;
  orderBy?: InputMaybe<Array<JobTaskOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobTasksCountArgs = {
  filter?: InputMaybe<JobTaskFilterInput>;
};


export type QueryJobsArgs = {
  filter?: InputMaybe<JobFilterInput>;
  orderBy?: InputMaybe<Array<JobOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobsCountArgs = {
  filter?: InputMaybe<JobFilterInput>;
};


export type QueryJsonFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJsonFileAssignmentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
};


export type QueryJsonFilesArgs = {
  filter?: InputMaybe<JsonFileFilterInput>;
  orderBy?: InputMaybe<Array<JsonFileOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJsonFilesCountArgs = {
  filter?: InputMaybe<JsonFileFilterInput>;
};


export type QueryMaterialArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMaterialAssignmentHistoryItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMaterialAssignmentHistoryItemsArgs = {
  filter?: InputMaybe<MaterialAssignmentHistoryFilterInput>;
  orderBy?: InputMaybe<Array<MaterialAssignmentHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMaterialAssignmentHistoryItemsCountArgs = {
  filter?: InputMaybe<MaterialAssignmentHistoryFilterInput>;
};


export type QueryMaterialCardDataByIdArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryMaterialDownloadDataArgs = {
  articleId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryMaterialEditorDataArgs = {
  materialId: Scalars['ID']['input'];
};


export type QueryMaterialHistoryItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMaterialHistoryItemsArgs = {
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MaterialHistoryFilterInput>;
  orderBy?: InputMaybe<Array<MaterialHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMaterialHistoryItemsCountArgs = {
  filter?: InputMaybe<MaterialHistoryFilterInput>;
};


export type QueryMaterialRevisionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMaterialRevisionsArgs = {
  filter?: InputMaybe<MaterialRevisionFilterInput>;
  orderBy?: InputMaybe<Array<MaterialRevisionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMaterialRevisionsCountArgs = {
  filter?: InputMaybe<MaterialRevisionFilterInput>;
};


export type QueryMaterialsArgs = {
  filter?: InputMaybe<MaterialFilterInput>;
  orderBy?: InputMaybe<Array<MaterialOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMaterialsCountArgs = {
  filter?: InputMaybe<MaterialFilterInput>;
};


export type QueryMembershipArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryModelArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryModelHistoryItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryModelHistoryItemsArgs = {
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ModelHistoryFilterInput>;
  orderBy?: InputMaybe<Array<ModelHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryModelHistoryItemsCountArgs = {
  filter?: InputMaybe<ModelHistoryFilterInput>;
};


export type QueryModelsArgs = {
  filter?: InputMaybe<ModelFilterInput>;
  orderBy?: InputMaybe<Array<ModelOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryModelsCountArgs = {
  filter?: InputMaybe<ModelFilterInput>;
};


export type QueryOrganizationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationGroupArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationGroupsArgs = {
  filter?: InputMaybe<OrganizationGroupFilterInput>;
  orderBy?: InputMaybe<Array<OrganizationGroupOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationGroupsCountArgs = {
  filter?: InputMaybe<OrganizationGroupFilterInput>;
};


export type QueryOrganizationsArgs = {
  filter?: InputMaybe<OrganizationFilterInput>;
  orderBy?: InputMaybe<Array<OrganizationOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationsCountArgs = {
  filter?: InputMaybe<OrganizationFilterInput>;
};


export type QueryPictureArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPictureAssetAssignmentHistoryItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPictureAssetAssignmentHistoryItemsArgs = {
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PictureAssetAssignmentHistoryFilterInput>;
  orderBy?: InputMaybe<Array<PictureAssetAssignmentHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPictureAssetAssignmentHistoryItemsCountArgs = {
  filter?: InputMaybe<PictureAssetAssignmentHistoryFilterInput>;
};


export type QueryPictureHistoryItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPictureHistoryItemsArgs = {
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PictureHistoryFilterInput>;
  orderBy?: InputMaybe<Array<PictureHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPictureHistoryItemsCountArgs = {
  filter?: InputMaybe<PictureHistoryFilterInput>;
};


export type QueryPictureRevisionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPictureRevisionsArgs = {
  filter?: InputMaybe<PictureRevisionFilterInput>;
  orderBy?: InputMaybe<Array<PictureRevisionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPictureRevisionsCountArgs = {
  filter?: InputMaybe<PictureRevisionFilterInput>;
};


export type QueryPicturesArgs = {
  filter?: InputMaybe<PictureFilterInput>;
  orderBy?: InputMaybe<Array<PictureOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPicturesCountArgs = {
  filter?: InputMaybe<PictureFilterInput>;
};


export type QueryPriceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPriceGraphArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPriceGraphsArgs = {
  filter?: InputMaybe<PriceGraphFilterInput>;
  orderBy?: InputMaybe<Array<PriceGraphOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPriceGraphsCountArgs = {
  filter?: InputMaybe<PriceGraphFilterInput>;
};


export type QueryPricesArgs = {
  filter?: InputMaybe<PriceFilterInput>;
  orderBy?: InputMaybe<Array<PriceOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPricesCountArgs = {
  filter?: InputMaybe<PriceFilterInput>;
};


export type QueryProjectArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProjectsArgs = {
  filter?: InputMaybe<ProjectFilterInput>;
  orderBy?: InputMaybe<Array<ProjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProjectsCountArgs = {
  filter?: InputMaybe<ProjectFilterInput>;
};


export type QueryRenderJobArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRenderJobsArgs = {
  filter?: InputMaybe<RenderJobFilterInput>;
  orderBy?: InputMaybe<Array<RenderJobOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRenderJobsCountArgs = {
  filter?: InputMaybe<RenderJobFilterInput>;
};


export type QueryScanJobArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScanJobsArgs = {
  filter?: InputMaybe<ScanJobFilterInput>;
  orderBy?: InputMaybe<Array<ScanJobOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScanJobsCountArgs = {
  filter?: InputMaybe<ScanJobFilterInput>;
};


export type QueryScanSubJobArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScanSubJobsArgs = {
  filter?: InputMaybe<ScanSubJobFilterInput>;
  orderBy?: InputMaybe<Array<ScanSubJobOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScanSubJobsCountArgs = {
  filter?: InputMaybe<ScanSubJobFilterInput>;
};


export type QuerySceneArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySceneRevisionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySceneRevisionsArgs = {
  filter?: InputMaybe<SceneRevisionFilterInput>;
  orderBy?: InputMaybe<Array<SceneRevisionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySceneRevisionsCountArgs = {
  filter?: InputMaybe<SceneRevisionFilterInput>;
};


export type QuerySceneStatisticsItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySceneStatisticsItemsArgs = {
  filter?: InputMaybe<SceneStatisticsFilterInput>;
  orderBy?: InputMaybe<Array<SceneStatisticsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySceneStatisticsItemsCountArgs = {
  filter?: InputMaybe<SceneStatisticsFilterInput>;
};


export type QueryScenesArgs = {
  filter?: InputMaybe<SceneFilterInput>;
  orderBy?: InputMaybe<Array<SceneOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScenesCountArgs = {
  filter?: InputMaybe<SceneFilterInput>;
};


export type QuerySetArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySetsArgs = {
  filter?: InputMaybe<SetFilterInput>;
  orderBy?: InputMaybe<Array<SetOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySetsCountArgs = {
  filter?: InputMaybe<SetFilterInput>;
};


export type QueryStorageDeleteTaskArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStorageDeleteTasksArgs = {
  filter?: InputMaybe<StorageDeleteTaskFilterInput>;
  orderBy?: InputMaybe<Array<StorageDeleteTaskOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStorageDeleteTasksCountArgs = {
  filter?: InputMaybe<StorageDeleteTaskFilterInput>;
};


export type QueryTagArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagAssignmentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagAssignmentsArgs = {
  filter?: InputMaybe<TagAssignmentFilterInput>;
  orderBy?: InputMaybe<Array<TagAssignmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagAssignmentsCountArgs = {
  filter?: InputMaybe<TagAssignmentFilterInput>;
};


export type QueryTagsArgs = {
  filter?: InputMaybe<TagFilterInput>;
  orderBy?: InputMaybe<Array<TagOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagsCountArgs = {
  filter?: InputMaybe<TagFilterInput>;
};


export type QueryTaskArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTaskCommentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTaskCommentsArgs = {
  filter?: InputMaybe<TaskCommentFilterInput>;
  orderBy?: InputMaybe<Array<TaskCommentOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTaskCommentsCountArgs = {
  filter?: InputMaybe<TaskCommentFilterInput>;
};


export type QueryTaskPinArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTaskPinsArgs = {
  filter?: InputMaybe<TaskPinFilterInput>;
  orderBy?: InputMaybe<Array<TaskPinOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTaskPinsCountArgs = {
  filter?: InputMaybe<TaskPinFilterInput>;
};


export type QueryTasksArgs = {
  filter?: InputMaybe<TaskFilterInput>;
  orderBy?: InputMaybe<Array<TaskOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTasksCountArgs = {
  filter?: InputMaybe<TaskFilterInput>;
};


export type QueryTemplateArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTemplateRevisionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTemplateRevisionsArgs = {
  filter?: InputMaybe<TemplateRevisionFilterInput>;
  orderBy?: InputMaybe<Array<TemplateRevisionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTemplateRevisionsCountArgs = {
  filter?: InputMaybe<TemplateRevisionFilterInput>;
};


export type QueryTemplatesArgs = {
  filter?: InputMaybe<TemplateFilterInput>;
  orderBy?: InputMaybe<Array<TemplateOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTemplatesCountArgs = {
  filter?: InputMaybe<TemplateFilterInput>;
};


export type QueryTextureArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTextureEditGroupArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTextureEditGroupsArgs = {
  filter?: InputMaybe<TextureEditGroupFilterInput>;
  orderBy?: InputMaybe<Array<TextureEditGroupOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTextureEditGroupsCountArgs = {
  filter?: InputMaybe<TextureEditGroupFilterInput>;
};


export type QueryTextureGroupArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTextureGroupsArgs = {
  filter?: InputMaybe<TextureGroupFilterInput>;
  orderBy?: InputMaybe<Array<TextureGroupOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTextureGroupsCountArgs = {
  filter?: InputMaybe<TextureGroupFilterInput>;
};


export type QueryTextureRevisionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTextureRevisionsArgs = {
  filter?: InputMaybe<TextureRevisionFilterInput>;
  orderBy?: InputMaybe<Array<TextureRevisionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTextureRevisionsCountArgs = {
  filter?: InputMaybe<TextureRevisionFilterInput>;
};


export type QueryTextureSetArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTextureSetRevisionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTextureSetRevisionsArgs = {
  filter?: InputMaybe<TextureSetRevisionFilterInput>;
  orderBy?: InputMaybe<Array<TextureSetRevisionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTextureSetRevisionsCountArgs = {
  filter?: InputMaybe<TextureSetRevisionFilterInput>;
};


export type QueryTextureSetsArgs = {
  filter?: InputMaybe<TextureSetFilterInput>;
  orderBy?: InputMaybe<Array<TextureSetOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTextureSetsCountArgs = {
  filter?: InputMaybe<TextureSetFilterInput>;
};


export type QueryTexturesArgs = {
  filter?: InputMaybe<TextureFilterInput>;
  orderBy?: InputMaybe<Array<TextureOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTexturesCountArgs = {
  filter?: InputMaybe<TextureFilterInput>;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserAssignmentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserAssignmentHistoryItemArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserAssignmentHistoryItemsArgs = {
  filter?: InputMaybe<UserAssignmentHistoryFilterInput>;
  orderBy?: InputMaybe<Array<UserAssignmentHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserAssignmentHistoryItemsCountArgs = {
  filter?: InputMaybe<UserAssignmentHistoryFilterInput>;
};


export type QueryUserAssignmentsArgs = {
  filter?: InputMaybe<UserAssignmentFilterInput>;
  orderBy?: InputMaybe<Array<UserAssignmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserAssignmentsCountArgs = {
  filter?: InputMaybe<UserAssignmentFilterInput>;
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilterInput>;
  orderBy?: InputMaybe<Array<UserOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersCountArgs = {
  filter?: InputMaybe<UserFilterInput>;
};

/** Result of user registration */
export type RegisterUserResult = {
  __typename: 'RegisterUserResult';
  email: Scalars['String']['output'];
  userUuid: Scalars['String']['output'];
  verificationRequired: Scalars['Boolean']['output'];
};

/** Result of SSO registration or login */
export type RegisterUserSsoResult = {
  __typename: 'RegisterUserSsoResult';
  isExistingUser?: Maybe<Scalars['Boolean']['output']>;
  membership: SignupMembershipInfo;
  onboardingCompleted: Scalars['Boolean']['output'];
  organization: SignupOrganizationInfo;
  token: Scalars['String']['output'];
  user: SignupUserInfo;
};

export type RenderJob = {
  __typename: 'RenderJob';
  active: Scalars['Boolean']['output'];
  completed?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  instanceId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  log?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  samples: Scalars['Int']['output'];
  sceneRevision: SceneRevision;
  started?: Maybe<Scalars['DateTime']['output']>;
  state: RenderJobState;
  statusMessage?: Maybe<Scalars['String']['output']>;
  templateRevision?: Maybe<TemplateRevision>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type RenderJobFilterInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  completed?: InputMaybe<DateTimeFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  createdById?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdInFilter>;
  log?: InputMaybe<StringFilterInput>;
  progress?: InputMaybe<IntFilterInput>;
  samples?: InputMaybe<IntFilterInput>;
  sceneRevisionId?: InputMaybe<StringFilterInput>;
  started?: InputMaybe<DateTimeFilterInput>;
  state?: InputMaybe<Array<RenderJobState>>;
  statusMessage?: InputMaybe<StringFilterInput>;
  templateRevisionId?: InputMaybe<StringFilterInput>;
};

export enum RenderJobOrderByCriteria {
  Active = 'active',
  Completed = 'completed',
  CreatedAt = 'createdAt',
  Id = 'id',
  Started = 'started'
}

export type RenderJobOrderByInput = {
  direction: SortOrder;
  key: RenderJobOrderByCriteria;
};

export enum RenderJobState {
  Aborted = 'Aborted',
  Completed = 'Completed',
  Failed = 'Failed',
  Init = 'Init',
  Rendering = 'Rendering'
}

export type RenderServerDownload = {
  __typename: 'RenderServerDownload';
  target: Scalars['String']['output'];
  url: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export enum ResourceGroupId {
  CloudRunArGltf = 'CloudRunArGltf',
  CloudRunArUsdz = 'CloudRunArUsdz',
  CloudRunCpuRendering = 'CloudRunCpuRendering',
  CloudRunGpuRendering = 'CloudRunGpuRendering',
  CloudRunHighMemory = 'CloudRunHighMemory',
  CloudRunLowMemory = 'CloudRunLowMemory',
  CloudRunMidMemory = 'CloudRunMidMemory',
  CloudRunPythonTasks = 'CloudRunPythonTasks',
  CloudRunTiling = 'CloudRunTiling',
  ComputeEngineGpuRendering = 'ComputeEngineGpuRendering',
  ComputeEngineGpuRenderingHighMemory = 'ComputeEngineGpuRenderingHighMemory',
  ComputeEngineGpuRenderingOnDemand = 'ComputeEngineGpuRenderingOnDemand',
  ComputeEngineImageProcessing = 'ComputeEngineImageProcessing',
  ComputeEngineImageProcessingOnDemand = 'ComputeEngineImageProcessingOnDemand',
  ComputeEngineMaterialAi = 'ComputeEngineMaterialAi',
  ComputeEnginePowerMachine = 'ComputeEnginePowerMachine',
  ComputeEnginePowerMachineFlexStart = 'ComputeEnginePowerMachineFlexStart',
  ComputeEnginePowerMachineOnDemand = 'ComputeEnginePowerMachineOnDemand',
  RenderFarmCpuRendering = 'RenderFarmCpuRendering',
  RenderFarmGpuRendering = 'RenderFarmGpuRendering'
}

export enum ResourceGroupPlatform {
  CloudRun = 'CloudRun',
  ComputeEngineFlexStart = 'ComputeEngineFlexStart',
  ComputeEngineOnDemand = 'ComputeEngineOnDemand',
  ComputeEngineSpot = 'ComputeEngineSpot',
  RenderFarm = 'RenderFarm'
}

export type SalesEnquiry = {
  __typename: 'SalesEnquiry';
  companyName?: Maybe<Scalars['String']['output']>;
  contactName: Scalars['String']['output'];
  context?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  organization: Organization;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type ScanJob = {
  __typename: 'ScanJob';
  active: Scalars['Boolean']['output'];
  activeSubJobsCount: Scalars['Int']['output'];
  completed?: Maybe<Scalars['DateTime']['output']>;
  completedSubJobsCount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  instanceId?: Maybe<Scalars['String']['output']>;
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  lastFailedState?: Maybe<ScanJobState>;
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  progress?: Maybe<Scalars['String']['output']>;
  retryCount: Scalars['Int']['output'];
  sampleRotation: Scalars['Int']['output'];
  started?: Maybe<Scalars['DateTime']['output']>;
  startedSubJobsCount: Scalars['Int']['output'];
  state: ScanJobState;
  stateStarted?: Maybe<Scalars['DateTime']['output']>;
  subJobs: Array<ScanSubJob>;
  subJobsCount: Scalars['Int']['output'];
  textureSet?: Maybe<TextureSet>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type ScanJobDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type ScanJobJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};


export type ScanJobSubJobsArgs = {
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ScanJobFilterInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  completed?: InputMaybe<DateTimeFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  createdById?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdInFilter>;
  instanceId?: InputMaybe<StringFilterInput>;
  progress?: InputMaybe<StringFilterInput>;
  sampleRotation?: InputMaybe<IntFilterInput>;
  started?: InputMaybe<DateTimeFilterInput>;
  state?: InputMaybe<Array<ScanJobState>>;
  stateStarted?: InputMaybe<DateTimeFilterInput>;
  textureSetId?: InputMaybe<StringFilterInput>;
};

export enum ScanJobOrderByCriteria {
  Active = 'active',
  Completed = 'completed',
  CreatedAt = 'createdAt',
  Id = 'id',
  Started = 'started'
}

export type ScanJobOrderByInput = {
  direction: SortOrder;
  key: ScanJobOrderByCriteria;
};

export enum ScanJobState {
  Aborted = 'Aborted',
  Assembly = 'Assembly',
  Completed = 'Completed',
  Failed = 'Failed',
  Fitting = 'Fitting',
  ImageProcessing = 'ImageProcessing',
  Init = 'Init',
  Preprocessing = 'Preprocessing',
  Scanning = 'Scanning',
  Uploading = 'Uploading'
}

export type ScanSubJob = {
  __typename: 'ScanSubJob';
  active: Scalars['Boolean']['output'];
  completed?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  id: Scalars['ID']['output'];
  instanceId?: Maybe<Scalars['String']['output']>;
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  lastFailedState?: Maybe<ScanSubJobState>;
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  progress?: Maybe<Scalars['String']['output']>;
  retryCount: Scalars['Int']['output'];
  scanJob: ScanJob;
  started?: Maybe<Scalars['DateTime']['output']>;
  state: ScanSubJobState;
  tileX: Scalars['Int']['output'];
  tileY: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type ScanSubJobDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type ScanSubJobJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};

export type ScanSubJobFilterInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  completed?: InputMaybe<DateTimeFilterInput>;
  created?: InputMaybe<DateTimeFilterInput>;
  createdById?: InputMaybe<IdInFilter>;
  id?: InputMaybe<IdInFilter>;
  instanceId?: InputMaybe<StringFilterInput>;
  progress?: InputMaybe<StringFilterInput>;
  scanJobId?: InputMaybe<IdInFilter>;
  started?: InputMaybe<DateTimeFilterInput>;
  state?: InputMaybe<Array<ScanSubJobState>>;
  tileX?: InputMaybe<IntFilterInput>;
  tileY?: InputMaybe<IntFilterInput>;
};

export enum ScanSubJobOrderByCriteria {
  Active = 'active',
  Completed = 'completed',
  CreatedAt = 'createdAt',
  Id = 'id',
  Started = 'started'
}

export type ScanSubJobOrderByInput = {
  direction: SortOrder;
  key: ScanSubJobOrderByCriteria;
};

export enum ScanSubJobState {
  Aborted = 'Aborted',
  Completed = 'Completed',
  Failed = 'Failed',
  Init = 'Init',
  Processing = 'Processing'
}

export type Scene = {
  __typename: 'Scene';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  galleryImage?: Maybe<DataObject>;
  id: Scalars['ID']['output'];
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  latestRevision?: Maybe<SceneRevision>;
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  picture: Picture;
  revisions: Array<SceneRevision>;
  statistics: Array<SceneStatistics>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type SceneDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SceneJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};

export type SceneCreateSceneRevisionInlineInput = {
  graph?: InputMaybe<Scalars['Json']['input']>;
};

export type SceneFilterInput = {
  id?: InputMaybe<IdInFilter>;
  legacyId?: InputMaybe<IntFilterInput>;
  pictureId?: InputMaybe<IdInFilter>;
  revisionIds?: InputMaybe<IdInFilter>;
  statisticsIds?: InputMaybe<IdInFilter>;
};

export enum SceneOrderByCriteria {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name'
}

export type SceneOrderByInput = {
  direction: SortOrder;
  key: SceneOrderByCriteria;
};

export type SceneRevision = {
  __typename: 'SceneRevision';
  arStatistics: Array<ArStatistics>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  graph?: Maybe<Scalars['Json']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  renderJobs: Array<RenderJob>;
  scene: Scene;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type SceneRevisionCreateOneWithoutArStatisticsInput = {
  assign: Scalars['Int']['input'];
};

export type SceneRevisionFilterInput = {
  arStatisticsIds?: InputMaybe<IdInFilter>;
  created?: InputMaybe<DateTimeFilterInput>;
  createdById?: InputMaybe<IdInFilter>;
  id?: InputMaybe<Scalars['ID']['input']>;
  renderJobsIds?: InputMaybe<IdInFilter>;
  sceneId?: InputMaybe<IdInFilter>;
};

export enum SceneRevisionOrderByCriteria {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name'
}

export type SceneRevisionOrderByInput = {
  direction: SortOrder;
  key: SceneRevisionOrderByCriteria;
};

export type SceneStatistics = {
  __typename: 'SceneStatistics';
  created?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  scene?: Maybe<Scene>;
  template?: Maybe<Template>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type SceneStatisticsFilterInput = {
  created?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdInFilter>;
  sceneId?: InputMaybe<IdInFilter>;
  sceneLegacyId?: InputMaybe<IntInFilter>;
  templateId?: InputMaybe<IdInFilter>;
  templateLegacyId?: InputMaybe<IntInFilter>;
};

export enum SceneStatisticsOrderByCriteria {
  Id = 'id'
}

export type SceneStatisticsOrderByInput = {
  direction: SortOrder;
  key: SceneStatisticsOrderByCriteria;
};

export type Set = {
  __typename: 'Set';
  created: Scalars['DateTime']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  galleryImage?: Maybe<DataObject>;
  id: Scalars['ID']['output'];
  jobAssignments: Array<JobAssignment>;
  jobAssignmentsCount: Scalars['Int']['output'];
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  pictures: Array<Picture>;
  project: Project;
  shareAssignments: Array<ShareAssignment>;
  shareAssignmentsCount: Scalars['Int']['output'];
  tagAssignments: Array<TagAssignment>;
  tagAssignmentsCount: Scalars['Int']['output'];
  taskInfos: TaskInfos;
  tasks: Array<Task>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type SetDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type SetJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};


export type SetPicturesArgs = {
  orderBy?: InputMaybe<Array<PictureOrderByInput>>;
};


export type SetShareAssignmentsArgs = {
  filter?: InputMaybe<ShareAssignmentFilterInput>;
  orderBy?: InputMaybe<ShareAssignmentOrderByInput>;
};


export type SetTagAssignmentsArgs = {
  tagTypes?: InputMaybe<Array<TagType>>;
};

export type SetFilterInput = {
  created?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdInFilter>;
  name?: InputMaybe<StringFilterInput>;
  number?: InputMaybe<IntFilterInput>;
  projectId?: InputMaybe<IdInFilter>;
};

export enum SetOrderByCriteria {
  ArticleId = 'articleId',
  Id = 'id',
  Name = 'name',
  NextActor = 'nextActor',
  Number = 'number',
  PaymentState = 'paymentState',
  PriorityOrder = 'priorityOrder',
  ProjectId = 'project_id',
  Public = 'public',
  State = 'state'
}

export type SetOrderByInput = {
  direction: SortOrder;
  key: SetOrderByCriteria;
};

export type ShareAssignment = {
  __typename: 'ShareAssignment';
  assignedTo?: Maybe<ShareAssignmentSubject>;
  contentTypeModel: ContentTypeModel;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  /** @deprecated Currently unused */
  permission: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  user: User;
};

export type ShareAssignmentFilterInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ShareAssignmentOrderByInput = {
  id?: InputMaybe<SortOrder>;
};

export type ShareAssignmentSubject = Asset | Hdri | Material | Model | Picture | Project | Set | Template;

export type SharingLink = {
  __typename: 'SharingLink';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  organization: Organization;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  user: User;
};

/** Membership information returned during signup flow */
export type SignupMembershipInfo = {
  __typename: 'SignupMembershipInfo';
  role: MembershipRole;
  uuid: Scalars['String']['output'];
};

/** Organization information returned during signup flow */
export type SignupOrganizationInfo = {
  __typename: 'SignupOrganizationInfo';
  name?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionStatus?: Maybe<Scalars['String']['output']>;
  trialEndsAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<OrganizationType>;
  uuid: Scalars['String']['output'];
};

/** User information returned during signup flow */
export type SignupUserInfo = {
  __typename: 'SignupUserInfo';
  email: Scalars['String']['output'];
  emailNotifications?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  has3dExperience?: Maybe<Scalars['Boolean']['output']>;
  isActive: Scalars['Boolean']['output'];
  isOnboardingCompleted: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  newsletterOptIn?: Maybe<Scalars['Boolean']['output']>;
  ssoProvider?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type StorageDeleteTask = {
  __typename: 'StorageDeleteTask';
  created: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  gcsBucketName: Scalars['String']['output'];
  gcsObjectName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type StorageDeleteTaskFilterInput = {
  created?: InputMaybe<DateTimeFilterInput>;
  gcsBucketName?: InputMaybe<StringFilterInput>;
  gcsObjectName?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdInFilter>;
};

export enum StorageDeleteTaskOrderByCriteria {
  CreatedAt = 'createdAt',
  GcsBucketName = 'gcsBucketName',
  GcsObjectName = 'gcsObjectName',
  Id = 'id',
  LegacyId = 'legacyId'
}

export type StorageDeleteTaskOrderByInput = {
  direction: SortOrder;
  key: StorageDeleteTaskOrderByCriteria;
};

export type StringFilterInput = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<StringFilterInput>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringInFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** System RAM for a task run, in MiB. */
export type SystemMemoryUsageInput = {
  /** The limit that would have killed the task (a container cap, or the machine's RAM). */
  availableMb?: InputMaybe<Scalars['Float']['input']>;
  precision: MemoryPrecision;
  /** The most system RAM in use while the task ran, measured as `precision` says. */
  usedMb: Scalars['Float']['input'];
};

export enum SystemRole {
  ArGenerationService = 'ArGenerationService',
  AssetRenderingService = 'AssetRenderingService',
  Configurator = 'Configurator',
  FileProcessingService = 'FileProcessingService',
  ImageProcessingService = 'ImageProcessingService',
  JobSystemService = 'JobSystemService',
  MaterialAi = 'MaterialAi',
  MaterialMapsExporterService = 'MaterialMapsExporterService',
  RenderingService = 'RenderingService',
  Scanner = 'Scanner',
  Staff = 'Staff',
  Superadmin = 'Superadmin',
  TilingService = 'TilingService',
  UtilityService = 'UtilityService',
  WebComponents = 'WebComponents'
}

export type Tag = {
  __typename: 'Tag';
  assignments: Array<TagAssignment>;
  assignmentsCount: Scalars['Int']['output'];
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fullWidth?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  otherInfo?: Maybe<Scalars['String']['output']>;
  overviewTemplateType?: Maybe<FabricOverviewGenerateTemplateType>;
  railroaded: Scalars['Boolean']['output'];
  repeatHeight?: Maybe<Scalars['Float']['output']>;
  repeatWidth?: Maybe<Scalars['Float']['output']>;
  type: TagType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type TagAssignmentsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type TagDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type TagJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};

export type TagAssignment = {
  __typename: 'TagAssignment';
  assignedTo?: Maybe<TagAssignmentSubject>;
  contentTypeModel: ContentTypeModel;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  tag: Tag;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type TagAssignmentFilterInput = {
  contentTypeModel?: InputMaybe<ContentTypeModel>;
  id?: InputMaybe<Scalars['ID']['input']>;
  objectId?: InputMaybe<Scalars['ID']['input']>;
  objectLegacyId?: InputMaybe<Scalars['Int']['input']>;
  tagId?: InputMaybe<IdInFilter>;
};

export enum TagAssignmentOrderByCriteria {
  CreatedAt = 'createdAt',
  Id = 'id'
}

export type TagAssignmentOrderByInput = {
  direction: SortOrder;
  key: TagAssignmentOrderByCriteria;
};

export type TagAssignmentSubject = Asset | Hdri | Material | Model | Picture | Project | Set | Template;

export type TagFilterInput = {
  createdById?: InputMaybe<IdInFilter>;
  id?: InputMaybe<IdInFilter>;
  legacyId?: InputMaybe<IntInFilter>;
  organizationId?: InputMaybe<IdInFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<Array<TagType>>;
};

export enum TagOrderByCriteria {
  Id = 'id',
  LegacyId = 'legacyId',
  MaterialRevisionId = 'materialRevisionId',
  Name = 'name'
}

export type TagOrderByInput = {
  direction: SortOrder;
  key: TagOrderByCriteria;
};

export enum TagType {
  MaterialRange = 'MaterialRange',
  PdfSpecItem = 'PdfSpecItem',
  PictureAnnotation = 'PictureAnnotation',
  ProductCategory = 'ProductCategory',
  ProductRange = 'ProductRange',
  Production = 'Production'
}

export type Task = {
  __typename: 'Task';
  assignedTo?: Maybe<TaskAssignmentSubject>;
  comments: Array<TaskComment>;
  commentsCount: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  pins: Array<TaskPin>;
  pinsCount: Scalars['Int']['output'];
  public: Scalars['Boolean']['output'];
  state: TaskState;
  taskType: TaskType;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type TaskCommentsArgs = {
  orderBy?: InputMaybe<Array<TaskCommentOrderByInput>>;
};

export type TaskAssignmentSubject = Asset | Hdri | Material | Model | Picture | Project | Set | Template;

export type TaskComment = {
  __typename: 'TaskComment';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  task: Task;
  text: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type TaskCommentFilterInput = {
  created?: InputMaybe<DateTimeFilterInput>;
  createdById?: InputMaybe<IdInFilter>;
  id?: InputMaybe<IdInFilter>;
  taskId?: InputMaybe<IdInFilter>;
  text?: InputMaybe<StringFilterInput>;
};

export enum TaskCommentOrderByCriteria {
  CreatedAt = 'createdAt',
  Id = 'id',
  LegacyId = 'legacyId',
  Text = 'text'
}

export type TaskCommentOrderByInput = {
  direction: SortOrder;
  key: TaskCommentOrderByCriteria;
};

export type TaskFilterInput = {
  commentIds?: InputMaybe<IdInFilter>;
  contentTypeModel?: InputMaybe<ContentTypeModel>;
  created?: InputMaybe<DateTimeFilterInput>;
  createdById?: InputMaybe<IdInFilter>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdInFilter>;
  number?: InputMaybe<IntFilterInput>;
  objectId?: InputMaybe<IdFilterInput>;
  objectLegacyId?: InputMaybe<Scalars['Int']['input']>;
  pinIds?: InputMaybe<IdInFilter>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Array<TaskState>>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<Array<TaskType>>;
};

export type TaskInfos = {
  __typename: 'TaskInfos';
  archived: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  inProgress: Scalars['Int']['output'];
  waitingForFeedback: Scalars['Int']['output'];
};

export enum TaskOrderByCriteria {
  Comments = 'comments',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  LegacyId = 'legacyId',
  Number = 'number',
  Public = 'public',
  Title = 'title'
}

export type TaskOrderByInput = {
  direction: SortOrder;
  key: TaskOrderByCriteria;
};

export type TaskPin = {
  __typename: 'TaskPin';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  task: Task;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type TaskPinFilterInput = {
  id?: InputMaybe<IdInFilter>;
  taskId?: InputMaybe<IdInFilter>;
  x?: InputMaybe<FloatFilterInput>;
  y?: InputMaybe<FloatFilterInput>;
};

export enum TaskPinOrderByCriteria {
  CreatedAt = 'createdAt',
  Id = 'id',
  Text = 'text'
}

export type TaskPinOrderByInput = {
  direction: SortOrder;
  key: TaskPinOrderByCriteria;
};

export enum TaskState {
  Archived = 'Archived',
  Completed = 'Completed',
  InProgress = 'InProgress',
  WaitingForFeedback = 'WaitingForFeedback'
}

export enum TaskType {
  Generic = 'Generic',
  Material = 'Material',
  Model = 'Model',
  Picture = 'Picture'
}

export type Template = {
  __typename: 'Template';
  articleId?: Maybe<Scalars['String']['output']>;
  assets: Array<Asset>;
  assetsCount: Scalars['Int']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  currentUserAssignment?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  exSceneId?: Maybe<Scalars['Int']['output']>;
  galleryImage?: Maybe<DataObject>;
  id: Scalars['ID']['output'];
  jobAssignments: Array<JobAssignment>;
  jobAssignmentsCount: Scalars['Int']['output'];
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  latestRevision?: Maybe<TemplateRevision>;
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  /** Templates that are referenced by other templates are locked. Locked templates cannot be changed from public to private, nor can their organization be changed. */
  locked: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationId: Scalars['String']['output'];
  /** @deprecated Use organizationId instead */
  organizationLegacyId: Scalars['Int']['output'];
  paymentState: PaymentState;
  picture?: Maybe<Picture>;
  public: Scalars['Boolean']['output'];
  revisions: Array<TemplateRevision>;
  revisionsCount: Scalars['Int']['output'];
  shareAssignments: Array<ShareAssignment>;
  shareAssignmentsCount: Scalars['Int']['output'];
  state: TemplateState;
  statistics: Array<SceneStatistics>;
  tagAssignments: Array<TagAssignment>;
  tagAssignmentsCount: Scalars['Int']['output'];
  tasks: Array<Task>;
  type: TemplateType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  userAssignments: Array<UserAssignment>;
  userAssignmentsCount: Scalars['Int']['output'];
};


export type TemplateDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type TemplateJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};


export type TemplateRevisionsArgs = {
  orderBy?: InputMaybe<Array<TemplateRevisionOrderByInput>>;
};


export type TemplateShareAssignmentsArgs = {
  filter?: InputMaybe<ShareAssignmentFilterInput>;
  orderBy?: InputMaybe<ShareAssignmentOrderByInput>;
};


export type TemplateTagAssignmentsArgs = {
  tagTypes?: InputMaybe<Array<TagType>>;
};


export type TemplateUserAssignmentsArgs = {
  filter?: InputMaybe<UserAssignmentFilterInput>;
};

export type TemplateFilterInput = {
  articleId?: InputMaybe<StringInFilter>;
  exSceneId?: InputMaybe<Scalars['Int']['input']>;
  hasAssignedUser?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<IdInFilter>;
  legacyId?: InputMaybe<IntInFilter>;
  organizationId?: InputMaybe<IdInFilter>;
  organizationLegacyId?: InputMaybe<IntInFilter>;
  paymentState?: InputMaybe<Array<PaymentState>>;
  pictureId?: InputMaybe<IntInFilter>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Array<TemplateState>>;
  statisticsIds?: InputMaybe<IdInFilter>;
  tagId?: InputMaybe<IdInFilter>;
  type?: InputMaybe<Array<TemplateType>>;
  userId?: InputMaybe<IdInFilter>;
};

export enum TemplateOrderByCriteria {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  Public = 'public'
}

export type TemplateOrderByInput = {
  direction: SortOrder;
  key: TemplateOrderByCriteria;
};

export type TemplateRevision = {
  __typename: 'TemplateRevision';
  arStatistics: Array<ArStatistics>;
  completed: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  exSceneRevisionId?: Maybe<Scalars['Int']['output']>;
  graph?: Maybe<Scalars['Json']['output']>;
  hdris: Array<Hdri>;
  hdrisCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Referenced materials and templates that may be inaccessible (i.e. private and in a different organization) */
  inconsistencies: Array<Scalars['DataInconsistency']['output']>;
  jobAssignments: Array<JobAssignment>;
  jobAssignmentsCount: Scalars['Int']['output'];
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  materialRevisions: Array<MaterialRevision>;
  materialRevisionsCount: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  referencedBy: Array<TemplateRevision>;
  /** Count of template revisions that reference this template revision */
  referencedByCount: Scalars['Int']['output'];
  references: Array<TemplateRevision>;
  referencesCount: Scalars['Int']['output'];
  renderJobs: Array<RenderJob>;
  /** Up to four thumbnails based on the output of assigned job tasks */
  renderedImages: Array<DataObject>;
  template?: Maybe<Template>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type TemplateRevisionDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type TemplateRevisionJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};


export type TemplateRevisionRenderedImagesArgs = {
  orderBy?: InputMaybe<JobAssignmentOrderByInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type TemplateRevisionFilterInput = {
  arStatisticsIds?: InputMaybe<IdInFilter>;
  exSceneRevisionId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<IdInFilter>;
  legacyId?: InputMaybe<IntInFilter>;
  number?: InputMaybe<Scalars['Int']['input']>;
  renderJobsIds?: InputMaybe<IdInFilter>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};

export enum TemplateRevisionOrderByCriteria {
  CreatedAt = 'createdAt',
  Id = 'id',
  Number = 'number',
  TemplateId = 'template_id'
}

export type TemplateRevisionOrderByInput = {
  direction: SortOrder;
  key: TemplateRevisionOrderByCriteria;
};

export enum TemplateState {
  Completed = 'Completed',
  Draft = 'Draft',
  InProgress = 'InProgress',
  Review = 'Review'
}

export enum TemplateType {
  Part = 'Part',
  Picture = 'Picture',
  Product = 'Product',
  Scene = 'Scene',
  System = 'System'
}

export type Texture = {
  __typename: 'Texture';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  latestRevision?: Maybe<TextureRevision>;
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  revisions: Array<TextureRevision>;
  textureSet: TextureSet;
  type: TextureType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type TextureDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type TextureJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};


export type TextureRevisionsArgs = {
  orderBy?: InputMaybe<Array<TextureRevisionOrderByInput>>;
};

/** High-level description of an edit made to multiple revisions within a texture set */
export type TextureEditGroup = {
  __typename: 'TextureEditGroup';
  assignments: Array<TextureEditGroupAssignment>;
  content?: Maybe<Scalars['Json']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  /** Are all of the originally assigned revisions still present? Returns false if at least one assigned revision has been deleted since creation of the texture edit group. */
  isComplete: Scalars['Boolean']['output'];
  latestCyclesRevision?: Maybe<TextureRevision>;
  /** The number of revisions assigned at creation time. */
  originalRevisionsCount: Scalars['Int']['output'];
  revisions: Array<TextureRevision>;
  textureSet: TextureSet;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type TextureEditGroupAssignment = {
  __typename: 'TextureEditGroupAssignment';
  editGroup: TextureEditGroup;
  revision: TextureRevision;
};

export type TextureEditGroupFilterInput = {
  id?: InputMaybe<IdInFilter>;
  textureSetId?: InputMaybe<IdInFilter>;
};

export enum TextureEditGroupOrderByCriteria {
  CreatedAt = 'createdAt',
  Id = 'id',
  Title = 'title'
}

export type TextureEditGroupOrderByInput = {
  direction: SortOrder;
  key: TextureEditGroupOrderByCriteria;
};

export type TextureFilterInput = {
  id?: InputMaybe<IdInFilter>;
  revisionId?: InputMaybe<IdInFilter>;
  textureSetId?: InputMaybe<IdInFilter>;
  type?: InputMaybe<Array<TextureType>>;
};

export type TextureGroup = {
  __typename: 'TextureGroup';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  galleryImage?: Maybe<DataObject>;
  id: Scalars['ID']['output'];
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  material?: Maybe<Material>;
  meshSpecific: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  textureSets: Array<TextureSet>;
  textureSetsCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type TextureGroupDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type TextureGroupJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};

export type TextureGroupFilterInput = {
  id?: InputMaybe<IdInFilter>;
  legacyId?: InputMaybe<IntFilterInput>;
  materialId?: InputMaybe<IdInFilter>;
  meshSpecific?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<IdInFilter>;
  organizationLegacyId?: InputMaybe<IntInFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type TextureGroupInlineCreateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  meshSpecific?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Create texture sets inline. */
  textureSets: Array<TextureSetWithRevisionsInlineCreateInput>;
};

export enum TextureGroupOrderByCriteria {
  Comment = 'comment',
  Id = 'id',
  LegacyId = 'legacyId',
  Name = 'name'
}

export type TextureGroupOrderByInput = {
  direction: SortOrder;
  key: TextureGroupOrderByCriteria;
};

export enum TextureOrderByCriteria {
  Id = 'id'
}

export type TextureOrderByInput = {
  direction: SortOrder;
  key: TextureOrderByCriteria;
};

/** A particular version of a texture. Subsequent edits will create new revisions of the same texture. */
export type TextureRevision = {
  __typename: 'TextureRevision';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  createdByVersion?: Maybe<Scalars['String']['output']>;
  dataObject: DataObject;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  displacement?: Maybe<Scalars['Float']['output']>;
  editGroups: Array<TextureEditGroup>;
  group?: Maybe<Scalars['String']['output']>;
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  number?: Maybe<Scalars['Int']['output']>;
  state: TextureRevisionState;
  texture?: Maybe<Texture>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  width: Scalars['Float']['output'];
};


/** A particular version of a texture. Subsequent edits will create new revisions of the same texture. */
export type TextureRevisionDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


/** A particular version of a texture. Subsequent edits will create new revisions of the same texture. */
export type TextureRevisionJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};

export type TextureRevisionFilterInput = {
  id?: InputMaybe<IdInFilter>;
  legacyId?: InputMaybe<IntInFilter>;
  number?: InputMaybe<IntInFilter>;
  state?: InputMaybe<Array<TextureRevisionState>>;
  textureId?: InputMaybe<IdInFilter>;
};

export enum TextureRevisionOrderByCriteria {
  Id = 'id',
  Number = 'number',
  TextureId = 'texture_id'
}

export type TextureRevisionOrderByInput = {
  direction: SortOrder;
  key: TextureRevisionOrderByCriteria;
};

export enum TextureRevisionState {
  Completed = 'Completed',
  Draft = 'Draft'
}

export type TextureSet = {
  __typename: 'TextureSet';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  derivedFromTextureSetRevision?: Maybe<TextureSetRevision>;
  derivedTextureSets: Array<TextureSet>;
  editGroups: Array<TextureEditGroup>;
  fittingSchema?: Maybe<FittingSchema>;
  id: Scalars['ID']['output'];
  jobAssignments: Array<JobAssignment>;
  jobAssignmentsCount: Scalars['Int']['output'];
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  scanJob?: Maybe<ScanJob>;
  textureGroup: TextureGroup;
  textureSetRevisions: Array<TextureSetRevision>;
  textures: Array<Texture>;
  texturesCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type TextureSetDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type TextureSetJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};


export type TextureSetTextureSetRevisionsArgs = {
  orderBy?: InputMaybe<Array<TextureSetRevisionOrderByInput>>;
};

export type TextureSetFilterInput = {
  createdById?: InputMaybe<IdInFilter>;
  id?: InputMaybe<IdInFilter>;
  scanJobId?: InputMaybe<IdInFilter>;
  textureGroupId?: InputMaybe<IdInFilter>;
};

export type TextureSetInlineCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  scanJobId?: InputMaybe<Scalars['String']['input']>;
};

export enum TextureSetOrderByCriteria {
  Id = 'id'
}

export type TextureSetOrderByInput = {
  direction: SortOrder;
  key: TextureSetOrderByCriteria;
};

/** Revision of TextureSet describing all maps of PBR set as well as their edits */
export type TextureSetRevision = {
  __typename: 'TextureSetRevision';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  displacement?: Maybe<Scalars['Float']['output']>;
  editsJson?: Maybe<Scalars['Json']['output']>;
  editsProcessingJob?: Maybe<Job>;
  eligibleForMaterialAi: Scalars['Boolean']['output'];
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  mapAssignments: Array<TextureSetRevisionMapAssignment>;
  materialRevisionReferences: Array<MaterialRevisionTextureSetReference>;
  migratedFromTextureEditGroupUuid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sourceDataObjectReferences: Array<TextureSetRevisionSourceDataObjectReference>;
  textureSet: TextureSet;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  width: Scalars['Float']['output'];
};

export type TextureSetRevisionFilterInput = {
  id?: InputMaybe<IdInFilter>;
  migratedFromTextureEditGroupId?: InputMaybe<IdInFilter>;
  textureSetId?: InputMaybe<IdInFilter>;
};

export type TextureSetRevisionInlineCreateInput = {
  displacement?: InputMaybe<Scalars['Float']['input']>;
  height: Scalars['Float']['input'];
  mapAssignments: Array<InlineTextureSetRevisionMapAssignmentInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  width: Scalars['Float']['input'];
};

/** Assignment of texture revision to texture set revision for specified texture type */
export type TextureSetRevisionMapAssignment = {
  __typename: 'TextureSetRevisionMapAssignment';
  dataObject: DataObject;
  textureSetRevision: TextureSetRevision;
  textureType: TextureType;
};

export type TextureSetRevisionMapAssignmentInput = {
  dataObjectId: Scalars['ID']['input'];
  textureType: TextureType;
};

export enum TextureSetRevisionOrderByCriteria {
  CreatedAt = 'createdAt',
  Id = 'id',
  Title = 'title'
}

export type TextureSetRevisionOrderByInput = {
  direction: SortOrder;
  key: TextureSetRevisionOrderByCriteria;
};

/** Assignment of data-object reference to texture set revision */
export type TextureSetRevisionSourceDataObjectReference = {
  __typename: 'TextureSetRevisionSourceDataObjectReference';
  dataObject: DataObject;
  textureSetRevision: TextureSetRevision;
};

export type TextureSetWithRevisionsInlineCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  scanJobId?: InputMaybe<Scalars['String']['input']>;
  /** Create texture set revisions inline. */
  textureSetRevisions?: InputMaybe<Array<TextureSetRevisionInlineCreateInput>>;
};

export enum TextureType {
  Anisotropy = 'Anisotropy',
  AnisotropyRotation = 'AnisotropyRotation',
  AnisotropyStrength = 'AnisotropyStrength',
  Diffuse = 'Diffuse',
  DiffuseRoughness = 'DiffuseRoughness',
  Displacement = 'Displacement',
  Error = 'Error',
  F0 = 'F0',
  Ior = 'Ior',
  Mask = 'Mask',
  Metalness = 'Metalness',
  Normal = 'Normal',
  Roughness = 'Roughness',
  SpecularStrength = 'SpecularStrength',
  SpecularTint = 'SpecularTint',
  Transmission = 'Transmission'
}

export type ThumbnailOptionsInput = {
  generateThumbnails?: InputMaybe<Array<ThumbnailResolutionFormatInput>>;
  generateTiles?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ThumbnailResolutionFormatInput = {
  formats: Array<DownloadFileType>;
  resolution: DownloadResolution;
};

export type TypedDataObjectInput = {
  dataObjectId?: InputMaybe<Scalars['ID']['input']>;
  dataObjectLegacyId?: InputMaybe<Scalars['Int']['input']>;
  textureType: TextureType;
};

export type User = {
  __typename: 'User';
  assetHistories: Array<AssetHistory>;
  assetHistoriesCount: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  createdUserAssignments: Array<UserAssignment>;
  createdUserAssignmentsCount: Scalars['Int']['output'];
  dataObjectAssignments: Array<DataObjectAssignment>;
  dataObjectAssignmentsCount: Scalars['Int']['output'];
  dateJoined?: Maybe<Scalars['DateTime']['output']>;
  defaultJobsPriority?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailNotifications: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  galleryImage?: Maybe<DataObject>;
  has3dExperience?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isStaff: Scalars['Boolean']['output'];
  isSuperuser: Scalars['Boolean']['output'];
  jsonFileAssignments: Array<JsonFileAssignment>;
  jsonFileAssignmentsCount: Scalars['Int']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  materialAssignmentHistories: Array<MaterialAssignmentHistory>;
  materialAssignmentHistoriesCount: Scalars['Int']['output'];
  materialHistories: Array<MaterialHistory>;
  materialHistoriesCount: Scalars['Int']['output'];
  memberships: Array<Membership>;
  modelHistories: Array<ModelHistory>;
  modelHistoriesCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  newsletterOptIn: Scalars['Boolean']['output'];
  onboardingCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  pictureAssetAssignmentHistories: Array<PictureAssetAssignmentHistory>;
  pictureAssetAssignmentHistoriesCount: Scalars['Int']['output'];
  pictureHistories: Array<PictureHistory>;
  pictureHistoriesCount: Scalars['Int']['output'];
  role?: Maybe<SystemRole>;
  selfServiceSignup?: Maybe<Scalars['Boolean']['output']>;
  shareAssignments: Array<ShareAssignment>;
  shareAssignmentsCount: Scalars['Int']['output'];
  startingScreenDismissedAt?: Maybe<Scalars['DateTime']['output']>;
  taskInfos: TaskInfos;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  userAssignmentHistories: Array<UserAssignmentHistory>;
  userAssignmentHistoriesCount: Scalars['Int']['output'];
  userAssignments: Array<UserAssignment>;
  userAssignmentsCount: Scalars['Int']['output'];
  visibleInFilters: Scalars['Boolean']['output'];
};


export type UserDataObjectAssignmentsArgs = {
  filter?: InputMaybe<DataObjectAssignmentFilterInput>;
  orderBy?: InputMaybe<DataObjectAssignmentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type UserJsonFileAssignmentsArgs = {
  filter?: InputMaybe<JsonFileAssignmentFilterInput>;
  orderBy?: InputMaybe<JsonFileAssignmentOrderByInput>;
};

export type UserAssignment = {
  __typename: 'UserAssignment';
  assignedTo?: Maybe<UserAssignmentSubject>;
  /** Currently, there is only one type of assignment: 'Generic'. */
  assignmentType: UserAssignmentType;
  contentTypeModel: ContentTypeModel;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  /** The state of the Model, Material, Asset or Picture the User is assigned to. */
  objectState?: Maybe<UserAssignmentState>;
  /** We can assign different users for each state. This is the state of the UserAssignment itself. The current assignment is the one whose state matches that of the object. */
  state?: Maybe<UserAssignmentState>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  user: User;
};

export type UserAssignmentFilterInput = {
  created?: InputMaybe<DateTimeFilterInput>;
  createdById?: InputMaybe<IdInFilter>;
  id?: InputMaybe<IdInFilter>;
  state?: InputMaybe<UserAssignmentState>;
  type?: InputMaybe<UserAssignmentType>;
  userId?: InputMaybe<IdInFilter>;
};

export type UserAssignmentHistory = {
  __typename: 'UserAssignmentHistory';
  assignment?: Maybe<UserAssignment>;
  /** Currently, there is only one type of assignment: 'Generic'. */
  assignmentType: UserAssignmentType;
  contentTypeModel?: Maybe<ContentTypeModel>;
  created: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  historyChangeReason?: Maybe<Scalars['String']['output']>;
  historyDate?: Maybe<Scalars['DateTime']['output']>;
  historyType: HistoryType;
  id: Scalars['ID']['output'];
  /** @deprecated Int-based IDs are deprecated in favor of UUIDs. Please use the `id` field instead. */
  legacyId: Scalars['Int']['output'];
  /** The state of the Model, Material, Asset or Picture at which a User is assigned to it. */
  state?: Maybe<UserAssignmentState>;
  user?: Maybe<User>;
};

export type UserAssignmentHistoryFilterInput = {
  assignmentId?: InputMaybe<IdInFilter>;
  created?: InputMaybe<DateTimeFilterInput>;
  historyChangeReason?: InputMaybe<StringFilterInput>;
  historyDate?: InputMaybe<DateTimeFilterInput>;
  historyType?: InputMaybe<Array<HistoryType>>;
  id?: InputMaybe<IdInFilter>;
  type?: InputMaybe<Array<UserAssignmentType>>;
  userId?: InputMaybe<IdInFilter>;
};

export enum UserAssignmentHistoryOrderByCriteria {
  CreatedAt = 'createdAt',
  HistoryDate = 'history_date',
  Id = 'id'
}

export type UserAssignmentHistoryOrderByInput = {
  direction: SortOrder;
  key: UserAssignmentHistoryOrderByCriteria;
};

export enum UserAssignmentOrderByCriteria {
  CreatedAt = 'createdAt',
  Id = 'id',
  Text = 'text'
}

export type UserAssignmentOrderByInput = {
  direction: SortOrder;
  key: UserAssignmentOrderByCriteria;
};

export enum UserAssignmentState {
  Completed = 'Completed',
  Draft = 'Draft',
  FinalRender = 'FinalRender',
  InfoReview = 'InfoReview',
  Modelling = 'Modelling',
  OnHold = 'OnHold',
  Review = 'Review',
  Scanning = 'Scanning',
  Shading = 'Shading',
  Stage1 = 'Stage1',
  Stage2 = 'Stage2',
  Tiling = 'Tiling'
}

export type UserAssignmentSubject = Asset | Hdri | Material | Model | Picture | Project | Set | Template;

export enum UserAssignmentType {
  Generic = 'Generic'
}

export type UserFilterInput = {
  dateJoined?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  firstName?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdInFilter>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<DateTimeFilterInput>;
  lastName?: InputMaybe<StringFilterInput>;
  legacyId?: InputMaybe<IntFilterInput>;
  onboardingCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<IdInFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  selfServiceSignup?: InputMaybe<Scalars['Boolean']['input']>;
  systemRole?: InputMaybe<SystemRole>;
  visibleInFilters?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum UserOrderByCriteria {
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  LegacyId = 'legacyId'
}

export type UserOrderByInput = {
  direction: SortOrder;
  key: UserOrderByCriteria;
};

/** Result of email verification */
export type VerifyEmailResult = {
  __typename: 'VerifyEmailResult';
  membership: SignupMembershipInfo;
  onboardingCompleted: Scalars['Boolean']['output'];
  organization: SignupOrganizationInfo;
  token: Scalars['String']['output'];
  user: SignupUserInfo;
};
